/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */


document.addEventListener('click', function(event) {
  const plusButton = event.target.closest('.cart__quantity-plus');
  const minusButton = event.target.closest('.cart__quantity-minus');
  
  if (!plusButton && !minusButton) return;
  
  const quantityCounter = event.target.closest('quantity-counter') || event.target.closest('.cart__quantity-counter');
  if (!quantityCounter) return;
  
  const inputField = quantityCounter.querySelector('.cart__quantity-field');
  if (!inputField) return;
  
  let currentValue = parseInt(inputField.value, 10) || 0;
  if (plusButton) {
    currentValue++;
  } else if (minusButton && currentValue > 1) {
    currentValue--;
  }
  
  inputField.value = currentValue;
  inputField.dispatchEvent(new Event('change', { bubbles: true }));
  inputField.dispatchEvent(new Event('blur', { bubbles: true }));
  
  // Nach einer kurzen Verzögerung wird das Formular automatisch abgesendet.
  setTimeout(function() {
    const cartForm = document.getElementById('cartForm');
    if (cartForm) {
      cartForm.submit();
    }
  }, 100);
});








! function(t, e, s) {
    "use strict";

    function i() {
        if (document.querySelector("cart-items")) return;
        const t = document.createElement("cart-items");
        document.body.appendChild(t)
    }

    function o(t) {
        t.querySelectorAll(".form-field").forEach((t => {
            const e = t.querySelector("label"),
                s = t.querySelector("input, textarea");
            e && s && (s.addEventListener("keyup", (t => {
                "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float")
            })), s.value && s.value.length && e.classList.add("label--float"))
        }))
    }! function() {
        const t = {
            NODE_ENV: "production"
        };
        try {
            if (process) return process.env = Object.assign({}, process.env), void Object.assign(process.env, t)
        } catch (t) {}
        globalThis.process = {
            env: t
        }
    }(), window.theme = window.theme || {}, window.theme.sizes = {
        mobile: 480,
        small: 750,
        large: 990,
        widescreen: 1400
    }, window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    let n = d();

    function r() {
        const t = {};
        return t.windowHeight = Math.min(window.screen.height, window.innerHeight), t.footerHeight = h('[data-section-type*="footer"]'), t.headerHeight = h("[data-header-height]"), t.stickyHeaderHeight = document.querySelector("[data-header-sticky]") ? t.headerHeight : 0, t.collectionNavHeight = h("[data-collection-nav]"), t.logoHeight = function() {
            const t = h("[data-footer-logo]");
            return t > 0 ? t + 20 : 0
        }(), t
    }

    function a() {
        document.addEventListener("theme:resize", c), l()
    }

    function l() {
        const {
            windowHeight: t,
            headerHeight: e,
            logoHeight: s,
            footerHeight: i,
            collectionNavHeight: o
        } = r();
        document.documentElement.style.setProperty("--full-height", `${t}px`), document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"), document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"), document.documentElement.style.setProperty("--one-half", t / 2 + "px"), document.documentElement.style.setProperty("--one-third", t / 3 + "px"), document.documentElement.style.setProperty("--collection-nav-height", `${o}px`), document.documentElement.style.setProperty("--header-height", `${e}px`), document.documentElement.style.setProperty("--footer-height", `${i}px`), document.documentElement.style.setProperty("--content-full", t - e - s / 2 + "px"), document.documentElement.style.setProperty("--content-min", t - e - i + "px")
    }

    function c() {
        const {
            windowHeight: t,
            headerHeight: e,
            logoHeight: s,
            footerHeight: i,
            collectionNavHeight: o
        } = r(), a = d();
        (a !== n || window.innerWidth > window.theme.sizes.mobile) && (document.documentElement.style.setProperty("--full-height", `${t}px`), document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"), document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"), document.documentElement.style.setProperty("--one-half", t / 2 + "px"), document.documentElement.style.setProperty("--one-third", t / 3 + "px"), n = a), document.documentElement.style.setProperty("--collection-nav-height", `${o}px`), document.documentElement.style.setProperty("--header-height", `${e}px`), document.documentElement.style.setProperty("--footer-height", `${i}px`), document.documentElement.style.setProperty("--content-full", t - e - s / 2 + "px"), document.documentElement.style.setProperty("--content-min", t - e - i + "px")
    }

    function d() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0
    }

    function h(t) {
        const e = document.querySelector(t);
        return e ? e.offsetHeight : 0
    }

    function u(t, e) {
        let s;
        return function() {
            if (t) {
                const i = () => t.apply(this, arguments);
                clearTimeout(s), s = setTimeout(i, e)
            }
        }
    }

    function p() {
        return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth
    }

    function m() {
        return document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight
    }

    function v() {
        return p() >= window.theme.sizes.small
    }

    function g() {
        return p() < window.theme.sizes.small
    }
    window.initialWindowHeight = Math.min(window.screen.height, window.innerHeight);
    let b = p(),
        f = m();
    let y = window.scrollY,
        w = null,
        S = null,
        E = null,
        L = null,
        k = 0;

    function A(e) {
        setTimeout((() => {
            k && clearTimeout(k), t.disablePageScroll(e.detail, {
                allowTouchMove: t => "TEXTAREA" === t.tagName
            }), document.documentElement.setAttribute("data-scroll-locked", "")
        }))
    }

    function C(t) {
        const e = t.detail;
        e ? k = setTimeout(q, e) : q()
    }

    function q() {
        t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked")
    }
    const T = (t, e = "", s) => {
        const i = s || document.createElement("div");
        return i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t)
    };

    function x(t) {
        t.querySelectorAll(".rte table").forEach((t => {
            T(t, "rte__table-wrapper"), t.setAttribute("data-scroll-lock-scrollable", "")
        }));
        t.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((t => {
            T(t, "rte__video-wrapper")
        }))
    }

    function P(t) {
        const e = t.querySelectorAll("[data-aria-toggle]");
        e.length && e.forEach((t => {
            t.addEventListener("click", (function(t) {
                t.preventDefault();
                const e = t.currentTarget;
                e.setAttribute("aria-expanded", "false" == e.getAttribute("aria-expanded") ? "true" : "false");
                const s = e.getAttribute("aria-controls"),
                    i = document.querySelector(`#${s}`),
                    o = () => {
                        i.classList.remove("expanding"), i.removeEventListener("transitionend", o)
                    },
                    n = () => {
                        i.classList.add("expanding"), i.removeEventListener("transitionstart", n)
                    };
                i.addEventListener("transitionstart", n), i.addEventListener("transitionend", o), i.classList.toggle("expanded")
            }))
        }))
    }
    const I = "is-loading",
        H = "img.is-loading";

    function O(t, e) {
        e = e || {};
        var s = t.tabIndex;
        t.tabIndex = -1, t.dataset.tabIndex = s, t.focus(), void 0 !== e.className && t.classList.add(e.className), t.addEventListener("blur", (function i(o) {
            o.target.removeEventListener(o.type, i), t.tabIndex = s, delete t.dataset.tabIndex, void 0 !== e.className && t.classList.remove(e.className)
        }))
    }

    function M(t) {
        return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled")).filter((function(t) {
            return !(!(t.offsetWidth || t.offsetHeight || t.getClientRects().length) || (e = t, s = window.getComputedStyle(e), "none" === s.display || "hidden" === s.visibility));
            var e, s
        }))
    }
    var D = {};

    function B(t, e) {
        e = e || {};
        var s = M(t),
            i = e.elementToFocus || t,
            o = s[0],
            n = s[s.length - 1];
        F(), D.focusin = function(e) {
            t !== e.target && !t.contains(e.target) && o && o === e.target && o.focus(), e.target !== t && e.target !== n && e.target !== o || document.addEventListener("keydown", D.keydown)
        }, D.focusout = function() {
            document.removeEventListener("keydown", D.keydown)
        }, D.keydown = function(e) {
            "Tab" === e.code && (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()), e.target !== t && e.target !== o || !e.shiftKey || (e.preventDefault(), n.focus()))
        }, document.addEventListener("focusout", D.focusout), document.addEventListener("focusin", D.focusin), O(i, e)
    }

    function F() {
        document.removeEventListener("focusin", D.focusin), document.removeEventListener("focusout", D.focusout), document.removeEventListener("keydown", D.keydown)
    }

    function _() {
        window.a11y.lastElement && document.body.classList.contains("is-focused") && setTimeout((() => {
            var t;
            null === (t = window.a11y.lastElement) || void 0 === t || t.focus()
        }))
    }
    var $ = Object.freeze({
        __proto__: null,
        forceFocus: O,
        focusHash: function(t) {
            t = t || {};
            var e = window.location.hash,
                s = document.getElementById(e.slice(1));
            if (s && t.ignore && s.matches(t.ignore)) return !1;
            e && s && O(s, t)
        },
        bindInPageLinks: function(t) {
            return t = t || {}, Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((function(e) {
                if ("#" === e.hash || "" === e.hash) return !1;
                if (t.ignore && e.matches(t.ignore)) return !1;
                if (s = e.hash.substr(1), null === document.getElementById(s)) return !1;
                var s, i = document.querySelector(e.hash);
                return !!i && (e.addEventListener("click", (function() {
                    O(i, t)
                })), !0)
            }))
        },
        focusable: M,
        trapFocus: B,
        removeTrapFocus: F,
        autoFocusLastElement: _,
        accessibleLinks: function(t, e) {
            if ("string" != typeof t) throw new TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (e = e || {}).messages = e.messages || {};
                var s, i, o, n = {
                        newWindow: e.messages.newWindow || "Opens in a new window.",
                        external: e.messages.external || "Opens external website.",
                        newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window."
                    },
                    r = e.prefix || "a11y",
                    a = {
                        newWindow: r + "-new-window-message",
                        external: r + "-external-message",
                        newWindowExternal: r + "-new-window-external-message"
                    };
                t.forEach((function(t) {
                    var e = t.getAttribute("target"),
                        s = t.getAttribute("rel"),
                        i = function(t) {
                            return t.hostname !== window.location.hostname
                        }(t),
                        o = "_blank" === e,
                        n = null === s || -1 === s.indexOf("noopener");
                    if (o && n) {
                        var r = null === s ? "noopener" : s + " noopener";
                        t.setAttribute("rel", r)
                    }
                    i && o ? t.setAttribute("aria-describedby", a.newWindowExternal) : i ? t.setAttribute("aria-describedby", a.external) : o && t.setAttribute("aria-describedby", a.newWindow)
                })), s = n, i = document.createElement("ul"), o = Object.keys(s).reduce((function(t, e) {
                    return t + "<li id=" + a[e] + ">" + s[e] + "</li>"
                }), ""), i.setAttribute("hidden", !0), i.innerHTML = o, document.body.appendChild(i)
            }
        }
    });

    function N(t) {
        return new Promise((e => {
            null == t || t.addEventListener("animationend", (function s(i) {
                i.target == t && (t.removeEventListener("animationend", s), e())
            }))
        }))
    }
    const R = "[data-drawer-inner]",
        W = "[data-drawer-close]",
        U = "[data-drawer-menu]",
        z = "[data-drawer-underlay]",
        V = "[data-stagger-animation]",
        j = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        J = "drawer--animated",
        X = "is-open",
        G = "is-closing",
        Q = "is-focused";
    let Y = class extends HTMLElement {
        connectDrawer() {
            this.addEventListener("theme:drawer:toggle", (t => {
                var e;
                this.triggerButton = null === (e = t.detail) || void 0 === e ? void 0 : e.button, this.classList.contains(X) ? this.dispatchEvent(new CustomEvent("theme:drawer:close", {
                    bubbles: !0
                })) : this.dispatchEvent(new CustomEvent("theme:drawer:open", {
                    bubbles: !0
                }))
            })), this.addEventListener("theme:drawer:close", this.hideDrawer), this.addEventListener("theme:drawer:open", this.showDrawer), document.addEventListener("theme:cart-drawer:open", this.hideDrawer)
        }
        closers() {
            var t;
            null === (t = this.querySelectorAll(W)) || void 0 === t || t.forEach((t => {
                t.addEventListener("click", (() => {
                    this.hideDrawer()
                }))
            })), document.addEventListener("keyup", (t => {
                "Escape" === t.code && this.hideDrawer()
            })), this.underlay.addEventListener("click", (() => {
                this.hideDrawer()
            }))
        }
        showDrawer() {
            var t;
            this.isAnimating || (this.isAnimating = !0, null === (t = this.triggerButton) || void 0 === t || t.setAttribute("aria-expanded", !0), this.classList.add(X, J), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), this.drawerInner && (F(), N(this.drawerInner).then((() => {
                this.isAnimating = !1, B(this.drawerInner, {
                    elementToFocus: this.querySelector(j)
                })
            }))))
        }
        hideDrawer() {
            !this.isAnimating && this.classList.contains(X) && (this.isAnimating = !0, this.classList.add(G), this.classList.remove(X), this.drawerMenu && (this.drawerMenu.style.height = "auto"), F(), this.triggerButton && (this.triggerButton.setAttribute("aria-expanded", !1), document.body.classList.contains(Q) && this.triggerButton.focus()), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            })), N(this.drawerInner).then((() => {
                this.classList.remove(G, J), this.isAnimating = !1, document.dispatchEvent(new CustomEvent("theme:sliderule:close", {
                    bubbles: !1
                }))
            })))
        }
        disconnectedCallback() {
            document.removeEventListener("theme:cart-drawer:open", this.hideDrawer)
        }
        constructor() {
            super(), this.isAnimating = !1, this.drawer = this, this.drawerMenu = this.querySelector(U), this.drawerInner = this.querySelector(R), this.underlay = this.querySelector(z), this.triggerButton = null, this.staggers = this.querySelectorAll(V), this.showDrawer = this.showDrawer.bind(this), this.hideDrawer = this.hideDrawer.bind(this), this.connectDrawer(), this.closers()
        }
    };
    const K = 'input[type="search"]',
        Z = '[aria-selected="true"] a',
        tt = 'button[type="reset"]',
        et = "hidden";
    let st = class extends HTMLElement {
        toggleResetButton() {
            const t = this.resetButton.classList.contains(et);
            this.input.value.length > 0 && t ? this.resetButton.classList.remove(et) : 0 !== this.input.value.length || t || this.resetButton.classList.add(et)
        }
        onChange() {
            this.toggleResetButton()
        }
        shouldResetForm() {
            return !document.querySelector(Z)
        }
        onFormReset(t) {
            t.preventDefault(), this.shouldResetForm() && (this.input.value = "", this.toggleResetButton(), t.target.querySelector(K).focus())
        }
        constructor() {
            super(), this.input = this.querySelector(K), this.resetButton = this.querySelector(tt), this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", u((t => {
                this.onChange(t)
            }), 300).bind(this)))
        }
    };
    customElements.define("header-search-form", st);
    const it = '[role="option"]',
        ot = '[aria-selected="true"]',
        nt = "[data-popular-searches]",
        rt = "predictive-search",
        at = "[data-predictive-search-results]",
        lt = "[data-predictive-search-status]",
        ct = 'input[type="search"]',
        dt = "[data-popdown]",
        ht = "[data-predictive-search-live-region-count-value]",
        ut = "[data-search-results-groups-wrapper]",
        pt = "[data-predictive-search-search-for-text]",
        mt = "#shopify-section-predictive-search",
        vt = '[aria-selected="true"] a',
        gt = '[aria-selected="true"] a, button[aria-selected="true"]';
    let bt = class extends st {
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)), this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this))
        }
        getQuery() {
            return this.input.value.trim()
        }
        onChange() {
            super.onChange();
            const t = this.getQuery();
            var e;
            this.searchTerm && t.startsWith(this.searchTerm) || (null === (e = this.querySelector(ut)) || void 0 === e || e.remove());
            this.updateSearchForTerm(this.searchTerm, t), this.searchTerm = t, this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset()
        }
        onFormSubmit(t) {
            this.getQuery().length && !this.querySelector(vt) || t.preventDefault()
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && (this.searchTerm = "", this.abortController.abort(), this.abortController = new AbortController, this.closeResults(!0))
        }
        shouldResetForm() {
            return !document.querySelector(vt)
        }
        onFocus() {
            const t = this.getQuery();
            t.length && (this.searchTerm !== t ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm))
        }
        onFocusOut() {
            setTimeout((() => {
                this.contains(document.activeElement) || this.close()
            }))
        }
        onKeyup(t) {
            switch (this.getQuery().length || this.close(!0), t.preventDefault(), t.code) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption()
            }
        }
        onKeydown(t) {
            "ArrowUp" !== t.code && "ArrowDown" !== t.code || t.preventDefault()
        }
        updateSearchForTerm(t, e) {
            const s = this.querySelector(pt),
                i = null == s ? void 0 : s.innerText;
            if (i) {
                var o;
                if ((null === (o = i.match(new RegExp(t, "g"))) || void 0 === o ? void 0 : o.length) > 1) return;
                const n = i.replace(t, e);
                s.innerText = n
            }
        }
        switchOption(t) {
            if (!this.getAttribute("open")) return;
            const e = "up" === t,
                s = this.querySelector(ot),
                i = Array.from(this.querySelectorAll(it)).filter((t => null !== t.offsetParent));
            let o = 0;
            if (e && !s) return;
            let n = -1,
                r = 0;
            for (; - 1 === n && r <= i.length;) i[r] === s && (n = r), r++;
            if (this.statusElement.textContent = "", !e && s ? o = n === i.length - 1 ? 0 : n + 1 : e && (o = 0 === n ? i.length - 1 : n - 1), o === n) return;
            const a = i[o];
            a.setAttribute("aria-selected", !0), s && s.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", a.id)
        }
        selectOption() {
            const t = this.querySelector(gt);
            t && t.click()
        }
        getSearchResults(t) {
            const e = t.replace(" ", "-").toLowerCase();
            this.setLiveRegionLoadingState(), this.cachedResults[e] ? this.renderSearchResults(this.cachedResults[e]) : fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(t)}&section_id=predictive-search`, {
                signal: this.abortController.signal
            }).then((t => {
                if (!t.ok) {
                    var e = new Error(t.status);
                    throw this.close(), e
                }
                return t.text()
            })).then((t => {
                const s = (new DOMParser).parseFromString(t, "text/html").querySelector(mt).innerHTML;
                this.allPredictiveSearchInstances.forEach((t => {
                    t.cachedResults[e] = s
                })), this.renderSearchResults(s)
            })).catch((t => {
                if (20 !== (null == t ? void 0 : t.code)) throw this.close(), t
            }))
        }
        setLiveRegionLoadingState() {
            this.statusElement = this.statusElement || this.querySelector(lt), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0)
        }
        setLiveRegionText(t) {
            this.statusElement.setAttribute("aria-hidden", "false"), this.statusElement.textContent = t, setTimeout((() => {
                this.statusElement.setAttribute("aria-hidden", "true")
            }), 1e3)
        }
        renderSearchResults(t) {
            this.predictiveSearchResults.innerHTML = t, this.setAttribute("results", !0), this.setLiveRegionResults(), this.open()
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(ht).textContent)
        }
        open() {
            this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), this.isOpen = !0, this.predictiveSearchResults.style.setProperty("--full-screen", `${window.visualViewport.height}px`)
        }
        close(t = !1) {
            this.closeResults(t), this.isOpen = !1, this.predictiveSearchResults.style.removeProperty("--full-screen")
        }
        closeResults(t = !1) {
            var e;
            t && (this.input.value = "", this.removeAttribute("results"));
            const s = this.querySelector(ot);
            s && s.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", ""), this.removeAttribute("loading"), this.removeAttribute("open"), this.input.setAttribute("aria-expanded", !1), null === (e = this.predictiveSearchResults) || void 0 === e || e.removeAttribute("style")
        }
        reset() {
            this.predictiveSearchResults.innerHTML = "", this.input.val = "", this.a11y.removeTrapFocus(), this.popularSearches && (this.input.dispatchEvent(new Event("blur", {
                bubbles: !1
            })), this.a11y.trapFocus(this.searchPopdown, {
                elementToFocus: this.input
            }))
        }
        constructor() {
            var t;
            super(), this.a11y = $, this.abortController = new AbortController, this.allPredictiveSearchInstances = document.querySelectorAll(rt), this.cachedResults = {}, this.input = this.querySelector(ct), this.isOpen = !1, this.predictiveSearchResults = this.querySelector(at), this.searchPopdown = this.closest(dt), this.popularSearches = null === (t = this.searchPopdown) || void 0 === t ? void 0 : t.querySelector(nt), this.searchTerm = ""
        }
    };
    const ft = "[data-popout-list]",
        yt = "[data-popout-toggle]",
        wt = "[data-popout-toggle-text]",
        St = "[data-popout-input]",
        Et = "[data-popout-option]",
        Lt = "[data-product-image]",
        kt = "[data-grid-item]",
        At = "popout-list--visible",
        Ct = "is-visible",
        qt = "is-active",
        Tt = "popout-list--top",
        xt = "aria-expanded",
        Pt = "aria-current",
        It = "data-value",
        Ht = "data-popout-toggle-text",
        Ot = "submit";
    let Mt = class extends HTMLElement {
        connectedCallback() {
            this.popoutList = this.querySelector(ft), this.popoutToggle = this.querySelector(yt), this.popoutToggleText = this.querySelector(wt), this.popoutInput = this.querySelector(St), this.popoutOptions = this.querySelectorAll(Et), this.productGridItem = this.popoutList.closest(kt), this.fireSubmitEvent = this.hasAttribute(Ot), this.popupToggleFocusoutEvent = t => this.onPopupToggleFocusout(t), this.popupListFocusoutEvent = t => this.onPopupListFocusout(t), this.popupToggleClickEvent = t => this.onPopupToggleClick(t), this.keyUpEvent = t => this.onKeyUp(t), this.bodyClickEvent = t => this.onBodyClick(t), this._connectOptions(), this._connectToggle(), this._onFocusOut(), this.popupListSetDimensions()
        }
        onPopupToggleClick(t) {
            const e = "true" === t.currentTarget.getAttribute(xt);
            if (this.productGridItem) {
                const t = this.productGridItem.querySelector(Lt);
                t && t.classList.toggle(Ct, !e), this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom-this.productGridItem.getBoundingClientRect().bottom)}px`
            }
            t.currentTarget.setAttribute(xt, !e), this.popoutList.classList.toggle(At), this.popupListSetDimensions(), this.toggleListPosition(), document.body.addEventListener("click", this.bodyClickEvent)
        }
        onPopupToggleFocusout(t) {
            this.contains(t.relatedTarget) || this._hideList()
        }
        onPopupListFocusout(t) {
            const e = t.currentTarget.contains(t.relatedTarget);
            this.popoutList.classList.contains(At) && !e && this._hideList()
        }
        toggleListPosition() {
            const t = "true" === this.querySelector(yt).getAttribute(xt),
                e = window.innerHeight,
                s = this.getBoundingClientRect().top,
                i = () => {
                    this.popoutList.classList.remove(Tt), this.popoutList.removeEventListener("transitionend", i)
                };
            t ? e / 2 > s && this.popoutList.classList.add(Tt) : this.popoutList.addEventListener("transitionend", i)
        }
        popupListSetDimensions() {
            this.popoutList.style.setProperty("--max-width", "100vw"), this.popoutList.style.setProperty("--max-height", "100vh"), requestAnimationFrame((() => {
                this.popoutList.style.setProperty("--max-width", `${parseInt(document.body.clientWidth-this.popoutList.getBoundingClientRect().left)}px`), this.popoutList.style.setProperty("--max-height", `${parseInt(window.innerHeight-this.popoutList.getBoundingClientRect().top)}px`)
            }))
        }
        popupOptionsClick(t) {
            if ("#" === t.target.closest(Et).attributes.href.value) {
                t.preventDefault();
                const e = t.currentTarget.hasAttribute(It) ? t.currentTarget.getAttribute(It) : "";
                if (this.popoutInput.value = e, this.popoutInput.disabled && this.popoutInput.removeAttribute("disabled"), this.fireSubmitEvent) this._submitForm(e);
                else {
                    const s = t.currentTarget.parentElement,
                        i = this.popoutList.querySelector(`.${qt}`),
                        o = this.popoutList.querySelector(`[${Pt}]`);
                    this.popoutInput.dispatchEvent(new Event("change")), i && (i.classList.remove(qt), s.classList.add(qt)), "quantity" != this.popoutInput.name || s.nextSibling || this.classList.add(qt), o && o.hasAttribute(`${Pt}`) && (o.removeAttribute(`${Pt}`), t.currentTarget.setAttribute(`${Pt}`, "true")), "" !== e && (this.popoutToggleText.innerHTML = e, this.popoutToggleText.hasAttribute(Ht) && "" !== this.popoutToggleText.getAttribute(Ht) && this.popoutToggleText.setAttribute(Ht, e)), this.onPopupToggleFocusout(t), this.onPopupListFocusout(t)
                }
            }
        }
        onKeyUp(t) {
            "Escape" === t.code && (this._hideList(), this.popoutToggle.focus())
        }
        onBodyClick(t) {
            const e = this.contains(t.target);
            this.popoutList.classList.contains(At) && !e && this._hideList()
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("click", this.popupToggleClickEvent)
        }
        _connectOptions() {
            this.popoutOptions.length && this.popoutOptions.forEach((t => {
                t.addEventListener("click", (t => this.popupOptionsClick(t)))
            }))
        }
        _onFocusOut() {
            this.addEventListener("keyup", this.keyUpEvent), this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent), this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent)
        }
        _submitForm() {
            const t = this.closest("form");
            t && t.submit()
        }
        _hideList() {
            this.popoutList.classList.remove(At), this.popoutToggle.setAttribute(xt, !1), this.toggleListPosition(), document.body.removeEventListener("click", this.bodyClickEvent)
        }
        constructor() {
            super()
        }
    };
    const Dt = "[data-aos]:not(.aos-animate)",
        Bt = "[data-aos-anchor]",
        Ft = "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
        _t = "aos-animate",
        $t = {
            attributes: !1,
            childList: !0,
            subtree: !0
        };
    let Nt = [];
    const Rt = t => {
            for (const e of t)
                if ("childList" === e.type) {
                    const t = e.target,
                        s = t.querySelectorAll(Dt),
                        i = t.querySelectorAll(Bt);
                    s.length && s.forEach((t => {
                        Wt.observe(t)
                    })), i.length && zt(i)
                }
        },
        Wt = new IntersectionObserver(((t, e) => {
            t.forEach((t => {
                t.isIntersecting && (t.target.classList.add(_t), e.unobserve(t.target))
            }))
        }), {
            root: null,
            rootMargin: "0px",
            threshold: [0, .1, .25, .5, .75, 1]
        }),
        Ut = new IntersectionObserver(((t, e) => {
            t.forEach((t => {
                if (t.intersectionRatio) {
                    const s = t.target.querySelectorAll(Dt);
                    s.length && s.forEach((t => {
                        t.classList.add(_t)
                    })), e.unobserve(t.target)
                }
            }))
        }), {
            root: null,
            rootMargin: "0px",
            threshold: [.1, .25, .5, .75, 1]
        });

    function zt(t) {
        t.length && t.forEach((t => {
            const e = t.dataset.aosAnchor;
            if (e && -1 === Nt.indexOf(e)) {
                const t = document.querySelector(e);
                t && (Ut.observe(t), Nt.push(e))
            }
        }))
    }
    const Vt = "[data-deferred-media-button]",
        jt = "video, model-viewer, iframe",
        Jt = '[data-host="youtube"]',
        Xt = '[data-host="vimeo"]',
        Gt = "[data-grid-item]",
        Qt = ".shopify-section",
        Yt = "template",
        Kt = "video",
        Zt = "product-model",
        te = "loaded",
        ee = "autoplay";
    let se = class extends HTMLElement {
        connectedCallback() {
            this.productGridItem && (this.section.addEventListener("mouseover", this.mouseOverEvent, {
                once: !0
            }), this.addEventListener("mouseenter", this.mouseEnterEvent), this.addEventListener("mouseleave", this.mouseLeaveEvent))
        }
        disconnectedCallback() {
            this.productGridItem && (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
                once: !0
            }), this.removeEventListener("mouseenter", this.mouseEnterEvent), this.removeEventListener("mouseleave", this.mouseLeaveEvent))
        }
        mouseEnterActions() {
            this.hovered = !0, this.videoActions(), this.getAttribute(te) || this.loadContent()
        }
        mouseLeaveActions() {
            this.hovered = !1, this.videoActions()
        }
        videoActions() {
            if (this.getAttribute(te)) {
                const t = this.querySelector(Jt),
                    e = this.querySelector(Xt),
                    s = t || e,
                    i = this.querySelector(Kt);
                if (s) {
                    let t = this.hovered ? "playVideo" : "pauseVideo",
                        i = `{"event":"command","func":"${t}","args":""}`;
                    e && (t = this.hovered ? "play" : "pause", i = `{"method":"${t}"}`), s.contentWindow.postMessage(i, "*"), s.addEventListener("load", (t => {
                        this.videoActions()
                    }))
                } else i && (this.hovered ? i.play() : i.pause())
            }
        }
        loadContent(t = !0) {
            if (this.pauseAllMedia(), !this.getAttribute(te)) {
                const e = document.createElement("div"),
                    s = this.querySelector(Yt).content.firstElementChild.cloneNode(!0);
                e.appendChild(s), this.setAttribute(te, !0);
                const i = this.appendChild(e.querySelector(jt));
                t && i.focus(), "VIDEO" == i.nodeName && i.getAttribute(ee) && i.play(), this.productGridItem && this.videoActions()
            }
        }
        pauseAllMedia() {
            document.querySelectorAll(Jt).forEach((t => {
                t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
            })), document.querySelectorAll(Xt).forEach((t => {
                t.contentWindow.postMessage('{"method":"pause"}', "*")
            })), document.querySelectorAll(Kt).forEach((t => t.pause())), document.querySelectorAll(Zt).forEach((t => {
                t.modelViewerUI && t.modelViewerUI.pause()
            }))
        }
        constructor() {
            super();
            const t = this.querySelector(Vt);
            null == t || t.addEventListener("click", this.loadContent.bind(this)), this.section = this.closest(Qt), this.productGridItem = this.closest(Gt), this.hovered = !1, this.mouseEnterEvent = () => this.mouseEnterActions(), this.mouseLeaveEvent = () => this.mouseLeaveActions()
        }
    };
    const ie = "is-visible";
    class oe {
        init() {
            var t;
            const e = {
                root: this.container,
                threshold: [.01, .5, .75, .99]
            };
            this.observer = new IntersectionObserver((t => {
                t.forEach((t => {
                    t.intersectionRatio >= .99 ? t.target.classList.add(ie) : t.target.classList.remove(ie)
                }))
            }), e), null === (t = this.container.querySelectorAll(this.itemSelector)) || void 0 === t || t.forEach((t => {
                this.observer.observe(t)
            }))
        }
        destroy() {
            this.observer.disconnect()
        }
        constructor(t, e) {
            t && e && (this.observer = null, this.container = t, this.itemSelector = e, this.init())
        }
    }
    const ne = "is-dragging",
        re = "is-enabled",
        ae = "is-scrolling",
        le = "is-visible",
        ce = "[data-grid-item]";
    class de {
        handleMouseDown(t) {
            t.preventDefault(), this.isDown = !0, this.startX = t.pageX - this.slider.offsetLeft, this.scrollLeft = this.slider.scrollLeft, this.cancelMomentumTracking()
        }
        handleMouseLeave() {
            this.isDown && (this.isDown = !1, this.beginMomentumTracking())
        }
        handleMouseUp() {
            this.isDown = !1, this.beginMomentumTracking()
        }
        handleMouseMove(t) {
            if (!this.isDown) return;
            t.preventDefault();
            const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
                s = this.slider.scrollLeft,
                i = e > 0 ? 1 : -1;
            this.slider.classList.add(ne, ae), this.slider.scrollLeft = this.scrollLeft - e, this.slider.scrollLeft !== s && (this.velX = this.slider.scrollLeft - s || i)
        }
        handleMouseWheel() {
            this.cancelMomentumTracking(), this.slider.classList.remove(ae)
        }
        beginMomentumTracking() {
            this.isScrolling = !1, this.slider.classList.remove(ne), this.cancelMomentumTracking(), this.scrollToSlide()
        }
        cancelMomentumTracking() {
            cancelAnimationFrame(this.scrollAnimation)
        }
        scrollToSlide() {
            if (!this.velX && !this.isScrolling) return;
            const t = this.slider.querySelector(`${ce}.${le}`);
            if (!t) return;
            const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
                s = t.offsetWidth + e,
                i = t.offsetLeft,
                o = this.velX > 0 ? 1 : -1,
                n = Math.floor(Math.abs(this.velX) / 100) || 1;
            this.startPosition = this.slider.scrollLeft, this.distance = i - this.startPosition, this.startTime = performance.now(), this.isScrolling = !0, o < 0 && this.velX < s && (this.distance -= s * n), o > 0 && this.velX < s && (this.distance += s * n), this.scrollAnimation = requestAnimationFrame(this.scrollStep)
        }
        scrollStep() {
            const t = performance.now() - this.startTime,
                e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(1);
            this.slider.scrollLeft = e, t < this.duration ? this.scrollAnimation = requestAnimationFrame(this.scrollStep) : (this.slider.classList.remove(ae), this.velX = 0, this.isScrolling = !1)
        }
        easeOutCubic(t) {
            return t /= this.duration, t--, this.distance * (t * t * t + 1) + this.startPosition
        }
        destroy() {
            this.slider.classList.remove(re), this.slider.removeEventListener("mousedown", this.handleMouseDown), this.slider.removeEventListener("mouseleave", this.handleMouseLeave), this.slider.removeEventListener("mouseup", this.handleMouseUp), this.slider.removeEventListener("mousemove", this.handleMouseMove), this.slider.removeEventListener("wheel", this.handleMouseWheel)
        }
        constructor(t) {
            this.slider = t, this.isDown = !1, this.startX = 0, this.scrollLeft = 0, this.velX = 0, this.scrollAnimation = null, this.isScrolling = !1, this.duration = 800, this.scrollStep = this.scrollStep.bind(this), this.scrollToSlide = this.scrollToSlide.bind(this), this.handleMouseDown = this.handleMouseDown.bind(this), this.handleMouseLeave = this.handleMouseLeave.bind(this), this.handleMouseUp = this.handleMouseUp.bind(this), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleMouseWheel = this.handleMouseWheel.bind(this), this.slider.addEventListener("mousedown", this.handleMouseDown), this.slider.addEventListener("mouseleave", this.handleMouseLeave), this.slider.addEventListener("mouseup", this.handleMouseUp), this.slider.addEventListener("mousemove", this.handleMouseMove), this.slider.addEventListener("wheel", this.handleMouseWheel, {
                passive: !0
            }), this.slider.classList.add(re)
        }
    }
    const he = "[data-button-arrow]",
        ue = "[data-collection-image]",
        pe = "[data-column-image]",
        me = "[data-product-image]",
        ve = "[data-grid-item]",
        ge = "[data-grid-slider]",
        be = "data-button-prev",
        fe = "data-button-next",
        ye = "align-arrows",
        we = "slider__arrows",
        Se = "is-visible",
        Ee = "scroll-snap-disabled";
    class Le extends HTMLElement {
        connectedCallback() {
            this.init(), this.addEventListener("theme:grid-slider:init", this.init)
        }
        init() {
            var t;
            this.slider = this.querySelector(ge), this.slides = this.querySelectorAll(ve), this.buttons = this.querySelectorAll(he), this.slider.classList.add(Ee), this.toggleSlider(), document.addEventListener("theme:resize:width", this.toggleSlider), (t = this, new Promise(((e, s) => {
                const i = t.querySelectorAll("[data-aos]");
                let o = 0;

                function n(t) {
                    o++, o === i.length && e(), t.target.removeEventListener("animationend", n)
                }
                i.forEach((t => {
                    t.addEventListener("animationend", n)
                })), o || s()
            }))).then((() => {
                this.slider.classList.remove(Ee)
            })).catch((() => {
                this.slider.classList.remove(Ee)
            }))
        }
        toggleSlider() {
            if (!(this.slider.clientWidth < this.getSlidesWidth()) || !v() && window.theme.touch) this.destroy();
            else {
                if (this.isInitialized) return;
                this.slidesObserver = new oe(this.slider, ve), this.initArrows(), this.isInitialized = !0, this.draggableSlider = new de(this.slider)
            }
        }
        initArrows() {
            if (!this.buttons.length) {
                const t = document.createElement("div");
                t.classList.add(we), t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next, this.append(t), this.buttons = this.querySelectorAll(he), this.buttonPrev = this.querySelector(`[${be}]`), this.buttonNext = this.querySelector(`[${fe}]`)
            }
            this.toggleArrowsObserver(), this.hasAttribute(ye) && (this.positionArrows(), this.arrowsResizeObserver()), this.buttons.forEach((t => {
                t.addEventListener("click", this.onButtonArrowClick)
            }))
        }
        buttonArrowClickEvent(t) {
            t.preventDefault();
            const e = this.slider.querySelector(`${ve}.${Se}`);
            let s = null;
            t.target.hasAttribute(be) && (s = null == e ? void 0 : e.previousElementSibling), t.target.hasAttribute(fe) && (s = null == e ? void 0 : e.nextElementSibling), this.goToSlide(s)
        }
        removeArrows() {
            var t;
            null === (t = this.querySelector(`.${we}`)) || void 0 === t || t.remove()
        }
        goToSlide(t) {
            t && this.slider.scrollTo({
                top: 0,
                left: t.offsetLeft,
                behavior: "smooth"
            })
        }
        getSlidesWidth() {
            var t;
            return (null === (t = this.slider.querySelector(ve)) || void 0 === t ? void 0 : t.clientWidth) * this.slider.querySelectorAll(ve).length
        }
        toggleArrowsObserver() {
            if (this.buttonPrev && this.buttonNext) {
                const t = this.slides.length,
                    e = this.slides[0],
                    s = this.slides[t - 1],
                    i = {
                        attributes: !0,
                        childList: !1,
                        subtree: !1
                    },
                    o = t => {
                        for (const i of t)
                            if ("attributes" === i.type) {
                                const t = i.target,
                                    o = Boolean(t.classList.contains(Se));
                                t == e && (this.buttonPrev.disabled = o), t == s && (this.buttonNext.disabled = o)
                            }
                    };
                e && s && (this.firstLastSlidesObserver = new MutationObserver(o), this.firstLastSlidesObserver.observe(e, i), this.firstLastSlidesObserver.observe(s, i))
            }
        }
        positionArrows() {
            const t = this.slider.querySelector(me) || this.slider.querySelector(ue) || this.slider.querySelector(pe) || this.slider;
            t && this.style.setProperty("--button-position", t.clientHeight / 2 + "px")
        }
        arrowsResizeObserver() {
            document.addEventListener("theme:resize:width", this.positionArrows)
        }
        disconnectedCallback() {
            this.destroy(), document.removeEventListener("theme:resize:width", this.toggleSlider)
        }
        destroy() {
            var t, e;
            this.isInitialized = !1, null === (t = this.draggableSlider) || void 0 === t || t.destroy(), this.draggableSlider = null, null === (e = this.slidesObserver) || void 0 === e || e.destroy(), this.slidesObserver = null, this.removeArrows(), document.removeEventListener("theme:resize:width", this.positionArrows)
        }
        constructor() {
            super(), this.isInitialized = !1, this.draggableSlider = null, this.positionArrows = this.positionArrows.bind(this), this.onButtonArrowClick = t => this.buttonArrowClickEvent(t), this.slidesObserver = null, this.firstLastSlidesObserver = null, this.isDragging = !1, this.toggleSlider = this.toggleSlider.bind(this)
        }
    }
    const ke = "time",
        Ae = "[data-days]",
        Ce = "[data-hours]",
        qe = "[data-minutes]",
        Te = "[data-seconds]",
        xe = ".shopify-section",
        Pe = "[data-countdown-block]",
        Ie = "[data-ticker-text]",
        He = "data-expiration-behavior",
        Oe = "data-clone",
        Me = "show-message",
        De = "hidden",
        Be = "hide-section",
        Fe = "show-message";
    let _e = class extends HTMLElement {
        connectedCallback() {
            isNaN(this.endDate) || this.endDate <= Date.now() ? this.onComplete() : (this.update(), this.interval = setInterval(this.update, 1e3))
        }
        disconnectedCallback() {
            this.stopTimer()
        }
        convertTime(t) {
            const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
            t -= e * this.daysInMs;
            const s = this.formatDigits(parseInt(t / this.hoursInMs, 10));
            t -= s * this.hoursInMs;
            const i = this.formatDigits(parseInt(t / this.minutesInMs, 10));
            t -= i * this.minutesInMs;
            return {
                days: e,
                hours: s,
                minutes: i,
                seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10))
            }
        }
        formatDigits(t) {
            return t < 10 && (t = "0" + t), t
        }
        render(t) {
            this.days.textContent = t.days, this.hours.textContent = t.hours, this.minutes.textContent = t.minutes, this.seconds.textContent = t.seconds
        }
        stopTimer() {
            clearInterval(this.interval)
        }
        onComplete() {
            var t, e;
            (this.render({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            }), this.shouldHideOnComplete) && (null === (t = this.countdownParent) || void 0 === t || t.classList.add(De), null === (e = this.countdownParent) || void 0 === e || e.dispatchEvent(new CustomEvent("theme:countdown:hide", {
                detail: {
                    element: this
                },
                bubbles: !0
            })));
            if (this.shouldShowMessage) {
                var s, i;
                if (null === (s = this.classList) || void 0 === s || s.add(Me), this.closest(Ie).hasAttribute(Oe)) return;
                null === (i = this.countdownParent) || void 0 === i || i.dispatchEvent(new CustomEvent("theme:countdown:expire", {
                    bubbles: !0
                }))
            }
        }
        update() {
            const t = (new Date).getTime(),
                e = this.endDate - t;
            e < 1e3 && (this.stopTimer(), this.onComplete());
            const s = this.convertTime(e);
            this.render(s)
        }
        constructor() {
            super(), this.section = this.closest(xe), this.countdownParent = this.closest(Pe) || this.section, this.expirationBehavior = this.getAttribute(He), this.time = this.querySelector(ke), this.days = this.querySelector(Ae), this.hours = this.querySelector(Ce), this.minutes = this.querySelector(qe), this.seconds = this.querySelector(Te), this.endDate = Date.parse(this.time.dateTime), this.daysInMs = 864e5, this.hoursInMs = this.daysInMs / 24, this.minutesInMs = this.hoursInMs / 60, this.secondsInMs = this.minutesInMs / 60, this.shouldHideOnComplete = this.expirationBehavior === Be, this.shouldShowMessage = this.expirationBehavior === Fe, this.update = this.update.bind(this)
        }
    };
    const $e = {
            animates: "data-animates",
            drawerMenu: "[data-drawer-menu]",
            links: "[data-links]",
            sliderule: "[data-sliderule]",
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            drawerContent: "[data-drawer-content]",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * > [data-animates],\n             :scope > * > .sliderule-grid  > *"
        },
        Ne = "is-open",
        Re = "is-visible",
        We = "is-hiding",
        Ue = "is-hidden",
        ze = "is-focused",
        Ve = "is-scrolling",
        je = "data-sliderule";
    let Je = class extends HTMLElement {
        clickEvents() {
            this.trigger.addEventListener("click", (() => {
                this.cachedButton = this.trigger, this.showSliderule()
            })), this.exit.forEach((t => {
                t.addEventListener("click", (() => {
                    this.hideSliderule()
                }))
            }))
        }
        keyboardEvents() {
            this.addEventListener("keyup", (t => {
                t.stopPropagation(), "Escape" === t.code && this.hideSliderule()
            }))
        }
        trapFocusSliderule(t = !0) {
            const e = t ? this.querySelector(this.exitSelector) : this.cachedButton;
            this.accessibility.removeTrapFocus(), e && this.drawerContent && this.accessibility.trapFocus(this.drawerContent, {
                elementToFocus: document.body.classList.contains(ze) ? e : null
            })
        }
        hideSliderule(t = !1) {
            const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
            this.pane.setAttribute($e.sliderulePane, e), this.pane.classList.add(We), this.sliderule.classList.add(We);
            const s = t ? `[${$e.animates}].${Ue}` : `[${$e.animates}="${e}"]`,
                i = this.pane.querySelectorAll(s);
            i.length && i.forEach((t => {
                t.classList.remove(Ue)
            }));
            const o = this.closest("header-drawer").classList.contains(Ne);
            if (e > 0 && o) {
                const t = this.sliderule.closest(`[${je}="${e}"]`).querySelector($e.links).scrollHeight;
                setTimeout((() => {
                    this.drawerMenu.style.height = `${t}px`
                }), 500)
            } else setTimeout((() => {
                this.drawerMenu.style.height = "auto"
            }), 500);
            const n = t ? this.pane.querySelectorAll(`.${Re}, .${We}`) : this.childrenElements;
            n.forEach(((s, i) => {
                const o = n.length - 1 == i;
                s.classList.remove(Re), t && (s.classList.remove(We), this.pane.classList.remove(We));
                const r = () => {
                    parseInt(this.pane.getAttribute($e.sliderulePane)) === e && this.sliderule.classList.remove(Re), this.sliderule.classList.remove(We), this.pane.classList.remove(We), o && (this.accessibility.removeTrapFocus(), t || this.trapFocusSliderule(!1)), s.removeEventListener("animationend", r)
                };
                window.theme.settings.enableAnimations ? s.addEventListener("animationend", r) : r()
            }))
        }
        showSliderule() {
            let t = null;
            const e = this.closest(`.${Re}`);
            let s = this.pane;
            e && (s = e), s.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            }), s.classList.add(Ve);
            const i = () => {
                s.scrollTop <= 0 ? (s.classList.remove(Ve), t && cancelAnimationFrame(t)) : t = requestAnimationFrame(i)
            };
            t = requestAnimationFrame(i);
            const o = parseInt(this.pane.dataset.sliderulePane, 10),
                n = o + 1;
            if (this.sliderule.classList.add(Re), this.pane.setAttribute($e.sliderulePane, n), n > 0) {
                const t = this.sliderule.scrollHeight;
                this.drawerMenu.style.height = `${t}px`
            }
            const r = this.pane.querySelectorAll(`[${$e.animates}="${o}"]`);
            r.length && r.forEach(((t, e) => {
                const s = r.length - 1 == e;
                t.classList.add(We);
                const i = () => {
                    t.classList.remove(We), parseInt(this.pane.getAttribute($e.sliderulePane)) !== o && t.classList.add(Ue), s && this.trapFocusSliderule(), t.removeEventListener("animationend", i)
                };
                window.theme.settings.enableAnimations ? t.addEventListener("animationend", i) : i()
            }))
        }
        closeSliderule() {
            this.pane && this.pane.hasAttribute($e.sliderulePane) && parseInt(this.pane.getAttribute($e.sliderulePane)) > 0 && (this.hideSliderule(!0), parseInt(this.pane.getAttribute($e.sliderulePane)) > 0 && this.pane.setAttribute($e.sliderulePane, 0))
        }
        disconnectedCallback() {
            document.removeEventListener("theme:sliderule:close", this.closeSliderule)
        }
        constructor() {
            super(), this.key = this.id, this.drawerMenu = this.closest($e.drawerMenu), this.sliderule = this.querySelector($e.sliderule);
            const t = `[${$e.slideruleOpen}='${this.key}']`;
            this.exitSelector = `[${$e.slideruleClose}='${this.key}']`, this.trigger = this.querySelector(t), this.exit = document.querySelectorAll(this.exitSelector), this.pane = this.trigger.closest(`[${$e.sliderulePane}]`), this.childrenElements = this.querySelectorAll($e.children), this.drawerContent = this.closest($e.drawerContent), this.cachedButton = null, this.accessibility = $, this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.closeSliderule = this.closeSliderule.bind(this), this.clickEvents(), this.keyboardEvents(), document.addEventListener("theme:sliderule:close", this.closeSliderule)
        }
    };
    window.requestIdleCallback = window.requestIdleCallback || function(t) {
            var e = Date.now();
            return setTimeout((function() {
                t({
                    didTimeout: !1,
                    timeRemaining: function() {
                        return Math.max(0, 50 - (Date.now() - e))
                    }
                })
            }), 1)
        }, window.cancelIdleCallback = window.cancelIdleCallback || function(t) {
            clearTimeout(t)
        }, window.theme.settings.enableAnimations && (! function() {
            const t = document.querySelectorAll(Ft);
            t.length && t.forEach((t => {
                Wt.observe(t)
            }))
        }(), function() {
            const t = document.querySelectorAll(Bt);
            t.length && zt(t)
        }(), new MutationObserver(Rt).observe(document.body, $t), document.addEventListener("shopify:section:unload", (t => {
            var e;
            const s = "#" + (null === (e = t.target.querySelector("[data-section-id]")) || void 0 === e ? void 0 : e.id),
                i = Nt.indexOf(s); - 1 !== i && Nt.splice(i, 1)
        }))), window.addEventListener("resize", u((function() {
            document.dispatchEvent(new CustomEvent("theme:resize", {
                bubbles: !0
            })), b !== p() && (document.dispatchEvent(new CustomEvent("theme:resize:width", {
                bubbles: !0
            })), b = p()), f !== m() && (document.dispatchEvent(new CustomEvent("theme:resize:height", {
                bubbles: !0
            })), f = m())
        }), 50)),
        function() {
            let t;
            window.addEventListener("scroll", (function() {
                t && window.cancelAnimationFrame(t), t = window.requestAnimationFrame((function() {
                    ! function() {
                        const t = window.scrollY;
                        t > y ? (S = !0, w = !1) : t < y ? (S = !1, w = !0) : (w = null, S = null), y = t, document.dispatchEvent(new CustomEvent("theme:scroll", {
                            detail: {
                                up: w,
                                down: S,
                                position: t
                            },
                            bubbles: !1
                        })), w && !E && document.dispatchEvent(new CustomEvent("theme:scroll:up", {
                            detail: {
                                position: t
                            },
                            bubbles: !1
                        })), S && !L && document.dispatchEvent(new CustomEvent("theme:scroll:down", {
                            detail: {
                                position: t
                            },
                            bubbles: !1
                        })), L = S, E = w
                    }()
                }))
            }), {
                passive: !0
            }), window.addEventListener("theme:scroll:lock", A), window.addEventListener("theme:scroll:unlock", C)
        }(), "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? (document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch"), window.theme.touch = !0) : window.theme.touch = !1, l(), document.addEventListener("load", (t => {
            "img" == t.target.tagName.toLowerCase() && t.target.classList.contains(I) && (t.target.classList.remove(I), t.target.parentNode.classList.remove(I), t.target.parentNode.parentNode.classList.contains(I) && t.target.parentNode.parentNode.classList.remove(I))
        }), !0), window.addEventListener("DOMContentLoaded", (() => {
            a(), P(document), o(document), x(document), document.querySelectorAll(H).forEach((t => {
                t.complete && (t.classList.remove(I), t.parentNode.classList.remove(I), t.parentNode.parentNode.classList.contains(I) && t.parentNode.parentNode.classList.remove(I))
            })), document.body.classList.add("is-loaded"), i(), requestIdleCallback((() => {
                Shopify.visualPreviewMode && document.documentElement.classList.add("preview-mode")
            }))
        })), document.addEventListener("shopify:section:load", (t => {
            const e = t.target;
            o(e), x(e), P(document), a()
        })), customElements.get("header-drawer") || customElements.define("header-drawer", Y), customElements.get("mobile-sliderule") || customElements.define("mobile-sliderule", Je), customElements.get("popout-select") || customElements.define("popout-select", Mt), customElements.get("predictive-search") || customElements.define("predictive-search", bt), customElements.get("deferred-media") || customElements.define("deferred-media", se), customElements.get("grid-slider") || customElements.define("grid-slider", Le), customElements.get("countdown-timer") || customElements.define("countdown-timer", _e), Shopify.Products = function() {
            const t = {
                howManyToShow: 4,
                howManyToStoreInMemory: 10,
                wrapperId: "recently-viewed-products",
                section: null,
                target: "api-product-grid-item",
                onComplete: null
            };
            let e = [],
                s = null,
                i = null;
            const o = new Date,
                n = new Date;
            n.setTime(o.getTime() + 7776e6);
            const r = {
                    configuration: {
                        expires: n.toGMTString(),
                        path: "/",
                        domain: window.location.hostname,
                        sameSite: "none",
                        secure: !0
                    },
                    name: "shopify_recently_viewed",
                    write: function(t) {
                        const e = encodeURIComponent(t.join(" "));
                        document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`
                    },
                    read: function() {
                        let t = [],
                            e = null;
                        return -1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t => t.startsWith(this.name))) && (e = document.cookie.split("; ").find((t => t.startsWith(this.name))).split("=")[1]), null !== e && (t = decodeURIComponent(e).split(" ")), t
                    },
                    destroy: function() {
                        document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`
                    },
                    remove: function(t) {
                        const e = this.read(),
                            s = e.indexOf(t); - 1 !== s && (e.splice(s, 1), this.write(e))
                    }
                },
                a = (e, s, o, n, l, c) => {
                    s.length && e < c ? fetch(`${window.theme.routes.root}products/${s[0]}?section_id=${l}`).then((t => t.text())).then((t => {
                        const i = 100 * e,
                            r = o.id ? `#${o.id}` : "",
                            d = document.createElement("div");
                        let h = t;
                        h = h.includes("||itemAnimationDelay||") ? h.replaceAll("||itemAnimationDelay||", i) : h, h = h.includes("||itemAnimationAnchor||") ? h.replaceAll("||itemAnimationAnchor||", r) : h, d.innerHTML = h, o.innerHTML += d.querySelector("[data-api-content]").innerHTML, s.shift(), e++, a(e, s, o, n, l, c)
                    })).catch((() => {
                        r.remove(s[0]), s.shift(), a(e, s, o, n, l, c)
                    })) : ((e, s) => {
                        e.classList.remove("hidden");
                        const o = r.read().length;
                        if (Shopify.recentlyViewed && i && o && o < i && e.children.length) {
                            let t = [],
                                s = [],
                                i = 0;
                            for (const e in Shopify.recentlyViewed) {
                                i += 1;
                                const o = Shopify.recentlyViewed[e].split(" "),
                                    n = parseInt(e.split("_")[1]);
                                t = [...t, ...o], (r.read().length === n || i === Object.keys(Shopify.recentlyViewed).length && !s.length) && (s = [...s, ...o])
                            }
                            for (let i = 0; i < e.children.length; i++) {
                                const o = e.children[i];
                                t.length && o.classList.remove(...t), s.length && o.classList.add(...s)
                            }
                        }
                        if (t.onComplete) try {
                            t.onComplete(e, s)
                        } catch (t) {
                            console.log(t)
                        }
                    })(o, n)
                };
            return {
                showRecentlyViewed: function(o) {
                    const n = o || {};
                    Object.assign(t, n), e = r.read(), s = document.querySelector(`#${t.wrapperId}`), i = t.howManyToShow, t.howManyToShow = Math.min(e.length, t.howManyToShow), t.howManyToShow && s && a(0, e, s, t.section, t.target, i)
                },
                getConfig: function() {
                    return t
                },
                clearList: function() {
                    r.destroy()
                },
                recordRecentlyViewed: function(e) {
                    const s = e || {};
                    Object.assign(t, s);
                    let i = r.read();
                    if (-1 !== window.location.pathname.indexOf("/products/")) {
                        let e = decodeURIComponent(window.location.pathname).match(/\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/)[0].split("/products/")[1];
                        t.handle && (e = t.handle);
                        const s = i.indexOf(e); - 1 === s ? (i.unshift(e), i = i.splice(0, t.howManyToStoreInMemory)) : (i.splice(s, 1), i.unshift(e)), r.write(i)
                    }
                },
                hasProducts: r.read().length > 0
            }
        }();
    const Xe = "is-focused",
        Ge = "[data-skip-content]",
        Qe = 'a[href="#"]';
    window.a11y = new class {
        init() {
            this.a11y = $, this.html = document.documentElement, this.body = document.body, this.inPageLink = document.querySelector(Ge), this.linkesWithOnlyHash = document.querySelectorAll(Qe), this.a11y.focusHash(), this.a11y.bindInPageLinks(), this.clickEvents(), this.focusEvents()
        }
        clickEvents() {
            this.inPageLink && this.inPageLink.addEventListener("click", (t => {
                t.preventDefault()
            })), this.linkesWithOnlyHash && this.linkesWithOnlyHash.forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault()
                }))
            }))
        }
        focusEvents() {
            document.addEventListener("mousedown", (() => {
                this.body.classList.remove(Xe)
            })), document.addEventListener("keyup", (t => {
                "Tab" === t.code && this.body.classList.add(Xe)
            }))
        }
        constructor() {
            this.init()
        }
    };

    function Ye(t, e) {
        "string" == typeof t && (t = t.replace(".", ""));
        let s = "";
        const i = /\{\{\s*(\w+)\s*\}\}/,
            o = e || "${{amount}}";

        function n(t, e = 2, s = ",", i = ".") {
            if (isNaN(t) || null == t) return 0;
            const o = (t = (t / 100).toFixed(e)).split(".");
            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${s}`) + (o[1] ? i + o[1] : "")
        }
        switch (o.match(i)[1]) {
            case "amount":
                s = n(t, 2);
                break;
            case "amount_no_decimals":
                s = n(t, 0);
                break;
            case "amount_with_comma_separator":
                s = n(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                s = n(t, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                s = n(t, 2, "'", ".");
                break;
            case "amount_no_decimals_with_space_separator":
                s = n(t, 0, " ", "");
                break;
            case "amount_with_space_separator":
                s = n(t, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                s = n(t, 2, " ", ".")
        }
        return o.replace(i, s)
    }
    const Ke = (t, e) => {
        let s, i;
        return function o(...n) {
            const r = Date.now();
            i = clearTimeout(i), !s || r - s >= e ? (t.apply(null, n), s = r) : i = setTimeout(o.bind(null, ...n), e - (r - s))
        }
    };

    function Ze(t) {
        this.status = t.status || null, this.headers = t.headers || null, this.json = t.json || null, this.body = t.body || null
    }
    Ze.prototype = Error.prototype;
    const ts = "is-animated",
        es = "is-added",
        ss = "is-disabled",
        is = "is-empty",
        os = "is-hidden",
        ns = "is-hiding",
        rs = "is-loading",
        as = "is-open",
        ls = "is-removed",
        cs = "is-success",
        ds = "is-visible",
        hs = "is-expanded",
        us = "is-updated",
        ps = "variant--soldout",
        ms = "variant--unavailable",
        vs = "[data-api-content]",
        gs = "[data-api-line-items]",
        bs = "[data-api-upsell-items]",
        fs = "[data-api-cart-price]",
        ys = "[data-animation]",
        ws = "[data-skip-upsell-product]",
        Ss = "[data-add-to-cart-bar]",
        Es = "[data-cart-error-close]",
        Ls = "cart-drawer",
        ks = "[data-cart-drawer-close]",
        As = "[data-cart-empty]",
        Cs = "[data-cart-errors]",
        qs = "[data-item-remove]",
        Ts = "[data-cart-page]",
        xs = "[data-cart-form]",
        Ps = "[data-cart-acceptance-checkbox]",
        Is = "[data-cart-checkout-buttons]",
        Hs = "[data-cart-checkout-button]",
        Os = "[data-cart-total]",
        Ms = "[data-checkout-buttons]",
        Ds = "[data-error-message]",
        Bs = "[data-close-error]",
        Fs = "[data-cart-errors-container]",
        _s = "[data-form-wrapper]",
        $s = "[data-free-shipping]",
        Ns = "[data-progress-graph]",
        Rs = "[data-progress-bar]",
        Ws = "[data-header-wrapper]",
        Us = "[data-item]",
        zs = "[data-items-holder]",
        Vs = "[data-left-to-spend]",
        js = "[data-drawer]",
        Js = "[data-section-id]",
        Xs = "[data-cart-price-holder]",
        Gs = "[data-quick-add-holder]",
        Qs = "[data-quick-add-modal]",
        Ys = 'input[name="updates[]"]',
        Ks = "[data-upsell-products]",
        Zs = "[data-upsell-widget]",
        ti = "[data-terms-error-message]",
        ei = "[data-collapsible-body]",
        si = "recently-viewed-products-cart",
        ii = "noscript",
        oi = "data-cart-total",
        ni = "disabled",
        ri = "data-free-shipping",
        ai = "data-free-shipping-limit",
        li = "data-item",
        ci = "data-item-index",
        di = "data-item-title",
        hi = "open",
        ui = "data-quick-add-holder",
        pi = "data-scroll-locked",
        mi = "data-upsell-auto-open",
        vi = "name";
    let gi = class extends HTMLElement {
        connectedCallback() {
            this.cartPage = document.querySelector(Ts), this.cartForm = document.querySelector(xs), this.cartDrawer = document.querySelector(Ls), this.cartEmpty = document.querySelector(As), this.cartTermsCheckbox = document.querySelector(Ps), this.cartCheckoutButtonWrapper = document.querySelector(Is), this.cartCheckoutButton = document.querySelector(Hs), this.checkoutButtons = document.querySelector(Ms), this.itemsHolder = document.querySelector(zs), this.priceHolder = document.querySelector(Xs), this.items = document.querySelectorAll(Us), this.cartTotal = document.querySelector(Os), this.freeShipping = document.querySelectorAll($s), this.cartErrorHolder = document.querySelector(Cs), this.cartCloseErrorMessage = document.querySelector(Es), this.headerWrapper = document.querySelector(Ws), this.navDrawer = document.querySelector(js), this.upsellProductsHolder = document.querySelector(Ks), this.subtotal = window.theme.subtotal, this.cart = this.cartDrawer || this.cartPage, this.animateItems = this.animateItems.bind(this), this.addToCart = this.addToCart.bind(this), this.cartAddEvent = this.cartAddEvent.bind(this), this.updateProgress = this.updateProgress.bind(this), this.onCartDrawerClose = this.onCartDrawerClose.bind(this), document.addEventListener("theme:cart:add", this.cartAddEvent), document.addEventListener("theme:announcement:init", this.updateProgress), "drawer" == theme.settings.cartType && (document.addEventListener("theme:cart-drawer:open", this.animateItems), document.addEventListener("theme:cart-drawer:close", this.onCartDrawerClose)), this.skipUpsellProductsArray = [], this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility(), this.circumference = 28 * Math.PI, this.freeShippingLimit = this.freeShipping.length ? 100 * Number(this.freeShipping[0].getAttribute(ai)) * window.Shopify.currency.rate : 0, this.freeShippingMessageHandle(this.subtotal), this.updateProgress(), this.build = this.build.bind(this), this.updateCart = this.updateCart.bind(this), this.productAddCallback = this.productAddCallback.bind(this), this.formSubmitHandler = Ke(this.formSubmitHandler.bind(this), 50), this.cartPage && this.animateItems(), this.cart && (this.recentlyViewedProducts(), this.hasItemsInCart = this.hasItemsInCart.bind(this), this.cartCount = this.getCartItemCount()), this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this), this.totalItems = this.items.length, this.cartUpdateFailed = !1, this.cartEvents(), this.cartRemoveEvents(), this.cartUpdateEvents(), document.addEventListener("theme:product:add", this.productAddCallback), document.addEventListener("theme:product:add-error", this.productAddCallback), document.addEventListener("theme:cart:refresh", this.getCart.bind(this)), document.dispatchEvent(new CustomEvent("theme:cart:load", {
                bubbles: !0
            }))
        }
        disconnectedCallback() {
            document.removeEventListener("theme:cart:add", this.cartAddEvent), document.removeEventListener("theme:cart:refresh", this.cartAddEvent), document.removeEventListener("theme:announcement:init", this.updateProgress), document.removeEventListener("theme:product:add", this.productAddCallback), document.removeEventListener("theme:product:add-error", this.productAddCallback), document.dispatchEvent(new CustomEvent("theme:cart:unload", {
                bubbles: !0
            })), document.documentElement.hasAttribute(pi) && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))
        }
        onCartDrawerClose() {
            var t;
            this.resetAnimatedItems(), (null === (t = this.cartDrawer) || void 0 === t ? void 0 : t.classList.contains(as)) && this.cart.classList.remove(us), this.cartEmpty.classList.remove(us), this.cartErrorHolder.classList.remove(hs), this.cart.querySelectorAll(ys).forEach((t => {
                const e = () => {
                    t.classList.remove(ns), t.removeEventListener("animationend", e)
                };
                t.classList.add(ns), t.addEventListener("animationend", e)
            }))
        }
        cartUpdateEvents() {
            this.items = document.querySelectorAll(Us), this.items.forEach((t => {
                t.addEventListener("theme:cart:update", (e => {
                    this.updateCart({
                        id: e.detail.id,
                        quantity: e.detail.quantity
                    }, t)
                }))
            }))
        }
        cartRemoveEvents() {
            document.querySelectorAll(qs).forEach((t => {
                const e = t.closest(Us);
                t.addEventListener("click", (s => {
                    s.preventDefault(), t.classList.contains(ss) || this.updateCart({
                        id: t.dataset.id,
                        quantity: 0
                    }, e)
                }))
            })), this.cartCloseErrorMessage && this.cartCloseErrorMessage.addEventListener("click", (t => {
                t.preventDefault(), this.cartErrorHolder.classList.remove(hs)
            }))
        }
        cartAddEvent(t) {
            let e = "",
                s = t.detail.button;
            if (s.hasAttribute("disabled")) return;
            const i = s.closest("form");
            if (!i.checkValidity()) return void i.reportValidity();
            e = new FormData(i);
            [...i.elements].some((t => t.closest(ii))) && (e = this.handleFormDataDuplicates([...i.elements], e)), null !== i && i.querySelector('[type="file"]') || ("drawer" === theme.settings.cartType && this.cartDrawer && t.preventDefault(), this.addToCart(e, s))
        }
        handleFormDataDuplicates(t, e) {
            return t.length && "object" == typeof e ? (t.forEach((t => {
                if (t.closest(ii)) {
                    const s = t.getAttribute(vi),
                        i = t.value;
                    if (s) {
                        const t = e.getAll(s);
                        t.length > 1 && t.splice(t.indexOf(i), 1), e.delete(s), e.set(s, t[0])
                    }
                }
            })), e) : e
        }
        cartEvents() {
            this.cartTermsCheckbox && (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler), this.cartForm.removeEventListener("submit", this.formSubmitHandler), this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler), this.cartForm.addEventListener("submit", this.formSubmitHandler))
        }
        formSubmitHandler() {
            const t = document.querySelector(Ps).checked,
                e = document.querySelector(ti);
            if (t) e.classList.remove(hs), this.cartCheckoutButton.removeAttribute(ni);
            else {
                if (document.querySelector(ti).length > 0) return;
                e.innerText = theme.strings.cartAcceptanceError, this.cartCheckoutButton.setAttribute(ni, !0), e.classList.add(hs)
            }
        }
        formErrorsEvents(t) {
            const e = t.querySelector(Bs);
            null == e || e.addEventListener("click", (e => {
                e.preventDefault(), t && t.classList.remove(ds)
            }))
        }
        getCart() {
            fetch(theme.routes.cart_url + "?section_id=api-cart-items").then(this.cartErrorsHandler).then((t => t.text())).then((t => {
                const e = document.createElement("div");
                e.innerHTML = t;
                const s = e.querySelector(vs);
                this.build(s)
            })).catch((t => console.log(t)))
        }
        addToCart(t, e) {
            this.cart && this.cart.classList.add(rs);
            const s = null == e ? void 0 : e.closest(Gs);
            e && (e.classList.add(rs), e.disabled = !0), s && s.classList.add(ds), fetch(theme.routes.cart_add_url, {
                method: "POST",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    Accept: "application/javascript"
                },
                body: t
            }).then((t => t.json())).then((t => {
                if (t.status) return this.addToCartError(t, e), void(e && (e.classList.remove(rs), e.disabled = !1));
                this.cart ? (e && (e.classList.remove(rs), e.classList.add(es), e.dispatchEvent(new CustomEvent("theme:product:add", {
                    detail: {
                        response: t,
                        button: e
                    },
                    bubbles: !0
                }))), "page" === theme.settings.cartType && (window.location = theme.routes.cart_url), this.getCart()) : window.location = theme.routes.cart_url
            })).catch((t => {
                this.addToCartError(t, e), this.enableCartButtons()
            }))
        }
        updateCart(t = {}, e = null) {
            this.cart.classList.add(rs);
            let s = t.quantity;
            null !== e && (s ? e.classList.add(rs) : e.classList.add(ls)), this.disableCartButtons();
            const i = this.cart.querySelector(`[${li}="${t.id}"]`) || e,
                o = (null == i ? void 0 : i.hasAttribute(ci)) ? parseInt(i.getAttribute(ci)) : 0,
                n = (null == i ? void 0 : i.hasAttribute(di)) ? i.getAttribute(di) : null;
            if (0 === o) return;
            const r = {
                line: o,
                quantity: s
            };
            fetch(theme.routes.cart_change_url, {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify(r)
            }).then((t => t.text())).then((t => {
                if (JSON.parse(t).errors) return this.cartUpdateFailed = !0, this.updateErrorText(n), this.toggleErrorMessage(), this.resetLineItem(e), void this.enableCartButtons();
                this.getCart()
            })).catch((t => {
                console.log(t), this.enableCartButtons()
            }))
        }
        resetLineItem(t) {
            const e = t.querySelector(Ys),
                s = e.getAttribute("value");
            e.value = s, t.classList.remove(rs)
        }
        disableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${qs}`);
            t.length && t.forEach((t => {
                t.classList.add(ss), t.blur(), t.disabled = !0
            })), e.length && e.forEach((t => {
                t.setAttribute(ni, !0)
            }))
        }
        enableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${qs}`);
            t.length && t.forEach((t => {
                t.classList.remove(ss), t.disabled = !1
            })), e.length && e.forEach((t => {
                t.removeAttribute(ni)
            })), this.cart.classList.remove(rs)
        }
        updateErrorText(t) {
            this.cartErrorHolder.querySelector(Ds).innerText = t
        }
        toggleErrorMessage() {
            this.cartErrorHolder && (this.cartErrorHolder.classList.toggle(hs, this.cartUpdateFailed), this.cartUpdateFailed = !1)
        }
        cartErrorsHandler(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new Ze({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        addToCartError(t, e) {
            var s;
            if (null !== e) {
                const s = e.closest(Js) || e.closest(Gs) || e.closest(Qs);
                let i = null == s ? void 0 : s.querySelector(Fs);
                const o = e.closest(Gs);
                if (o && o.querySelector(Fs) && (i = o.querySelector(Fs)), i) {
                    let e = `${t.message}: ${t.description}`;
                    t.message == t.description && (e = t.message), i.innerHTML = `<div class="errors">${e}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`, i.classList.add(ds), this.formErrorsEvents(i)
                }
                e.dispatchEvent(new CustomEvent("theme:product:add-error", {
                    detail: {
                        response: t,
                        button: e
                    },
                    bubbles: !0
                }))
            }
            const i = null == e ? void 0 : e.closest(Gs);
            i && i.dispatchEvent(new CustomEvent("theme:cart:error", {
                bubbles: !0,
                detail: {
                    message: t.message,
                    description: t.description,
                    holder: i
                }
            })), null === (s = this.cart) || void 0 === s || s.classList.remove(rs)
        }
        productAddCallback(t) {
            let e = [],
                s = null;
            const i = "theme:product:add-error" == t.type,
                o = t.detail.button,
                n = document.querySelector(Ss);
            e.push(o), s = o.closest(Gs), n && e.push(n), e.forEach((t => {
                t.classList.remove(rs), i || t.classList.add(es)
            })), setTimeout((() => {
                e.forEach((t => {
                    var e, s;
                    t.classList.remove(es);
                    (null === (e = t.closest(_s)) || void 0 === e ? void 0 : e.classList.contains(ps)) || (null === (s = t.closest(_s)) || void 0 === s ? void 0 : s.classList.contains(ms)) || (t.disabled = !1)
                })), null == s || s.classList.remove(ds)
            }), 1e3)
        }
        toggleClassesOnContainers() {
            const t = this.hasItemsInCart();
            this.cart.classList.toggle(is, !t), !t && this.cartDrawer && setTimeout((() => {
                B(this.cartDrawer, {
                    elementToFocus: this.cartDrawer.querySelector(ks)
                })
            }), 100)
        }
        build(t) {
            var e;
            const s = t.querySelector(gs),
                i = t.querySelector(bs),
                o = Boolean(null === s && null === i),
                n = t.querySelector(fs),
                r = t.querySelector(Os);
            this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML), o ? (this.itemsHolder.innerHTML = t.innerHTML, this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = "")) : (this.itemsHolder.innerHTML = s.innerHTML, this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = i.innerHTML), this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility()), this.newTotalItems = s && s.querySelectorAll(Us).length ? s.querySelectorAll(Us).length : 0, this.subtotal = r && r.hasAttribute(oi) ? parseInt(r.getAttribute(oi)) : 0, this.cartCount = this.getCartItemCount(), document.dispatchEvent(new CustomEvent("theme:cart:change", {
                bubbles: !0,
                detail: {
                    cartCount: this.cartCount
                }
            })), this.cartTotal.innerHTML = 0 === this.subtotal ? window.theme.strings.free : Ye(this.subtotal, theme.moneyWithCurrencyFormat), this.totalItems !== this.newTotalItems && (this.totalItems = this.newTotalItems, this.toggleClassesOnContainers()), (null === (e = this.cartDrawer) || void 0 === e ? void 0 : e.classList.contains(as)) && this.cart.classList.add(us), this.cart.classList.remove(rs), this.hasItemsInCart() || this.cartEmpty.querySelectorAll(ys).forEach((t => {
                t.classList.remove(ts)
            })), this.freeShippingMessageHandle(this.subtotal), this.cartRemoveEvents(), this.cartUpdateEvents(), this.toggleErrorMessage(), this.enableCartButtons(), this.updateProgress(), this.animateItems(), document.dispatchEvent(new CustomEvent("theme:product:added", {
                bubbles: !0
            }))
        }
        getCartItemCount() {
            return Array.from(this.cart.querySelectorAll(Ys)).reduce(((t, e) => t + parseInt(e.value)), 0)
        }
        hasItemsInCart() {
            return this.totalItems > 0
        }
        freeShippingMessageHandle(t) {
            this.freeShipping.length && this.freeShipping.forEach((e => {
                const s = e.hasAttribute(ri) && "true" === e.getAttribute(ri) && t >= 0;
                e.classList.toggle(cs, s && t >= this.freeShippingLimit)
            }))
        }
        updateProgress() {
            if (this.freeShipping = document.querySelectorAll($s), !this.freeShipping.length) return;
            const t = isNaN(this.subtotal / this.freeShippingLimit) ? 100 : this.subtotal / this.freeShippingLimit,
                e = Math.min(100 * t, 100),
                s = this.circumference - e / 100 * this.circumference / 2,
                i = Ye(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
            this.freeShipping.forEach((t => {
                const o = t.querySelector(Rs),
                    n = t.querySelector(Ns),
                    r = t.querySelector(Vs);
                r && (r.innerHTML = i.replace(".00", "")), o && (o.value = e), n && n.style.setProperty("--stroke-dashoffset", `${s}`)
            }))
        }
        skipUpsellProductEvent() {
            if (null === this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelectorAll(ws);
            t.length && t.forEach((t => {
                t.addEventListener("click", (e => {
                    e.preventDefault();
                    const s = t.closest(Gs).getAttribute(ui);
                    this.skipUpsellProductsArray.includes(s) || this.skipUpsellProductsArray.push(s), window.sessionStorage.setItem("skip_upsell_products", this.skipUpsellProductsArray), this.removeUpsellProduct(s), this.toggleCartUpsellWidgetVisibility()
                }))
            }))
        }
        checkSkippedUpsellProductsFromStorage() {
            const t = window.sessionStorage.getItem("skip_upsell_products");
            if (!t) return;
            t.split(",").forEach((t => {
                this.skipUpsellProductsArray.includes(t) || this.skipUpsellProductsArray.push(t), this.removeUpsellProduct(t)
            }))
        }
        removeUpsellProduct(t) {
            if (!this.upsellProductsHolder) return;
            const e = this.upsellProductsHolder.querySelector(`[${ui}="${t}"]`);
            e && e.parentNode.remove()
        }
        toggleCartUpsellWidgetVisibility() {
            if (!this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelectorAll(Gs),
                e = this.upsellProductsHolder.closest(Zs);
            if (e && (e.classList.toggle(os, !t.length), t.length && !e.hasAttribute(hi) && e.hasAttribute(mi))) {
                e.setAttribute(hi, !0);
                const t = e.querySelector(ei);
                t && (t.style.height = "auto")
            }
        }
        resetAnimatedItems() {
            this.cart.querySelectorAll(ys).forEach((t => {
                t.classList.remove(ts), t.classList.remove(ns)
            }))
        }
        animateItems(t) {
            requestAnimationFrame((() => {
                let e = this.cart;
                t && t.detail && t.detail.target && (e = t.detail.target), null == e || e.querySelectorAll(ys).forEach((t => {
                    t.classList.add(ts)
                }))
            }))
        }
        recentlyViewedProducts() {
            this.cart.querySelector(`#${si}`) && Shopify.Products.showRecentlyViewed({
                howManyToShow: 3,
                wrapperId: si,
                section: this,
                target: "api-upsell-product"
            })
        }
        constructor() {
            super()
        }
    };
    customElements.get("cart-items") || customElements.define("cart-items", gi);
    const bi = "data-cart-count",
        fi = "data-limit";
    let yi = class extends HTMLElement {
        connectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback)
        }
        disconnectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback)
        }
        onCartChange(t) {
            this.cartCount = t.detail.cartCount, this.update()
        }
        update() {
            if (null !== this.cartCount) {
                this.setAttribute(bi, this.cartCount);
                let t = this.cartCount;
                this.limit && this.cartCount >= this.limit && (t = "9+"), this.innerText = t
            }
        }
        constructor() {
            super(), this.cartCount = null, this.limit = this.getAttribute(fi), this.onCartChangeCallback = this.onCartChange.bind(this)
        }
    };
    customElements.get("cart-count") || customElements.define("cart-count", yi);
    const wi = "is-open",
        Si = "is-closing",
        Ei = "drawer--duplicate",
        Li = "drawer-editor-error",
        ki = {
            cartDrawer: "cart-drawer",
            cartDrawerClose: "[data-cart-drawer-close]",
            cartDrawerSection: '[data-section-type="cart-drawer"]',
            cartDrawerInner: "[data-cart-drawer-inner]",
            shopifySection: ".shopify-section"
        },
        Ai = "data-drawer-underlay";
    let Ci = class extends HTMLElement {
        connectedCallback() {
            const t = this.closest(ki.shopifySection);
            if (window.theme.hasCartDrawer) {
                if (!window.Shopify.designMode) return void t.remove();
                {
                    const t = document.createElement("div");
                    t.classList.add(Li), t.innerText = "Cart drawer section already exists.", this.querySelector(`.${Li}`) || this.querySelector(ki.cartDrawerInner).append(t), this.classList.add(Ei)
                }
            }
            window.theme.hasCartDrawer = !0, this.addEventListener("theme:cart-drawer:show", this.openCartDrawer), document.addEventListener("theme:cart:toggle", this.toggleCartDrawer), document.addEventListener("theme:quick-add:open", this.closeCartDrawer), document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded), document.addEventListener("shopify:block:select", this.openCartDrawerOnSelect), document.addEventListener("shopify:section:select", this.openCartDrawerOnSelect), document.addEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:added", this.openCartDrawerOnProductAdded), document.removeEventListener("theme:cart:toggle", this.toggleCartDrawer), document.removeEventListener("theme:quick-add:open", this.closeCartDrawer), document.removeEventListener("shopify:block:select", this.openCartDrawerOnSelect), document.removeEventListener("shopify:section:select", this.openCartDrawerOnSelect), document.removeEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect), document.querySelectorAll(ki.cartDrawer).length <= 1 && (window.theme.hasCartDrawer = !1), i()
        }
        openCartDrawerOnProductAdded() {
            this.cartDrawerIsOpen || this.openCartDrawer()
        }
        openCartDrawerOnSelect(t) {
            (t.target.querySelector(ki.shopifySection) || t.target.closest(ki.shopifySection) || t.target) === this.cartDrawerSection && this.openCartDrawer(!0)
        }
        closeCartDrawerOnDeselect() {
            this.cartDrawerIsOpen && this.closeCartDrawer()
        }
        openCartDrawer(t = !1) {
            !t && this.classList.contains(Ei) || (this.cartDrawerIsOpen = !0, this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), document.body.addEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:cart-drawer:open", {
                detail: {
                    target: this
                },
                bubbles: !0
            })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), this.classList.add(wi), this.observeAdditionalCheckoutButtons(), N(this.cartDrawerInner).then((() => {
                B(this, {
                    elementToFocus: this.querySelector(ki.cartDrawerClose)
                })
            })))
        }
        closeCartDrawer() {
            this.classList.contains(wi) && (this.classList.add(Si), this.classList.remove(wi), this.cartDrawerIsOpen = !1, document.dispatchEvent(new CustomEvent("theme:cart-drawer:close", {
                bubbles: !0
            })), F(), _(), document.body.removeEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            })), N(this.cartDrawerInner).then((() => {
                this.classList.remove(Si)
            })))
        }
        toggleCartDrawer() {
            this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer()
        }
        closeCartEvents() {
            this.cartDrawerClose.addEventListener("click", (t => {
                t.preventDefault(), this.closeCartDrawer()
            })), this.addEventListener("keyup", (t => {
                "Escape" === t.code && this.closeCartDrawer()
            }))
        }
        onBodyClick(t) {
            t.target.hasAttribute(Ai) && this.closeCartDrawer()
        }
        observeAdditionalCheckoutButtons() {
            const t = this.querySelector(ki.additionalCheckoutButtons);
            if (t) {
                const e = new MutationObserver((() => {
                    B(this, {
                        elementToFocus: this.querySelector(ki.cartDrawerClose)
                    }), e.disconnect()
                }));
                e.observe(t, {
                    subtree: !0,
                    childList: !0
                })
            }
        }
        constructor() {
            super(), this.cartDrawerIsOpen = !1, this.cartDrawerClose = this.querySelector(ki.cartDrawerClose), this.cartDrawerInner = this.querySelector(ki.cartDrawerInner), this.openCartDrawer = this.openCartDrawer.bind(this), this.closeCartDrawer = this.closeCartDrawer.bind(this), this.toggleCartDrawer = this.toggleCartDrawer.bind(this), this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this), this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this), this.closeCartDrawerOnDeselect = this.closeCartDrawerOnDeselect.bind(this), this.cartDrawerSection = this.closest(ki.shopifySection), this.closeCartEvents()
        }
    };
    customElements.get("cart-drawer") || customElements.define("cart-drawer", Ci);
    const qi = "[data-collapsible]",
        Ti = "[data-collapsible-trigger]",
        xi = "[data-collapsible-body]",
        Pi = "[data-collapsible-content]",
        Ii = "desktop",
        Hi = "disabled",
        Oi = "mobile",
        Mi = "open",
        Di = "single";
    let Bi = class extends HTMLElement {
        connectedCallback() {
            this.toggle(), document.addEventListener("theme:resize:width", this.toggle), this.collapsibles.forEach((t => {
                const e = t.querySelector(Ti),
                    s = t.querySelector(xi);
                null == e || e.addEventListener("click", (t => this.onCollapsibleClick(t))), null == s || s.addEventListener("transitionend", (e => {
                    e.target === s && ("true" == t.getAttribute(Mi) && this.setBodyHeight(s, "auto"), "false" == t.getAttribute(Mi) && (t.removeAttribute(Mi), this.setBodyHeight(s, "")))
                }))
            }))
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.toggle)
        }
        toggle() {
            const t = v();
            this.collapsibles.forEach((e => {
                if (!e.hasAttribute(Ii) && !e.hasAttribute(Oi)) return;
                const s = e.hasAttribute(Ii) ? e.getAttribute(Ii) : "true",
                    i = e.hasAttribute(Oi) ? e.getAttribute(Oi) : "true",
                    o = t && "true" == s || !t && "true" == i,
                    n = e.querySelector(xi);
                o ? (e.removeAttribute(Hi), e.querySelector(Ti).removeAttribute("tabindex"), e.removeAttribute(Mi), this.setBodyHeight(n, "")) : (e.setAttribute(Hi, ""), e.setAttribute("open", !0), e.querySelector(Ti).setAttribute("tabindex", -1))
            }))
        }
        open(t) {
            if ("true" == t.getAttribute("open")) return;
            const e = t.querySelector(xi),
                s = t.querySelector(Pi);
            t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight)
        }
        close(t) {
            if (!t.hasAttribute("open")) return;
            const e = t.querySelector(xi),
                s = t.querySelector(Pi);
            this.setBodyHeight(e, s.offsetHeight), t.setAttribute("open", !1), setTimeout((() => {
                requestAnimationFrame((() => {
                    this.setBodyHeight(e, 0)
                }))
            }))
        }
        setBodyHeight(t, e) {
            t.style.height = "auto" !== e && "" !== e ? `${e}px` : e
        }
        onCollapsibleClick(t) {
            t.preventDefault();
            const e = t.target.closest(qi);
            this.single && this.collapsibles.forEach((t => {
                t.hasAttribute(Mi) && t != e && requestAnimationFrame((() => {
                    this.close(t)
                }))
            })), e.hasAttribute(Mi) ? this.close(e) : this.open(e), e.dispatchEvent(new CustomEvent("theme:form:sticky", {
                bubbles: !0,
                detail: {
                    element: "accordion"
                }
            })), e.dispatchEvent(new CustomEvent("theme:collapsible:toggle", {
                bubbles: !0
            }))
        }
        constructor() {
            super(), this.collapsibles = this.querySelectorAll(qi), this.single = this.hasAttribute(Di), this.toggle = this.toggle.bind(this)
        }
    };
    customElements.get("collapsible-elements") || customElements.define("collapsible-elements", Bi);
    const Fi = "details",
        _i = "[data-popdown]",
        $i = "[data-popdown-close]",
        Ni = 'input:not([type="hidden"])',
        Ri = "mobile-menu",
        Wi = "data-popdown-underlay",
        Ui = "data-scroll-locked",
        zi = "is-open";
    let Vi = class extends HTMLElement {
        connectedCallback() {
            this.popdown.addEventListener("transitionend", this.popdownTransitionCallback), this.popdownContainer.addEventListener("keyup", (t => "ESCAPE" === t.code.toUpperCase() && this.close())), this.popdownContainer.addEventListener("toggle", this.detailsToggleCallback), this.popdownClose.addEventListener("click", this.close.bind(this))
        }
        detailsToggleCallback(t) {
            t.target.hasAttribute("open") && this.open()
        }
        popdownTransitionCallback(t) {
            t.target === this.popdown && (this.classList.contains(zi) ? "transform" !== t.propertyName && "opacity" !== t.propertyName || this.a11y.trapFocus(this.popdown, {
                elementToFocus: this.popdown.querySelector(Ni)
            }) : (this.popdownContainer.removeAttribute("open"), this.a11y.removeTrapFocus()))
        }
        onBodyClick(t) {
            this.contains(t.target) && !t.target.hasAttribute(Wi) || this.close()
        }
        open() {
            var t;
            this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), document.body.addEventListener("click", this.onBodyClickEvent), null === (t = this.mobileMenu) || void 0 === t || t.dispatchEvent(new CustomEvent("theme:search:open")), document.documentElement.hasAttribute(Ui) || document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), requestAnimationFrame((() => {
                this.classList.add(zi)
            }))
        }
        close() {
            var t;
            this.classList.remove(zi), null === (t = this.mobileMenu) || void 0 === t || t.dispatchEvent(new CustomEvent("theme:search:close")), document.body.removeEventListener("click", this.onBodyClickEvent), this.mobileMenu || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))
        }
        constructor() {
            super(), this.popdown = this.querySelector(_i), this.popdownContainer = this.querySelector(Fi), this.popdownClose = this.querySelector($i), this.popdownTransitionCallback = this.popdownTransitionCallback.bind(this), this.detailsToggleCallback = this.detailsToggleCallback.bind(this), this.mobileMenu = this.closest(Ri), this.a11y = $
        }
    };
    customElements.define("header-search-popdown", Vi);
    const ji = 'input[type="search"]';
    customElements.define("main-search", class extends st {
        setupEventListeners() {
            let t = [];
            this.allSearchInputs.forEach((e => t.push(e.form))), this.input.addEventListener("focus", this.onInputFocus.bind(this)), t.length < 2 || (t.forEach((t => t.addEventListener("reset", this.onFormReset.bind(this)))), this.allSearchInputs.forEach((t => t.addEventListener("input", this.onInput.bind(this)))))
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && this.keepInSync("", this.input)
        }
        onInput(t) {
            const e = t.target;
            this.keepInSync(e.value, e)
        }
        onInputFocus() {
            v() || this.scrollIntoView({
                behavior: "smooth"
            })
        }
        keepInSync(t, e) {
            this.allSearchInputs.forEach((s => {
                s !== e && (s.value = t)
            }))
        }
        constructor() {
            super(), this.allSearchInputs = document.querySelectorAll(ji), this.setupEventListeners()
        }
    });
    const Ji = "[data-actions]",
        Xi = "[data-content]",
        Gi = "[data-button]",
        Qi = "data-height",
        Yi = "is-open",
        Ki = "is-enabled";
    let Zi = class extends HTMLElement {
        connectedCallback() {
            this.setHeight(this.initialHeight), this.trigger.addEventListener("click", (() => {
                this.setHeight(this.content.offsetHeight), this.classList.add(Yi)
            })), this.setHeight(this.initialHeight), this.toggleActions(), document.addEventListener("theme:resize", this.toggleActions), document.addEventListener("theme:collapsible:toggle", this.toggleActions)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.toggleActions), document.removeEventListener("theme:collapsible:toggle", this.toggleActions)
        }
        setHeight(t) {
            this.style.setProperty("--height", `${t}px`)
        }
        toggleActions() {
            this.classList.toggle(Ki, this.content.offsetHeight + this.actions.offsetHeight > this.initialHeight)
        }
        constructor() {
            super(), this.initialHeight = this.getAttribute(Qi), this.content = this.querySelector(Xi), this.trigger = this.querySelector(Gi), this.actions = this.querySelector(Ji), this.toggleActions = this.toggleActions.bind(this)
        }
    };
    customElements.get("toggle-ellipsis") || customElements.define("toggle-ellipsis", Zi), window.Shopify = window.Shopify || {}, window.Shopify.theme = window.Shopify.theme || {}, window.Shopify.theme.sections = window.Shopify.theme.sections || {}, window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}, window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    const to = window.Shopify.theme.sections.registered,
        eo = window.Shopify.theme.sections.instances,
        so = "data-section-id",
        io = "data-section-type";
    let oo = class {
        callFunctions(t, e = null) {
            this.callStack[t].forEach((t => {
                const s = {
                    id: this.id,
                    type: this.type,
                    container: this.container
                };
                e ? t.call(s, e) : t.call(s)
            }))
        }
        onLoad() {
            this.callFunctions("onLoad")
        }
        onUnload() {
            this.callFunctions("onUnload")
        }
        onSelect(t) {
            this.callFunctions("onSelect", t)
        }
        onDeselect(t) {
            this.callFunctions("onDeselect", t)
        }
        onBlockSelect(t) {
            this.callFunctions("onBlockSelect", t)
        }
        onBlockDeselect(t) {
            this.callFunctions("onBlockDeselect", t)
        }
        onReorder(t) {
            this.callFunctions("onReorder", t)
        }
        constructor(t, e) {
            this.container = function(t) {
                if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === t.getAttribute(so)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + so + " attribute.");
                return t
            }(t), this.id = t.getAttribute(so), this.type = e.type, this.callStack = e.getStack();
            try {
                this.onLoad()
            } catch (t) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t)
            }
        }
    };

    function no(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== to[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const s = new class {
            getStack() {
                return this.callStack
            }
            constructor(t = null, e = []) {
                this.type = t, this.components = function(t) {
                    if (void 0 !== t && "object" != typeof t || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                    return t
                }(e), this.callStack = {
                    onLoad: [],
                    onUnload: [],
                    onSelect: [],
                    onDeselect: [],
                    onBlockSelect: [],
                    onBlockDeselect: [],
                    onReorder: []
                }, e.forEach((t => {
                    for (const [e, s] of Object.entries(t)) {
                        const t = this.callStack[e];
                        Array.isArray(t) && "function" == typeof s ? t.push(s) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(s))
                    }
                }))
            }
        }(t, e);
        return to[t] = s, to
    }

    function ro(t, e) {
        t = co(t), void 0 === e && (e = document.querySelectorAll("[" + io + "]")), e = ho(e), t.forEach((function(t) {
            const s = to[t];
            void 0 !== s && (e = e.filter((function(e) {
                return !(ao(e).length > 0) && (null !== e.getAttribute(io) && (e.getAttribute(io) !== t || (eo.push(new oo(e, s)), !1)))
            })))
        }))
    }

    function ao(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var s = t[0];
        if (t instanceof Element || s instanceof Element) ho(t).forEach((function(t) {
            e = e.concat(eo.filter((function(e) {
                return e.container === t
            })))
        }));
        else if ("string" == typeof t || "string" == typeof s) {
            co(t).forEach((function(t) {
                e = e.concat(eo.filter((function(e) {
                    return e.type === t
                })))
            }))
        }
        return e
    }

    function lo(t) {
        for (var e, s = 0; s < eo.length; s++)
            if (eo[s].id === t) {
                e = eo[s];
                break
            } return e
    }

    function co(t) {
        return "*" === t ? t = Object.keys(to) : "string" == typeof t ? t = [t] : t.constructor === oo ? t = [t.prototype.type] : Array.isArray(t) && t[0].constructor === oo && (t = t.map((function(t) {
            return t.type
        }))), t = t.map((function(t) {
            return t.toLowerCase()
        }))
    }

    function ho(t) {
        return NodeList.prototype.isPrototypeOf(t) && t.length > 0 ? t = Array.prototype.slice.call(t) : NodeList.prototype.isPrototypeOf(t) && 0 === t.length || null === t ? t = [] : !Array.isArray(t) && t instanceof Element && (t = [t]), t
    }
    window.Shopify.designMode && (document.addEventListener("shopify:section:load", (function(t) {
        var e = t.detail.sectionId,
            s = t.target.querySelector("[" + so + '="' + e + '"]');
        null !== s && ro(s.getAttribute(io), s)
    })), document.addEventListener("shopify:section:reorder", (function(t) {
        var e = t.detail.sectionId,
            s = t.target.querySelector("[" + so + '="' + e + '"]');
        "object" == typeof ao(s)[0] && ao(s).forEach((function(t) {
            t.onReorder()
        }))
    })), document.addEventListener("shopify:section:unload", (function(t) {
        var e = t.detail.sectionId,
            s = t.target.querySelector("[" + so + '="' + e + '"]');
        "object" == typeof ao(s)[0] && ao(s).forEach((function(t) {
            var e = eo.map((function(t) {
                return t.id
            })).indexOf(t.id);
            eo.splice(e, 1), t.onUnload()
        }))
    })), document.addEventListener("shopify:section:select", (function(t) {
        var e = lo(t.detail.sectionId);
        "object" == typeof e && e.onSelect(t)
    })), document.addEventListener("shopify:section:deselect", (function(t) {
        var e = lo(t.detail.sectionId);
        "object" == typeof e && e.onDeselect(t)
    })), document.addEventListener("shopify:block:select", (function(t) {
        var e = lo(t.detail.sectionId);
        "object" == typeof e && e.onBlockSelect(t)
    })), document.addEventListener("shopify:block:deselect", (function(t) {
        var e = lo(t.detail.sectionId);
        "object" == typeof e && e.onBlockDeselect(t)
    })));
    const uo = "[data-section-id]",
        po = "data-tooltip",
        mo = "data-tooltip-stop-mouseenter",
        vo = "tooltip-default",
        go = "is-visible",
        bo = "is-hiding";
    let fo = {},
        yo = class {
            init() {
                if (!document.querySelector(`.${this.class}`)) {
                    const t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
                        e = document.createElement("div");
                    e.className = this.class, e.innerHTML = t, document.body.appendChild(e)
                }
                this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent), document.addEventListener("theme:tooltip:close", this.removePinEvent)
            }
            addPin(t = !1) {
                const e = document.querySelector(`.${this.class}`),
                    s = this.tooltip.closest(uo),
                    i = Array.from(s.classList).find((t => t.startsWith("color-scheme-")));
                if (null == e || e.classList.add(i), this.label && e && (t && !this.tooltip.hasAttribute(mo) || !t)) {
                    const t = e.querySelector(`.${this.class}__arrow`),
                        s = e.querySelector(`.${this.class}__inner`);
                    e.querySelector(`.${this.class}__text`).innerHTML = this.label;
                    const i = s.offsetWidth,
                        o = this.tooltip.getBoundingClientRect(),
                        n = o.top,
                        r = o.width,
                        a = n + o.height + window.scrollY;
                    let l = o.left - i / 2 + r / 2;
                    const c = 24,
                        d = l + i - p() + c;
                    d > 0 && (l -= d), l < 0 && (l = 0), t.style.left = `${o.left+r/2}px`, e.style.setProperty("--tooltip-top", `${a}px`), s.style.transform = `translateX(${l}px)`, e.classList.remove(bo), e.classList.add(go), document.addEventListener("theme:scroll", this.removePinEvent)
                }
            }
            removePin(t, e = !1, s = !1) {
                const i = document.querySelector(`.${this.class}`),
                    o = i.classList.contains(go);
                i && (e && !this.tooltip.hasAttribute(mo) || !e) && (o && (s || t.detail.hideTransition) && (i.classList.add(bo), this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout), this.hideTransitionTimeout = setTimeout((() => {
                    i.classList.remove(bo)
                }), this.transitionSpeed)), i.classList.remove(go), document.removeEventListener("theme:scroll", this.removePinEvent))
            }
            unload() {
                this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent), document.removeEventListener("theme:tooltip:close", this.removePinEvent), document.removeEventListener("theme:scroll", this.removePinEvent)
            }
            constructor(t, e = {}) {
                this.tooltip = t, this.tooltip.hasAttribute(po) && (this.label = this.tooltip.getAttribute(po), this.class = e.class || vo, this.transitionSpeed = e.transitionSpeed || 200, this.hideTransitionTimeout = 0, this.addPinEvent = () => this.addPin(), this.addPinMouseEvent = () => this.addPin(!0), this.removePinEvent = t => Ke(this.removePin(t), 50), this.removePinMouseEvent = t => this.removePin(t, !0, !0), this.init())
            }
        };
    const wo = {
        onLoad() {
            fo[this.id] = [];
            this.container.querySelectorAll(`[${po}]`).forEach((t => {
                fo[this.id].push(new yo(t))
            }))
        },
        onUnload: function() {
            fo[this.id].forEach((t => {
                "function" == typeof t.unload && t.unload()
            }))
        }
    };
    no("article", [wo]);
    const So = "[data-aos]",
        Eo = ".collection-item__image",
        Lo = "[data-column-image]",
        ko = ".flickity-button.next",
        Ao = ".flickity-button.previous",
        Co = "a:not(.btn)",
        qo = ".product-item__image",
        To = "[data-slide]",
        xo = "data-slide",
        Po = "[data-slider]",
        Io = "[data-slider-thumb]",
        Ho = "data-arrow-position-middle",
        Oo = "data-slide-index",
        Mo = "data-options",
        Do = "data-slide-text-color",
        Bo = "aos-animate",
        Fo = "desktop",
        _o = "is-focused",
        $o = "flickity-enabled",
        No = "is-initialized",
        Ro = "is-loading",
        Wo = "is-selected",
        Uo = "mobile",
        zo = "single-slide",
        Vo = {};
    let jo = class {
        init() {
            this.slideshow.classList.add(Ro);
            let t = To;
            const i = v(),
                o = `${To}:not(.${Uo})`,
                n = `${To}:not(.${Fo})`;
            (this.slideshow.querySelectorAll(n).length || this.slideshow.querySelectorAll(o).length) && (t = i ? o : n), this.slideshow.querySelectorAll(t).length <= 1 && (this.slideshow.classList.add(zo), this.slideshow.classList.remove(Ro)), this.sliderOptions = {
                cellSelector: t,
                contain: !0,
                wrapAround: !0,
                adaptiveHeight: !0,
                ...this.customOptions,
                on: {
                    ready: () => {
                        requestAnimationFrame((() => {
                            this.slideshow.classList.add(No), this.slideshow.classList.remove(Ro), this.slideshow.parentNode.dispatchEvent(new CustomEvent("theme:slider:loaded", {
                                bubbles: !0,
                                detail: {
                                    slider: this
                                }
                            }))
                        })), this.slideActions(), this.sliderOptions.prevNextButtons && this.positionArrows()
                    },
                    change: t => {
                        const e = this.slideshowSlides[t];
                        if (!e || this.sliderOptions.groupCells) return;
                        const s = e.querySelectorAll(So);
                        s.length && s.forEach((t => {
                            t.classList.remove(Bo), requestAnimationFrame((() => {
                                setTimeout((() => {
                                    t.classList.add(Bo)
                                }), 0)
                            }))
                        }))
                    },
                    resize: () => {
                        this.sliderOptions.prevNextButtons && this.positionArrows()
                    }
                }
            }, this.sliderOptions.fade && (this.flkty = new s(this.slideshow, this.sliderOptions)), this.sliderOptions.fade || (this.flkty = new e(this.slideshow, this.sliderOptions)), this.flkty.on("change", (() => this.slideActions(!0))), this.sliderThumbs.length && this.sliderThumbs.forEach((t => {
                t.addEventListener("click", (e => {
                    e.preventDefault();
                    const s = [...t.parentElement.children].indexOf(t);
                    this.flkty.select(s)
                }))
            })), this.flkty && this.flkty.isActive || this.slideshow.classList.remove(Ro)
        }
        slideActions(t = !1) {
            const e = this.slideshow.querySelector(`.${Wo}`);
            if (!e) return;
            const s = e.hasAttribute(Do) ? e.getAttribute(Do) : "",
                i = e.querySelector(Co),
                o = this.slideshow.querySelectorAll(`${To} a, ${To} button`);
            if (document.body.classList.contains(_o) && i && this.sliderOptions.groupCells && t && i.focus(), o.length && o.forEach((t => {
                    const e = t.closest(To);
                    if (e) {
                        const s = e.classList.contains(Wo) ? 0 : -1;
                        t.setAttribute("tabindex", s)
                    }
                })), this.slideshow.style.setProperty("--text", s), this.sliderThumbs.length && this.sliderThumbs.length === this.slideshowSlides.length && e.hasAttribute(Oo)) {
                const t = parseInt(e.getAttribute(Oo)),
                    s = this.container.querySelector(`${Io}.${Wo}`);
                s && s.classList.remove(Wo), this.sliderThumbs[t].classList.add(Wo)
            }
        }
        positionArrows() {
            if (this.slideshow.hasAttribute(Ho) && this.sliderOptions.prevNextButtons) {
                const t = this.slideshow.querySelector(Eo) || this.slideshow.querySelector(qo) || this.slideshow.querySelector(Lo);
                if (!t) return;
                this.slideshow.querySelector(Ao).style.top = t.clientHeight / 2 + "px", this.slideshow.querySelector(ko).style.top = t.clientHeight / 2 + "px"
            }
        }
        onUnload() {
            this.slideshow && this.flkty && (this.flkty.options.watchCSS = !1, this.flkty.destroy())
        }
        onBlockSelect(t) {
            if (!this.slideshow) return;
            const e = this.slideshow.querySelector(`[${xo}="${t.detail.blockId}"]`);
            if (!e) return;
            let s = parseInt(e.getAttribute(Oo));
            this.slideshow.classList.add(Wo), this.flkty && this.slideshow.classList.contains($o) && (this.flkty.selectCell(s), this.flkty.stopPlayer())
        }
        onBlockDeselect() {
            this.slideshow && (this.slideshow.classList.remove(Wo), this.flkty && this.sliderOptions.hasOwnProperty("autoPlay") && this.sliderOptions.autoPlay && this.flkty.playPlayer())
        }
        constructor(t, e = null) {
            this.container = t, this.slideshow = e || this.container.querySelector(Po), this.slideshow && (this.slideshowSlides = this.slideshow.querySelectorAll(To), this.slideshowSlides.length <= 1 || (this.sliderThumbs = this.container.querySelectorAll(Io), this.slideshow.hasAttribute(Mo) && (this.customOptions = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(Mo)))), this.flkty = null, this.init()))
        }
    };
    const Jo = {
        onLoad() {
            Vo[this.id] = [];
            this.container.querySelectorAll(Po).forEach((t => {
                Vo[this.id].push(new jo(this.container, t))
            }))
        },
        onUnload() {
            Vo[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        },
        onBlockSelect(t) {
            Vo[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            Vo[this.id].forEach((e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            }))
        }
    };
    no("blog-section", [Jo]), no("double", Jo);
    const Xo = t => {
        let {
            stickyHeaderHeight: e
        } = r();
        window.scrollTo({
            top: t + window.scrollY - e,
            left: 0,
            behavior: "smooth"
        })
    };
    let Go = class {
        write() {
            (-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) && (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`)
        }
        read() {
            if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t => t.startsWith(this.name)))) {
                return document.cookie.split("; ").find((t => t.startsWith(this.name))).split("=")[1]
            }
            return !1
        }
        destroy() {
            document.cookie.split("; ").find((t => t.startsWith(this.name))) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
        }
        constructor(t, e, s = 7) {
            const i = new Date,
                o = new Date;
            o.setTime(i.getTime() + 864e5 * s), this.configuration = {
                expires: o.toGMTString(),
                path: "/",
                domain: window.location.hostname,
                sameSite: "none",
                secure: !0
            }, this.name = t, this.value = e
        }
    };
    const Qo = "[data-newsletter-form]",
        Yo = "[data-newsletter-heading]",
        Ko = "[data-newsletter]",
        Zo = "has-success",
        tn = "has-error",
        en = "hidden",
        sn = "data-cookie-name",
        on = {};
    const nn = {
        onLoad() {
            on[this.id] = [];
            this.container.querySelectorAll(Qo).forEach((t => {
                on[this.id].push(new class {
                    init() {
                        this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage()
                    }
                    newsletterSubmitEvent(t) {
                        this.stopSubmit && (t.preventDefault(), t.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), this.stopSubmit = !1, this.newsletter.submit())
                    }
                    checkForChallengePage() {
                        this.isChallengePage = "/challenge" === window.location.pathname
                    }
                    writeStorage() {
                        void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id)
                    }
                    readStorage() {
                        this.formID = this.sessionStorage.getItem("newsletter_form_id")
                    }
                    removeStorage() {
                        this.sessionStorage.removeItem("newsletter_form_id")
                    }
                    showMessage() {
                        if (this.readStorage(), this.newsletter.id === this.formID) {
                            const t = document.getElementById(this.formID),
                                e = t.parentElement.querySelector(Yo),
                                s = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                i = -1 !== window.location.search.indexOf("accepts_marketing");
                            s ? (t.classList.remove(tn), t.classList.add(Zo), e && (e.classList.add(en), t.classList.remove(en)), this.popup && this.cookie.write()) : i && (t.classList.remove(Zo), t.classList.add(tn), e && (e.classList.add(en), t.classList.remove(en))), (s || i) && window.addEventListener("load", (() => {
                                this.scrollToForm(t)
                            }))
                        }
                    }
                    scrollToForm(t) {
                        const e = t.getBoundingClientRect();
                        e.top >= 0 && e.left >= 0 && e.bottom <= m() && e.right <= p() || setTimeout((() => {
                            Xo(t.getBoundingClientRect().top)
                        }), 500)
                    }
                    unload() {
                        this.newsletter.removeEventListener("submit", this.newsletterSubmit)
                    }
                    constructor(t) {
                        this.sessionStorage = window.sessionStorage, this.newsletter = t, this.popup = this.newsletter.closest(Ko), this.popup && (this.cookie = new Go(this.popup.getAttribute(sn), "user_has_closed", null)), this.stopSubmit = !0, this.isChallengePage = !1, this.formID = null, this.checkForChallengePage(), this.newsletterSubmit = t => this.newsletterSubmitEvent(t), this.isChallengePage || this.init()
                    }
                }(t))
            }))
        },
        onUnload() {
            on[this.id].forEach((t => {
                "function" == typeof t.unload && t.unload()
            }))
        }
    };
    no("footer", [nn]);
    const rn = "[data-collection-sidebar]",
        an = "[data-collection-sidebar-slide-out]",
        ln = "[data-collection-sidebar-close]",
        cn = "[data-aria-toggle]",
        dn = "drawer--animated",
        hn = "expanded",
        un = "no-mobile-animation",
        pn = "is-focused";
    let mn = {};
    no("collection", [Jo, {
        onLoad() {
            mn[this.id] = new class {
                init() {
                    null !== this.groupTagsButton && (document.addEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent), this.collectionSidebar && setTimeout((() => {
                        this.collectionSidebar.classList.remove(un)
                    }), 1e3), new MutationObserver((t => {
                        for (const e of t) "attributes" === e.type && "true" == e.target.getAttribute("aria-expanded") && this.showSidebarCallback()
                    })).observe(this.groupTagsButton, {
                        attributes: !0,
                        childList: !1,
                        subtree: !1
                    })), this.container.addEventListener("keyup", function(t) {
                        "Escape" === t.code && this.hideSidebar()
                    }.bind(this)), this.collectionSidebar && (this.collectionSidebar.addEventListener("transitionend", (() => {
                        this.collectionSidebar.classList.contains(hn) || this.collectionSidebar.classList.remove(dn)
                    })), this.toggleSidebarSlider(), this.container.addEventListener("theme:filter:close", this.collectionSidebarCloseEvent))
                }
                showSidebarCallback() {
                    const t = this.container.querySelector(an),
                        e = document.documentElement.hasAttribute("data-scroll-locked"),
                        s = g();
                    this.collectionSidebar.classList.add(dn), null === t && !s && e && (this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))), (s || null !== t) && (t && this.a11y.trapFocus(this.collectionSidebar, {
                        elementToFocus: this.collectionSidebar.querySelector(ln)
                    }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                        bubbles: !0
                    })))
                }
                hideSidebar() {
                    const t = this.container.querySelector(an),
                        e = document.documentElement.hasAttribute("data-scroll-locked");
                    this.groupTagsButton.setAttribute("aria-expanded", "false"), this.collectionSidebar.classList.remove(hn), t && this.a11y.removeTrapFocus(), e && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))
                }
                toggleSidebarSlider() {
                    g() ? this.hideSidebar() : this.collectionSidebar.classList.contains(hn) && this.showSidebarCallback()
                }
                collectionSidebarClose(t) {
                    t.preventDefault(), this.hideSidebar(), document.body.classList.contains(pn) && this.groupTagsButton && this.groupTagsButton.focus()
                }
                groupTagsButtonClick() {
                    document.documentElement.hasAttribute("data-scroll-locked") && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))
                }
                onUnload() {
                    null !== this.groupTagsButton && (document.removeEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent)), this.collectionSidebar && this.container.removeEventListener("theme:filter:close", this.collectionSidebarCloseEvent)
                }
                constructor(t) {
                    this.container = t.container, this.collectionSidebar = this.container.querySelector(rn), this.groupTagsButton = this.container.querySelector(cn), this.a11y = $, this.groupTagsButtonClickEvent = t => this.groupTagsButtonClick(t), this.sidebarResizeEvent = () => this.toggleSidebarSlider(), this.collectionSidebarCloseEvent = t => this.collectionSidebarClose(t), this.init()
                }
            }(this)
        },
        onUnload() {
            mn[this.id].onUnload()
        }
    }, wo]);
    const vn = {
            marquee: ".announcement__bar-holder--marquee",
            slide: "[data-slide]",
            slider: "[data-slider]",
            ticker: "ticker-bar",
            tickerSlide: ".announcement__slide"
        },
        gn = "hidden";
    let bn = class extends HTMLElement {
        connectedCallback() {
            this.slider && this.initSliders(), this.addEventListener("theme:block:select", (t => {
                this.onBlockSelect(t)
            })), this.addEventListener("theme:block:deselect", (t => {
                this.onBlockDeselect(t)
            })), this.addEventListener("theme:countdown:hide", (t => {
                if (window.Shopify.designMode) return;
                const e = t.target.closest(vn.marquee);
                if (1 === this.slidesCount) {
                    this.querySelector(vn.ticker).style.display = "none"
                }
                if (e) {
                    const e = t.target.closest(vn.tickerSlide);
                    this.removeTickerText(e)
                } else {
                    const e = t.target.closest(vn.slide);
                    this.removeSlide(e)
                }
            })), this.addEventListener("theme:countdown:expire", (() => {
                var t;
                null === (t = this.querySelectorAll(vn.ticker)) || void 0 === t || t.forEach((t => {
                    t.dispatchEvent(new CustomEvent("theme:ticker:refresh"))
                }))
            })), document.dispatchEvent(new CustomEvent("theme:announcement:init", {
                bubbles: !0
            }))
        }
        initSliders() {
            this.initSlider(), document.addEventListener("theme:resize:width", this.initSliderEvent), this.addEventListener("theme:slider:loaded", (() => {
                var t;
                null === (t = this.querySelectorAll(vn.tickerBar)) || void 0 === t || t.forEach((t => {
                    t.dispatchEvent(new CustomEvent("theme:ticker:refresh"))
                }))
            }))
        }
        initSlider() {
            const t = v(),
                e = !t;
            var s, i;
            (t && this.enableSlider || e && !this.enableSlider) && (null === (s = this.slider.flkty) || void 0 === s || s.destroy(), t && this.enableSlider ? this.enableSlider = !1 : e && !this.enableSlider && (this.enableSlider = !0), this.slider = new jo(this, this.querySelector(vn.slider)), null === (i = this.slider.flkty) || void 0 === i || i.reposition())
        }
        removeSlide(t) {
            var e, s;
            null === (e = this.slider.flkty) || void 0 === e || e.remove(t), 0 === (null === (s = this.slider.flkty) || void 0 === s ? void 0 : s.cells.length) && this.section.classList.add(gn)
        }
        removeTickerText(t) {
            const e = t.closest(vn.ticker);
            t.remove(), e.dispatchEvent(new CustomEvent("theme:ticker:refresh"))
        }
        onBlockSelect(t) {
            this.slider && this.slider.onBlockSelect(t)
        }
        onBlockDeselect(t) {
            this.slider && this.slider.onBlockDeselect(t)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.initSliderEvent), document.removeEventListener("theme:resize:width", this.tickerResizeEvent), this.removeEventListener("theme:block:select", (t => {
                this.onBlockSelect(t)
            })), this.removeEventListener("theme:block:deselect", (t => {
                this.onBlockDeselect(t)
            }))
        }
        constructor() {
            super(), this.slider = this.querySelector(vn.slider), this.enableSlider = v(), this.slidesCount = this.querySelectorAll(vn.tickerSlide).length, this.initSliderEvent = t => this.initSlider(t)
        }
    };
    customElements.get("announcement-bar") || customElements.define("announcement-bar", bn);
    const fn = ".page-header",
        yn = "js__header__stuck",
        wn = "has-header-sticky",
        Sn = "shopify-section-group-header-group",
        En = "data-header-sticky",
        Ln = "data-scroll-locked";
    let kn = {};
    const An = {
            onLoad() {
                kn = new class {
                    listen() {
                        document.addEventListener("theme:scroll", this.scrollEvent), document.addEventListener("shopify:section:load", this.updateHeaderOffset), document.addEventListener("shopify:section:unload", this.updateHeaderOffset)
                    }
                    onScroll(t) {
                        t.detail.down ? !this.isStuck && t.detail.position > this.headerOffset && this.stickSimple() : t.detail.position <= this.headerOffset && this.unstickSimple()
                    }
                    updateHeaderOffset(t) {
                        t.target.classList.contains(Sn) && setTimeout((() => {
                            var t;
                            this.headerOffset = null === (t = document.querySelector(fn)) || void 0 === t ? void 0 : t.offsetTop
                        }))
                    }
                    stickOnLoad() {
                        window.scrollY > this.headerOffset && this.stickSimple()
                    }
                    stickSimple() {
                        this.cls.add(yn), this.isStuck = !0
                    }
                    unstickSimple() {
                        document.documentElement.hasAttribute(Ln) || (this.cls.remove(yn), this.isStuck = !1)
                    }
                    unload() {
                        document.removeEventListener("theme:scroll", this.scrollEvent), document.removeEventListener("shopify:section:load", this.updateHeaderOffset), document.removeEventListener("shopify:section:unload", this.updateHeaderOffset)
                    }
                    constructor(t) {
                        var e;
                        this.wrapper = t, this.sticks = this.wrapper.hasAttribute(En), document.body.classList.toggle(wn, this.sticks), this.sticks && (this.isStuck = !1, this.cls = this.wrapper.classList, this.headerOffset = null === (e = document.querySelector(fn)) || void 0 === e ? void 0 : e.offsetTop, this.updateHeaderOffset = this.updateHeaderOffset.bind(this), this.scrollEvent = t => this.onScroll(t), this.listen(), this.stickOnLoad())
                    }
                }(this.container)
            },
            onUnload: function() {
                "function" == typeof kn.unload && kn.unload()
            }
        },
        Cn = "data-hover-disclosure-toggle",
        qn = "[data-hover-disclosure]",
        Tn = "[data-top-link]",
        xn = "[data-header-wrapper]",
        Pn = "[data-stagger]",
        In = "[data-stagger-first]",
        Hn = "[data-stagger-second]",
        On = "is-visible",
        Mn = "meganav--visible",
        Dn = "meganav--is-transitioning";
    let Bn = {},
        Fn = {};
    const _n = {
            onLoad() {
                Bn[this.id] = [], Fn = this.container.querySelectorAll(qn), Fn.forEach((t => {
                    Bn[this.id].push(new class {
                        onBlockSelect(t) {
                            this.disclosure.contains(t.target) && this.showDisclosure(t)
                        }
                        onBlockDeselect(t) {
                            this.disclosure.contains(t.target) && this.hideDisclosure()
                        }
                        showDisclosure(t) {
                            t && t.type && "mouseenter" === t.type && this.wrapper.classList.add(Dn), this.grandparent ? this.wrapper.classList.add(Mn) : this.wrapper.classList.remove(Mn), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(On), this.disclosure.classList.add(On), this.transitionTimeout && clearTimeout(this.transitionTimeout), this.transitionTimeout = setTimeout((() => {
                                this.wrapper.classList.remove(Dn)
                            }), 200)
                        }
                        hideDisclosure() {
                            this.disclosure.classList.remove(On), this.trigger.classList.remove(On), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(Mn, Dn)
                        }
                        staggerChildAnimations() {
                            const t = this.disclosure.querySelectorAll(Pn);
                            let e = 50;
                            t.forEach(((t, s) => {
                                t.style.transitionDelay = s * e + 10 + "ms", e *= .95
                            })), this.disclosure.querySelectorAll(In).forEach(((t, e) => {
                                const s = 100 * e;
                                t.style.transitionDelay = `${s}ms`, t.parentElement.querySelectorAll(Hn).forEach(((t, e) => {
                                    const i = 20 * (e + 1);
                                    t.style.transitionDelay = `${s+i}ms`
                                }))
                            }))
                        }
                        handleTablets() {
                            this.trigger.addEventListener("touchstart", function(t) {
                                this.disclosure.classList.contains(On) || (t.preventDefault(), this.showDisclosure(t))
                            }.bind(this), {
                                passive: !0
                            })
                        }
                        connectHoverToggle() {
                            this.trigger.addEventListener("mouseenter", (t => this.showDisclosure(t))), this.link.addEventListener("focus", (t => this.showDisclosure(t))), this.trigger.addEventListener("mouseleave", (() => this.hideDisclosure())), this.trigger.addEventListener("focusout", (t => {
                                this.trigger.contains(t.relatedTarget) || this.hideDisclosure()
                            })), this.disclosure.addEventListener("keyup", (t => {
                                "Escape" === t.code && this.hideDisclosure()
                            }))
                        }
                        constructor(t) {
                            this.disclosure = t, this.wrapper = t.closest(xn), this.key = this.disclosure.id, this.trigger = document.querySelector(`[${Cn}='${this.key}']`), this.link = this.trigger.querySelector(Tn), this.grandparent = this.trigger.classList.contains("grandparent"), this.transitionTimeout = 0, this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.connectHoverToggle(), this.handleTablets(), this.staggerChildAnimations()
                        }
                    }(t))
                }))
            },
            onBlockSelect(t) {
                Bn[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                }))
            },
            onBlockDeselect(t) {
                Bn[this.id].forEach((e => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
                }))
            }
        },
        $n = "[data-takes-space-wrapper]",
        Nn = "[data-child-takes-space]",
        Rn = "[data-header-desktop]",
        Wn = '.navlink[href="#"]',
        Un = "cart-drawer",
        zn = "[data-cart-toggle]",
        Vn = ".main-content > .shopify-section.section-overlay-header:first-of-type",
        jn = "[data-prevent-transparent-header]",
        Jn = "js__header__clone",
        Xn = "has-first-section-overlay-header",
        Gn = "js__show__mobile",
        Qn = "has-header-transparent",
        Yn = "data-drawer",
        Kn = "data-drawer-toggle",
        Zn = "data-header-transparent";
    let tr = {};
    no("header", [{
        onLoad() {
            tr = new class {
                initTicker(t = !1) {
                    this.tickerFrames.forEach((e => {
                        new Ticker(e, t)
                    })), this.tickerResizeEvent = t => this.onTickerResize(t), document.addEventListener("theme:resize:width", this.tickerResizeEvent)
                }
                listenWidth() {
                    "ResizeObserver" in window ? (this.resizeObserver = new ResizeObserver(this.checkWidth), this.resizeObserver.observe(this.wrapper)) : document.addEventListener("theme:resize", this.checkWidth)
                }
                drawerToggleEvent() {
                    var t;
                    null === (t = this.wrapper.querySelectorAll(`[${Kn}]`)) || void 0 === t || t.forEach((t => {
                        t.addEventListener("click", (() => {
                            let e;
                            const s = t.hasAttribute(Kn) ? t.getAttribute(Kn) : "",
                                i = document.querySelector(`[${Yn}="${s}"]`),
                                o = document.querySelector(`mobile-menu > [${Yn}]`);
                            e = v() ? i : "new" === theme.settings.mobileMenuType && o || i, e.dispatchEvent(new CustomEvent("theme:drawer:toggle", {
                                bubbles: !1,
                                detail: {
                                    button: t
                                }
                            }))
                        }))
                    }))
                }
                killDeadLinks() {
                    this.deadLinks.forEach((t => {
                        t.onclick = t => {
                            t.preventDefault()
                        }
                    }))
                }
                checkWidth() {
                    if (document.body.clientWidth < this.minWidth) {
                        this.wrapper.classList.add(Gn);
                        const {
                            headerHeight: t
                        } = r();
                        document.documentElement.style.setProperty("--header-height", `${t}px`)
                    } else this.wrapper.classList.remove(Gn)
                }
                getMinWidth() {
                    const t = this.wrapper.cloneNode(!0);
                    t.classList.add(Jn), document.body.appendChild(t);
                    const e = t.querySelectorAll($n);
                    let s = 0,
                        i = 0;
                    return e.forEach((t => {
                        const e = t.querySelectorAll(Nn);
                        let o = 0;
                        o = 3 === e.length ? function(t) {
                            let e = [];
                            return t.forEach((t => {
                                t.firstElementChild && e.push(t.firstElementChild.clientWidth)
                            })), e[0] > e[2] ? e[2] = e[0] : e[0] = e[2], e.reduce(((t, e) => t + e))
                        }(e) : function(t) {
                            let e = 0;
                            return t.forEach((t => {
                                e += t.clientWidth
                            })), e
                        }(e), o > s && (s = o, i = 20 * e.length)
                    })), document.body.removeChild(t), s + i
                }
                cartToggleEvent() {
                    var t;
                    "drawer" === theme.settings.cartType && (null === (t = this.wrapper.querySelectorAll(zn)) || void 0 === t || t.forEach((t => {
                        t.addEventListener("click", (e => {
                            const s = document.querySelector(Un);
                            s && (e.preventDefault(), s.dispatchEvent(new CustomEvent("theme:cart-drawer:show")), window.a11y.lastElement = t)
                        }))
                    })))
                }
                toggleButtonClick(t) {
                    t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:toggle", {
                        bubbles: !0
                    }))
                }
                unload() {
                    var t;
                    "ResizeObserver" in window ? null === (t = this.resizeObserver) || void 0 === t || t.unobserve(this.wrapper) : document.removeEventListener("theme:resize", this.checkWidth)
                }
                constructor(t) {
                    this.wrapper = t, this.style = this.wrapper.dataset.style, this.desktop = this.wrapper.querySelector(Rn), this.deadLinks = document.querySelectorAll(Wn), this.resizeObserver = null, this.checkWidth = this.checkWidth.bind(this), this.killDeadLinks(), "drawer" !== this.style && this.desktop && (this.minWidth = this.getMinWidth(), this.listenWidth()), this.drawerToggleEvent(), this.cartToggleEvent();
                    let e = !1;
                    const s = document.querySelector(Vn);
                    s && !s.querySelector(jn) && (e = !0), document.body.classList.toggle(Qn, this.wrapper.hasAttribute(Zn)), document.body.classList.toggle(Xn, e)
                }
            }(this.container)
        },
        onUnload() {
            "function" == typeof tr.unload && tr.unload()
        }
    }, An, _n]);
    const er = "[data-slider-mobile]",
        sr = "[data-slide]",
        ir = "[data-slider-thumb]",
        or = "[data-slider-container]",
        nr = "[data-popup-container]",
        rr = "[data-popup-close]",
        ar = "is-animating",
        lr = "is-open",
        cr = "data-slider-thumb",
        dr = {};

    function hr() {
        this.entries = []
    }

    function ur(t, e) {
        pr(t);
        var s = function(t, e) {
            pr(t),
                function(t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.")
                }(e);
            var s = [];
            return e.forEach((function(e) {
                for (var i = 0; i < t.options.length; i++) {
                    if ((t.options[i].name || t.options[i]).toLowerCase() === e.name.toLowerCase()) {
                        s[i] = e.value;
                        break
                    }
                }
            })), s
        }(t, e);
        return function(t, e) {
            return pr(t),
                function(t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.")
                }(e), t.variants.filter((function(t) {
                    return e.every((function(e, s) {
                        return t.options[s] === e
                    }))
                }))[0] || null
        }(t, s)
    }

    function pr(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.")
    }
    no("look", [{
        onLoad() {
            dr[this.id] = new class {
                init() {
                    this.slider && this.slides.length && this.thumbs.length && (this.popupContainer.addEventListener("transitionend", (t => {
                        t.target == this.popupContainer && (this.popupContainer.classList.remove(ar), t.target.classList.contains(lr) ? this.popupOpenCallback() : this.popupCloseCallback())
                    })), this.popupContainer.addEventListener("transitionstart", (t => {
                        t.target == this.popupContainer && this.popupContainer.classList.add(ar)
                    })), this.popupClose.forEach((t => {
                        t.addEventListener("click", (() => {
                            this.popupContainer.classList.remove(lr), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                bubbles: !0
                            }))
                        }))
                    })), this.thumbs.forEach(((t, e) => {
                        t.addEventListener("click", (s => {
                            s.preventDefault();
                            const i = t.hasAttribute(cr) && "" !== t.getAttribute(cr) ? parseInt(t.getAttribute(cr)) : e,
                                o = this.slides[i];
                            if (g()) {
                                const t = parseInt(window.getComputedStyle(this.slider).paddingLeft);
                                this.slider.scrollTo({
                                    top: 0,
                                    left: o.offsetLeft - t,
                                    behavior: "auto"
                                }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                    bubbles: !0
                                })), this.popupContainer.classList.add(ar, lr)
                            } else {
                                let {
                                    stickyHeaderHeight: t
                                } = r();
                                const e = o.getBoundingClientRect().top,
                                    s = o.offsetHeight / 2,
                                    i = window.innerHeight,
                                    n = i / 2,
                                    a = this.container.querySelector(or);
                                let l = e + s - n + window.scrollY;
                                if (a) {
                                    const e = a.getBoundingClientRect().top + window.scrollY,
                                        s = e + a.offsetHeight;
                                    l < e ? l = e - t : l + i > s && (l = s - i)
                                }
                                window.scrollTo({
                                    top: l,
                                    left: 0,
                                    behavior: "smooth"
                                })
                            }
                        }))
                    })))
                }
                popupCloseByEvent() {
                    this.popupContainer.classList.remove(lr)
                }
                popupOpenCallback() {
                    document.addEventListener("theme:quick-add:open", this.popupCloseByEvent, {
                        once: !0
                    }), document.addEventListener("theme:product:added", this.popupCloseByEvent, {
                        once: !0
                    })
                }
                popupCloseCallback() {
                    document.removeEventListener("theme:quick-add:open", this.popupCloseByEvent, {
                        once: !0
                    }), document.removeEventListener("theme:product:added", this.popupCloseByEvent, {
                        once: !0
                    })
                }
                constructor(t) {
                    this.container = t.container, this.slider = this.container.querySelector(er), this.slides = this.container.querySelectorAll(sr), this.thumbs = this.container.querySelectorAll(ir), this.popupContainer = this.container.querySelector(nr), this.popupClose = this.container.querySelectorAll(rr), this.popupCloseByEvent = this.popupCloseByEvent.bind(this), this.init()
                }
            }(this)
        }
    }]), hr.prototype.add = function(t, e, s) {
        this.entries.push({
            element: t,
            event: e,
            fn: s
        }), t.addEventListener(e, s)
    }, hr.prototype.removeAll = function() {
        this.entries = this.entries.filter((function(t) {
            return t.element.removeEventListener(t.event, t.fn), !1
        }))
    };
    var mr = '[name="id"]',
        vr = '[name="selling_plan"]',
        gr = '[name^="options"]',
        br = '[name="quantity"]',
        fr = '[name^="properties"]';
    const yr = "data-scrollbar",
        wr = "data-scrollbar-slider",
        Sr = "data-scrollbar-slide-fullwidth",
        Er = "[data-scrollbar-arrow-prev]",
        Lr = "[data-scrollbar-arrow-next]",
        kr = "is-hidden";
    let Ar = class {
        init() {
            this.arrowNext && this.arrowPrev && (this.toggleNextArrow(), this.events())
        }
        listen() {
            document.addEventListener("theme:modal:open", (() => {
                this.toggleNextArrow()
            })), document.addEventListener("theme:resize", (() => {
                this.toggleNextArrow()
            }))
        }
        events() {
            this.arrowNext.addEventListener("click", (t => {
                t.preventDefault(), this.goToNext()
            })), this.arrowPrev.addEventListener("click", (t => {
                t.preventDefault(), this.goToPrev()
            })), this.scrollbar.addEventListener("scroll", (() => {
                this.togglePrevArrow(), this.toggleNextArrow()
            }))
        }
        goToNext() {
            const t = (this.scrollbar.hasAttribute(Sr) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2) + this.scrollbar.scrollLeft;
            this.move(t), this.arrowPrev.classList.remove(kr), this.toggleNextArrow()
        }
        goToPrev() {
            const t = this.scrollbar.hasAttribute(Sr) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2,
                e = this.scrollbar.scrollLeft - t;
            this.move(e), this.arrowNext.classList.remove(kr), this.togglePrevArrow()
        }
        toggleNextArrow() {
            requestAnimationFrame((() => {
                var t;
                null === (t = this.arrowNext) || void 0 === t || t.classList.toggle(kr, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth)
            }))
        }
        togglePrevArrow() {
            requestAnimationFrame((() => {
                this.arrowPrev.classList.toggle(kr, this.scrollbar.scrollLeft <= 0)
            }))
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (t => {
                t.addEventListener("click", (e => {
                    e.preventDefault(), this.move(t.offsetLeft - t.clientWidth)
                }))
            }))
        }
        move(t) {
            this.scrollbar.scrollTo({
                top: 0,
                left: t,
                behavior: "smooth"
            })
        }
        constructor(t) {
            this.scrollbar = t, this.arrowNext = this.scrollbar.parentNode.querySelector(Lr), this.arrowPrev = this.scrollbar.parentNode.querySelector(Er), this.scrollbar.hasAttribute(yr) && (this.init(), this.listen()), this.scrollbar.hasAttribute(wr) && this.scrollToVisibleElement()
        }
    };
    const Cr = "[data-grid-swatch-form]",
        qr = "[data-grid-item]",
        Tr = "[data-product-information]",
        xr = "[data-product-image]",
        Pr = "[data-swatch-button]",
        Ir = "[data-swatch-link]",
        Hr = "[data-swatch-text]",
        Or = "[data-swatch-template]",
        Mr = "is-visible",
        Dr = "no-events",
        Br = "swatch",
        Fr = "data-swatch-handle",
        _r = "data-swatch-label",
        $r = "data-scrollbar",
        Nr = "data-swatch-count",
        Rr = "data-tooltip",
        Wr = "data-swatch-variant-name",
        Ur = "data-variant-title",
        zr = "data-swatch-values";
    let Vr = class extends HTMLElement {
            connectedCallback() {
                this.hasAttribute(Rr) && new yo(this)
            }
            constructor() {
                super()
            }
        },
        jr = class extends HTMLElement {
            connectedCallback() {
                this.handle = this.getAttribute(Fr), this.productItem = this.closest(qr), this.productInfo = this.closest(Tr), this.productImage = this.productItem.querySelector(xr), this.template = document.querySelector(Or).innerHTML, this.swatchesJSON = this.getSwatchesJSON(), this.swatchesStyle = theme.settings.collectionSwatchStyle;
                const t = this.getAttribute(_r).trim().toLowerCase();
                (function(t) {
                    const e = `${window.theme.routes.root}products/${t}.js`;
                    return window.fetch(e).then((t => t.json())).catch((t => {
                        console.error(t)
                    }))
                })(this.handle).then((e => {
                    this.product = e, this.colorOption = e.options.find((function(e) {
                        return e.name.toLowerCase() === t || null
                    })), this.colorOption && (this.swatches = this.colorOption.values, this.init())
                }))
            }
            init() {
                if (this.innerHTML = "", this.count = 0, this.limitedCount = 0, this.swatches.forEach((t => {
                        let e = null,
                            s = !1,
                            i = "";
                        for (const s of this.product.variants) {
                            const o = s.options.includes(t);
                            if (!e && o && (e = s), o && s.featured_media) {
                                i = s.featured_media.preview_image.src, e = s;
                                break
                            }
                        }
                        for (const e of this.product.variants) {
                            if (e.options.includes(t) && e.available) {
                                s = !0;
                                break
                            }
                        }
                        if (e) {
                            const r = document.createElement("div");
                            r.innerHTML = this.template;
                            const a = r.querySelector(Pr),
                                l = r.querySelector(Ir),
                                c = r.querySelector(Hr),
                                d = this.swatchesJSON[t],
                                h = "native" == theme.settings.swatchesType ? d : `var(--${d})`,
                                u = e.title.replaceAll('"', "'");
                            a.style = `--animation-delay: ${100*this.count/1250}s`, a.classList.add(`${Br}-${d}`), a.dataset.tooltip = t, a.dataset.swatchVariant = e.id, a.dataset.swatchVariantName = u, a.dataset.swatchImage = i, a.dataset.variant = e.id, a.style.setProperty("--swatch", h), l.href = (o = this.product.url, n = e.id, /variant=/.test(o) ? o.replace(/(variant=)[^&]+/, "$1" + n) : /\?/.test(o) ? o.concat("&variant=").concat(n) : o.concat("?variant=").concat(n)), l.dataset.swatch = t, l.disabled = !s, c.innerText = t, "limited" != this.swatchesStyle ? this.innerHTML += r.innerHTML : this.count <= 4 && (this.innerHTML += r.innerHTML, this.limitedCount++), this.count++
                        }
                        var o, n
                    })), this.swatchCount = this.productInfo.querySelector(`[${Nr}]`), this.swatchElements = this.querySelectorAll(Ir), this.swatchForm = this.productInfo.querySelector(Cr), this.hideSwatchesTimer = 0, this.swatchCount.hasAttribute(Nr)) {
                    if ("text" == this.swatchesStyle || "text-slider" == this.swatchesStyle) {
                        if (this.swatchCount.innerText = `${this.count} ${this.count>1?theme.strings.otherColor:theme.strings.oneColor}`, "text" == this.swatchesStyle) return;
                        this.swatchCount.addEventListener("mouseenter", (() => {
                            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productInfo.classList.add(Dr), this.swatchForm.classList.add(Mr)
                        })), this.productInfo.addEventListener("mouseleave", (() => {
                            this.hideSwatchesTimer = setTimeout((() => {
                                this.productInfo.classList.remove(Dr), this.swatchForm.classList.remove(Mr)
                            }), 100)
                        }))
                    }
                    if ("slider" != this.swatchesStyle && "grid" != this.swatchesStyle || this.swatchForm.classList.add(Mr), "limited" == this.swatchesStyle) {
                        const t = this.count - this.limitedCount;
                        this.swatchForm.classList.add(Mr), t > 0 && (this.innerHTML += `<div class="swatch-limited">+${t}</div>`)
                    }
                }
                "text-slider" != this.swatchesStyle && "slider" != this.swatchesStyle || this.hasAttribute($r) && new Ar(this), this.bindSwatchButtonEvents()
            }
            bindSwatchButtonEvents() {
                var t;
                null === (t = this.querySelectorAll(Pr)) || void 0 === t || t.forEach((t => {
                    t.addEventListener("mouseenter", this.showVariantImageEvent), t.hasAttribute(Rr) && new yo(t)
                })), this.productItem.addEventListener("mouseleave", this.productItemMouseLeaveEvent)
            }
            showVariantImage(t) {
                var e;
                const s = null === (e = t.target.getAttribute(Wr)) || void 0 === e ? void 0 : e.replaceAll('"', "'"),
                    i = this.productImage.querySelectorAll(`[${Ur}]`),
                    o = this.productImage.querySelector(`[${Ur}="${s}"]`);
                null == i || i.forEach((t => {
                    t.classList.remove(Mr)
                })), null == o || o.classList.add(Mr)
            }
            hideVariantImages() {
                var t;
                null === (t = this.productImage.querySelectorAll(`[${Ur}].${Mr}`)) || void 0 === t || t.forEach((t => {
                    t.classList.remove(Mr)
                }))
            }
            getSwatchesJSON() {
                if (!this.hasAttribute(zr)) return {};
                const t = this.getAttribute(zr).split(","),
                    e = {};
                return null == t || t.forEach((t => {
                    const [s, i] = t.split(":");
                    e[s.trim()] = i.trim()
                })), e
            }
            constructor() {
                super(), this.productItemMouseLeaveEvent = () => this.hideVariantImages(), this.showVariantImageEvent = t => this.showVariantImage(t)
            }
        };

    function Jr(t) {
        return t.replace(/http(s)?:/, "")
    }
    const Xr = {
            productCutline: "[data-product-cutline]",
            productLink: "[data-product-link]",
            productGridItem: "[data-grid-item]",
            productInfo: "[data-product-information]",
            productImage: "[data-product-image-default]",
            productImageSibling: "[data-product-image-sibling]",
            productPrice: "[data-product-price]",
            siblingsInnerHolder: "[data-sibling-inner]",
            siblingCount: "[data-sibling-count]",
            siblingFieldset: "[data-sibling-fieldset]",
            siblingLink: "[data-sibling-link]",
            tooltip: "[data-tooltip]"
        },
        Gr = "is-visible",
        Qr = "is-fade",
        Yr = "no-events",
        Kr = "is-active",
        Zr = "data-sibling-cutline",
        ta = "data-sibling-image",
        ea = "data-sibling-link",
        sa = "data-sibling-price",
        ia = "data-sibling-compare-at-price",
        oa = "data-product-link";
    let na = class extends HTMLElement {
        connectedCallback() {
            this.product = this.closest(Xr.productGridItem), this.siblingScrollbar = this.querySelector(Xr.siblingsInnerHolder), this.siblingCount = this.querySelector(Xr.siblingCount), this.siblingFieldset = this.querySelector(Xr.siblingFieldset), this.siblingLinks = this.querySelectorAll(Xr.siblingLink), this.productInfo = this.closest(Xr.productInfo), this.productLink = this.closest(Xr.link), this.hideSwatchesTimer = 0, this.swatchesStyle = theme.settings.collectionSwatchStyle, this.initScrollbar(), this.siblingFieldset && this.productInfo && ("grid" != this.swatchesStyle && "slider" != this.swatchesStyle && "limited" != this.swatchesStyle || this.siblingFieldset.classList.add(Gr), this.siblingCount && (this.siblingCount.addEventListener("mouseenter", (() => this.showSiblings())), this.productInfo.addEventListener("mouseleave", (() => this.hideSiblings())))), this.siblingLinks.length && new class {
                init() {
                    this.cacheDefaultValues(), this.product.addEventListener("mouseleave", (() => this.resetProductValues())), this.product.addEventListener("focusout", (() => this.resetProductValues())), this.swatches.forEach((t => {
                        t.addEventListener("mouseenter", (t => this.showSibling(t))), t.addEventListener("focusin", (t => this.showSibling(t)))
                    })), this.productLinks.length && this.swatches.forEach((t => {
                        t.addEventListener("click", (() => {
                            this.productLinks[0].click()
                        })), t.addEventListener("keyup", (t => {
                            "Enter" === t.code && this.productLinks[0].click()
                        }))
                    }))
                }
                cacheDefaultValues() {
                    this.productLinkValue = this.productLinks[0].hasAttribute(oa) ? this.productLinks[0].getAttribute(oa) : "", this.productPriceValue = this.productPrice.innerHTML, this.productCutline && (this.productCutlineValue = this.productCutline.innerHTML)
                }
                resetProductValues() {
                    this.product.classList.remove(Kr), this.productLinkValue && this.productLinks.forEach((t => {
                        t.href = this.productLinkValue
                    })), this.productPrice && (this.productPrice.innerHTML = this.productPriceValue), this.productCutline && this.productCutline && (this.productCutline.innerHTML = this.productCutlineValue, this.productCutline.title = this.productCutlineValue), this.hideSiblingImage()
                }
                showSibling(t) {
                    const e = t.target,
                        s = e.hasAttribute(ea) ? e.getAttribute(ea) : "",
                        i = e.hasAttribute(sa) ? e.getAttribute(sa) : "",
                        o = e.hasAttribute(ia) ? e.getAttribute(ia) : "",
                        n = e.hasAttribute(Zr) ? e.getAttribute(Zr) : "",
                        r = e.hasAttribute(ta) ? e.getAttribute(ta) : "";
                    s && this.productLinks.forEach((t => {
                        t.href = s
                    })), this.productPrice.innerHTML = o ? `<span class="price sale"><span class="new-price">${i}</span> <span class="old-price">${o}</span></span>` : `<span class="price">${i}</span>`, this.productCutline && (n ? (this.productCutline.innerHTML = n, this.productCutline.title = n) : (this.productCutline.innerHTML = "", this.productCutline.title = "")), r && this.showSiblingImage(r)
                }
                showSiblingImage(t) {
                    if (!this.productImageSibling) return;
                    const e = window.devicePixelRatio || 1,
                        s = this.productImage.offsetWidth * e,
                        i = function(t, e) {
                            if (null === e) return t;
                            if ("master" === e) return Jr(t);
                            const s = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                            if (s) {
                                const i = t.split(s[0]),
                                    o = s[0];
                                return Jr(`${i[0]}_${e}${o}`)
                            }
                            return null
                        }(t, 180 * Math.ceil(s / 180) + "x"),
                        o = this.productImageSibling.querySelector(`[src="${i}"]`),
                        n = () => {
                            this.productImageSibling.classList.add(Gr), this.productImageSibling.querySelector(`[src="${i}"]`).classList.add(Qr)
                        },
                        r = () => {
                            this.productImageSibling.querySelectorAll("img").forEach((t => {
                                t.classList.remove(Qr)
                            })), requestAnimationFrame(n)
                        };
                    if (o) r();
                    else {
                        const t = document.createElement("img");
                        t.src = i, this.productCutline && (t.alt = this.productCutline.innerText), t.addEventListener("load", (() => {
                            this.productImageSibling.append(t), r()
                        }))
                    }
                }
                hideSiblingImage() {
                    this.productImageSibling && (this.productImageSibling.classList.remove(Gr), this.productImageSibling.querySelectorAll("img").forEach((t => {
                        t.classList.remove(Qr)
                    })))
                }
                constructor(t, e) {
                    this.swatches = t, this.product = e, this.productLinks = this.product.querySelectorAll(Xr.productLink), this.productCutline = this.product.querySelector(Xr.productCutline), this.productPrice = this.product.querySelector(Xr.productPrice), this.productImage = this.product.querySelector(Xr.productImage), this.productImageSibling = this.product.querySelector(Xr.productImageSibling), this.init()
                }
            }(this.siblingLinks, this.product), this.querySelectorAll(Xr.tooltip).forEach((t => {
                new yo(t)
            }))
        }
        showSiblings() {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productLink && this.productLink.classList.add(Yr), "text" != this.swatchesStyle && this.siblingFieldset.classList.add(Gr)
        }
        hideSiblings() {
            this.hideSwatchesTimer = setTimeout((() => {
                this.productLink && this.productLink.classList.remove(Yr), this.siblingFieldset.classList.remove(Gr)
            }), 100)
        }
        initScrollbar() {
            this.siblingScrollbar && new Ar(this.siblingScrollbar)
        }
        constructor() {
            super()
        }
    };
    const ra = "[data-hover-slide]",
        aa = "[data-hover-slide-touch]",
        la = "[data-hover-slider]",
        ca = "[data-product-link]",
        da = ".flickity-prev-next-button";
    let ha = class extends HTMLElement {
        connectedCallback() {
            window.theme.touch ? this.initTouch() : this.initFlickity()
        }
        disconnectedCallback() {
            this.flkty && (this.flkty.options.watchCSS = !1, this.flkty.destroy())
        }
        initTouch() {
            this.style.setProperty("--slides-count", this.querySelectorAll(aa).length), this.slider.addEventListener("scroll", this.handleScroll)
        }
        handleScroll() {
            const t = this.slider.scrollLeft / this.slider.clientWidth;
            this.style.setProperty("--slider-index", t)
        }
        initFlickity() {
            this.querySelectorAll(ra).length < 2 || (this.flkty = new e(this.slider, {
                cellSelector: ra,
                contain: !0,
                wrapAround: !0,
                watchCSS: !0,
                autoPlay: !1,
                draggable: !1,
                pageDots: !1,
                prevNextButtons: !0
            }), this.flkty.pausePlayer(), this.addEventListener("mouseenter", (() => {
                this.flkty.unpausePlayer()
            })), this.addEventListener("mouseleave", (() => {
                this.flkty.pausePlayer()
            })), this.closest(ca).addEventListener("click", (t => {
                t.target.matches(da) && t.preventDefault()
            })))
        }
        constructor() {
            super(), this.flkty = null, this.slider = this.querySelector(la), this.handleScroll = this.handleScroll.bind(this)
        }
    };
    const ua = "body",
        pa = "[data-related-section]",
        ma = "[data-tabs-holder]",
        va = "data-tab",
        ga = "data-tab-index",
        ba = "[data-aos]",
        fa = "data-block-id",
        ya = "[data-tab]",
        wa = ".tab-link",
        Sa = ".tab-link__recent",
        Ea = ".tab-content",
        La = "[data-scrollbar]",
        ka = "current",
        Aa = "hidden",
        Ca = "aos-animate",
        qa = "aos-no-transition",
        Ta = "is-focused",
        xa = {};
    const Pa = {
        onLoad() {
            xa[this.id] = [];
            this.container.querySelectorAll(ma).forEach((t => {
                xa[this.id].push(new class {
                    init() {
                        const t = this.container.querySelectorAll(ya);
                        this.container.addEventListener("theme:tab:check", (() => this.checkRecentTab())), this.container.addEventListener("theme:tab:hide", (() => this.hideRelatedTab())), t.length && t.forEach((t => {
                            const e = parseInt(t.getAttribute(va)),
                                s = this.container.querySelector(`${Ea}-${e}`);
                            t.addEventListener("click", (() => {
                                this.tabChange(t, s)
                            })), t.addEventListener("keyup", (e => {
                                "Space" !== e.code && "Enter" !== e.code || !this.body.classList.contains(Ta) || this.tabChange(t, s)
                            }))
                        }))
                    }
                    tabChange(t, e) {
                        if (t.classList.contains(ka)) return;
                        const s = this.container.querySelector(`${ya}.${ka}`),
                            i = this.container.querySelector(`${Ea}.${ka}`);
                        null == s || s.classList.remove(ka), null == i || i.classList.remove(ka), t.classList.add(ka), e.classList.add(ka), t.classList.contains(Aa) && e.classList.add(Aa), this.a11y.a11y.removeTrapFocus(), this.container.dispatchEvent(new CustomEvent("theme:tab:change", {
                            bubbles: !0
                        })), t.dispatchEvent(new CustomEvent("theme:form:sticky", {
                            bubbles: !0,
                            detail: {
                                element: "tab"
                            }
                        })), this.animateItems(e)
                    }
                    animateItems(t, e = !0) {
                        const s = t.querySelectorAll(ba);
                        s.length && s.forEach((t => {
                            t.classList.remove(Ca), e && (t.classList.add(qa), requestAnimationFrame((() => {
                                t.classList.remove(qa), t.classList.add(Ca)
                            })))
                        }))
                    }
                    initNativeScrollbar() {
                        this.scrollbarHolder.length && this.scrollbarHolder.forEach((t => {
                            new Ar(t)
                        }))
                    }
                    checkRecentTab() {
                        const t = this.container.querySelector(Sa);
                        if (t) {
                            t.classList.remove(Aa);
                            const e = parseInt(t.getAttribute(va)),
                                s = this.container.querySelector(`${Ea}[${ga}="${e}"]`);
                            s && (s.classList.remove(Aa), this.animateItems(s, !1)), this.initNativeScrollbar()
                        }
                    }
                    hideRelatedTab() {
                        const t = this.container.querySelector(pa);
                        if (!t) return;
                        const e = t.closest(`${Ea}.${ka}`);
                        if (!e) return;
                        const s = parseInt(e.getAttribute(ga)),
                            i = this.container.querySelectorAll(ya);
                        if (i.length > s) {
                            const t = i[s].nextSibling;
                            t && (i[s].classList.add(Aa), t.dispatchEvent(new Event("click")), this.initNativeScrollbar())
                        }
                    }
                    onBlockSelect(t) {
                        const e = this.container.querySelector(`${wa}[${fa}="${t.detail.blockId}"]`);
                        e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({
                            top: 0,
                            left: e.offsetLeft - e.clientWidth,
                            behavior: "smooth"
                        }))
                    }
                    constructor(t) {
                        this.container = t, this.body = document.querySelector(ua), this.a11y = window.a11y, this.container && (this.scrollbarHolder = this.container.querySelectorAll(La), this.init(), this.initNativeScrollbar())
                    }
                }(t))
            }))
        },
        onBlockSelect(t) {
            xa[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        }
    };

    function Ia() {
        const t = Boolean(document.querySelectorAll("dialog[open][data-scroll-lock-required]").length),
            e = Boolean(document.querySelectorAll(".drawer.is-open").length);
        return t || e
    }
    const Ha = {
            added: "is-added",
            animated: "is-animated",
            disabled: "is-disabled",
            error: "has-error",
            loading: "is-loading",
            open: "is-open",
            overlayText: "product-item--overlay-text",
            visible: "is-visible",
            siblingLinkCurrent: "sibling__link--current"
        },
        Oa = 3e3,
        Ma = "[data-animation]",
        Da = "[data-api-content]",
        Ba = "[data-quick-add-btn]",
        Fa = "[data-add-to-cart]",
        _a = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        $a = "[data-message-error]",
        Na = "[data-quick-add-modal-handle]",
        Ra = "[data-product-upsell-ajax]",
        Wa = "[data-quick-add-modal-close]",
        Ua = "data-grid-item",
        za = "[data-product-information]",
        Va = "[data-quick-add-holder]",
        ja = "[data-quick-add-modal]",
        Ja = "[data-quick-add-modal-template]",
        Xa = "[data-tooltip]",
        Ga = "closing",
        Qa = "data-product-id",
        Ya = "data-quick-add-modal-handle",
        Ka = "data-sibling-swapper",
        Za = "data-quick-add-holder";
    let tl = class extends HTMLElement {
        connectedCallback() {
            this.modalButton && this.modalButton.addEventListener("click", this.modalButtonClickEvent), this.buttonATC && this.buttonATC.addEventListener("click", (t => {
                t.preventDefault(), window.a11y.lastElement = this.buttonATC, document.dispatchEvent(new CustomEvent("theme:cart:add", {
                    detail: {
                        button: this.buttonATC
                    }
                }))
            })), this.quickAddHolder && (this.quickAddHolder.addEventListener("animationend", this.quickAddLoadingToggle), this.errorHandler())
        }
        modalButtonClickEvent(t) {
            t.preventDefault();
            const e = this.modalButton.hasAttribute(Ka),
                s = this.modalButton.classList.contains(Ha.siblingLinkCurrent);
            s || (this.modalButton.classList.add(Ha.loading), this.modalButton.disabled = !0, e && !s && (this.currentModal = t.target.closest(ja), this.currentModal.classList.add(Ha.loading)), this.renderModal())
        }
        modalCreate(t) {
            const e = document.querySelector(`${ja}[${Qa}="${this.productId}"]`);
            if (e) this.modal = e, this.modalOpen();
            else {
                const e = this.quickAddHolder.querySelector(Ja);
                if (!e) return;
                const s = document.createElement("div");
                s.innerHTML = e.innerHTML, document.body.appendChild(s.querySelector(ja)), e.remove(), this.modal = document.querySelector(`${ja}[${Qa}="${this.productId}"]`), this.modal.querySelector(Ra).innerHTML = (new DOMParser).parseFromString(t, "text/html").querySelector(Da).innerHTML, this.modal.querySelectorAll(Xa).forEach((t => {
                    new yo(t)
                })), this.modalCreatedCallback()
            }
        }
        modalOpen() {
            this.currentModal && this.currentModal.dispatchEvent(new CustomEvent("theme:modal:close", {
                bubbles: !1
            })), "function" == typeof this.modal.show && this.modal.show(), this.modal.setAttribute("open", !0), this.modal.removeAttribute("inert"), this.quickAddHolder.classList.add(Ha.disabled), this.modalButton && (this.modalButton.classList.remove(Ha.loading), this.modalButton.disabled = !1, window.a11y.lastElement = this.modalButton), requestAnimationFrame((() => {
                this.modal.querySelectorAll(Ma).forEach((t => {
                    t.classList.add(Ha.animated)
                }))
            })), document.dispatchEvent(new CustomEvent("theme:quick-add:open", {
                bubbles: !0
            })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), document.addEventListener("theme:product:added", this.modalCloseOnProductAdded, {
                once: !0
            })
        }
        modalClose() {
            if (!this.isAnimating) {
                if (!this.modal.hasAttribute(Ga)) return this.modal.setAttribute(Ga, ""), void(this.isAnimating = !0);
                "function" == typeof this.modal.close ? this.modal.close() : this.modal.removeAttribute("open"), this.modal.removeAttribute(Ga), this.modal.setAttribute("inert", ""), this.modal.classList.remove(Ha.loading), this.modalButton && (this.modalButton.disabled = !1), this.quickAddHolder && this.quickAddHolder.classList.contains(Ha.disabled) && this.quickAddHolder.classList.remove(Ha.disabled), this.resetAnimatedItems(), Ia() || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0
                })), document.removeEventListener("theme:product:added", this.modalCloseOnProductAdded), this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()
            }
        }
        modalEvents() {
            var t;
            null === (t = this.modal.querySelector(Wa)) || void 0 === t || t.addEventListener("click", (t => {
                t.preventDefault(), this.modalClose()
            })), this.modal.addEventListener("click", (t => {
                "DIALOG" === t.target.nodeName && "click" === t.type && this.modalClose()
            })), this.modal.addEventListener("keydown", (t => {
                "Escape" == t.code && (t.preventDefault(), this.modalClose())
            })), this.modal.addEventListener("theme:modal:close", (() => {
                this.modalClose()
            })), this.modal.addEventListener("animationend", (t => {
                t.target === this.modal && (this.isAnimating = !1, this.modal.hasAttribute(Ga) ? this.modalClose() : setTimeout((() => {
                    this.a11y.trapFocus(this.modal);
                    const t = this.modal.querySelector("[autofocus]") || this.modal.querySelector(_a);
                    null == t || t.focus()
                }), 50))
            }))
        }
        modalCloseOnProductAdded() {
            this.resetQuickAddButtons(), this.modal && this.modal.hasAttribute("open") && this.modalClose()
        }
        quickAddLoadingToggle(t) {
            t.target == this.quickAddHolder && this.quickAddHolder.classList.remove(Ha.disabled)
        }
        errorHandler() {
            this.quickAddHolder.addEventListener("theme:cart:error", (t => {
                const e = t.detail.holder,
                    s = e.closest(`[${Ua}]`);
                if (!s) return;
                const i = e.querySelector($a),
                    o = s.classList.contains(Ha.overlayText),
                    n = s.querySelector(za),
                    r = e.querySelector(Fa);
                r && (r.classList.remove(Ha.added, Ha.loading), e.classList.add(Ha.error)), i && (i.innerText = t.detail.description), o && n.classList.add(Ha.hidden), setTimeout((() => {
                    this.resetQuickAddButtons(), o && n.classList.remove(Ha.hidden)
                }), Oa)
            }))
        }
        resetQuickAddButtons() {
            this.quickAddHolder && this.quickAddHolder.classList.remove(Ha.visible, Ha.error), this.buttonQuickAdd && (this.buttonQuickAdd.classList.remove(Ha.added), this.buttonQuickAdd.disabled = !1)
        }
        renderModal() {
            this.modal ? this.modalOpen() : window.fetch(`${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`).then(this.upsellErrorsHandler).then((t => t.text())).then((t => {
                this.modalCreate(t)
            }))
        }
        modalCreatedCallback() {
            this.modalEvents(), this.modalOpen(), x(this.modal)
        }
        upsellErrorsHandler(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new Ze({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        resetAnimatedItems() {
            var t;
            null === (t = this.modal) || void 0 === t || t.querySelectorAll(Ma).forEach((t => {
                t.classList.remove(Ha.animated)
            }))
        }
        constructor() {
            var t;
            (super(), this.container = this, this.quickAddHolder = this.container.querySelector(Va), this.quickAddHolder) && (this.modal = null, this.currentModal = null, this.productId = this.quickAddHolder.getAttribute(Za), this.modalButton = this.quickAddHolder.querySelector(Na), this.handle = null === (t = this.modalButton) || void 0 === t ? void 0 : t.getAttribute(Ya), this.buttonQuickAdd = this.quickAddHolder.querySelector(Ba), this.buttonATC = this.quickAddHolder.querySelector(Fa), this.button = this.modalButton || this.buttonATC, this.modalClose = this.modalClose.bind(this), this.modalCloseOnProductAdded = this.modalCloseOnProductAdded.bind(this), this.a11y = $, this.isAnimating = !1, this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this), this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this))
        }
    };
    no("product-grid", [Pa]), customElements.get("quick-add-product") || customElements.define("quick-add-product", tl), customElements.get("radio-swatch") || customElements.define("radio-swatch", Vr), customElements.get("grid-swatch") || customElements.define("grid-swatch", jr), customElements.get("product-siblings") || customElements.define("product-siblings", na), customElements.get("hover-images") || customElements.define("hover-images", ha);
    const el = ".product__page",
        sl = "[data-form-wrapper]",
        il = "[data-header-sticky]",
        ol = "[data-product-media-list]",
        nl = "is-sticky",
        rl = "data-sticky-enabled";
    window.theme.variables = {
        productPageSticky: !1
    };
    const al = {};
    const ll = {
            onLoad() {
                al[this.id] = new class {
                    init() {
                        this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky()
                    }
                    initSticky() {
                        theme.variables.productPageSticky && (this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition())), this.formWrapper.addEventListener("theme:form:sticky", this.stickyFormEvent), document.addEventListener("theme:scroll", this.scrollEvent))
                    }
                    stickyFormEvents(t) {
                        this.removeAnimationFrameSticky(), this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition(t)))
                    }
                    scrollEvents(t) {
                        this.scrollTop = t.detail.position, this.scrollDirectionDown = t.detail.down, this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition())))
                    }
                    resizeEvents(t) {
                        this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.formWrapper.removeEventListener("theme:form:sticky", this.stickyFormEvent), this.initSticky()
                    }
                    stickyScrollCheck() {
                        const t = this.container.querySelector(`${el} ${sl}`);
                        if (t)
                            if (v()) {
                                const e = this.container.querySelector(sl),
                                    s = this.container.querySelector(ol);
                                if (!e || !s) return;
                                e.offsetHeight < s.offsetHeight ? (theme.variables.productPageSticky = !0, t.classList.add(nl)) : (theme.variables.productPageSticky = !1, t.classList.remove(nl))
                            } else theme.variables.productPageSticky = !1, t.classList.remove(nl)
                    }
                    calculateStickyPosition(t = null) {
                        if (document.documentElement.hasAttribute("data-scroll-locked")) return void this.removeAnimationFrameSticky();
                        const e = Boolean(t && t.detail),
                            s = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                            i = this.formWrapper.offsetHeight,
                            o = window.innerHeight - i - this.defaultTopBottomSpacings,
                            n = Math.abs(this.scrollTop - this.scrollLastPosition);
                        if (this.scrollDirectionDown ? this.stickyScrollTop -= n : this.stickyScrollTop += n, this.stickyFormLoad) {
                            if (document.querySelector(il)) {
                                let {
                                    headerHeight: t
                                } = r();
                                this.stickyDefaultTop = t
                            } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
                            this.stickyScrollTop = this.stickyDefaultTop
                        }
                        this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop);
                        const a = this.stickyScrollTop - this.currentPoint;
                        this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + .5 * a, this.formWrapper.style.setProperty("--sticky-top", `${this.currentPoint}px`), this.scrollLastPosition = this.scrollTop, this.stickyFormLoad = !1, s && this.onChangeCounter <= 10 || s && this.stickyFormLastHeight !== i || this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky ? (s && (this.onChangeCounter += 1), s && this.stickyFormLastHeight !== i && (this.onChangeCounter = 11), this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition(t)))) : this.requestAnimationSticky && this.removeAnimationFrameSticky(), this.stickyFormLastHeight = i
                    }
                    removeAnimationFrameSticky() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), this.requestAnimationSticky = null, this.onChangeCounter = 0)
                    }
                    onUnload() {
                        this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent)
                    }
                    constructor(t) {
                        this.section = t, this.container = t.container, this.stickyEnabled = "true" === this.container.getAttribute(rl), this.formWrapper = this.container.querySelector(sl), this.stickyScrollTop = 0, this.scrollLastPosition = 0, this.stickyDefaultTop = 0, this.currentPoint = 0, this.defaultTopBottomSpacings = 30, this.scrollTop = window.scrollY, this.scrollDirectionDown = !0, this.requestAnimationSticky = null, this.stickyFormLoad = !0, this.stickyFormLastHeight = null, this.onChangeCounter = 0, this.scrollEvent = t => this.scrollEvents(t), this.resizeEvent = t => this.resizeEvents(t), this.stickyFormEvent = t => this.stickyFormEvents(t), setTimeout((() => {
                            this.init()
                        }), 50)
                    }
                }(this)
            },
            onUnload() {
                al[this.id].onUnload()
            }
        },
        cl = "data-option-position",
        dl = '[name^="options"], [data-popout-option]',
        hl = '[name^="options"]:checked, [name^="options"][type="hidden"]',
        ul = "data-value",
        pl = "[data-popout]",
        ml = "sold-out",
        vl = "unavailable",
        gl = "sale";
    const bl = "[data-product]",
        fl = "[data-product-form]",
        yl = "product-notification",
        wl = "[data-variant-title]",
        Sl = "[data-notification-product]",
        El = "[data-add-to-cart]",
        Ll = "[data-add-to-cart-text]",
        kl = "[data-compare-price]",
        Al = "[data-compare-text]",
        Cl = "[data-final-sale-badge]",
        ql = "[data-form-wrapper]",
        Tl = "[data-product-select]",
        xl = "[data-price-wrapper]",
        Pl = "product-images",
        Il = "[data-product-media-list]",
        Hl = "[data-product-json]",
        Ol = "[data-product-price]",
        Ml = "[data-product-unit-price]",
        Dl = "[data-product-base]",
        Bl = "[data-product-unit]",
        Fl = "[data-product-preorder]",
        _l = "[data-subscription-watch-price]",
        $l = "[data-subscription-selectors]",
        Nl = "[data-toggles-group]",
        Rl = "data-group-toggle",
        Wl = "[data-plan-description]",
        Ul = "[data-section-type]",
        zl = "[data-variant-sku]",
        Vl = "[data-variant-final-sale-metafield]",
        jl = "[data-variant-buttons]",
        Jl = "[data-variant-option-image]",
        Xl = "[data-quick-add-modal]",
        Gl = "[data-price-off-amount]",
        Ql = "[data-price-off-badge]",
        Yl = "[data-price-off-type]",
        Kl = "[data-price-off]",
        Zl = "[data-remaining-count]",
        tc = "[data-remaining-max]",
        ec = "[data-remaining-wrapper]",
        sc = "[data-product-remaining-json]",
        ic = "[data-option-value]",
        oc = "[data-option-position]",
        nc = "[data-product-form-installment]",
        rc = 'input[name="id"]',
        ac = "hidden",
        lc = "variant--soldout",
        cc = "variant--unavailable",
        dc = "product__price--sale",
        hc = "count-is-low",
        uc = "count-is-in",
        pc = "count-is-out",
        mc = "count-is-unavailable",
        vc = "data-remaining-max",
        gc = "data-enable-history-state",
        bc = "data-fader-desktop",
        fc = "data-fader-mobile",
        yc = "data-option-position",
        wc = "data-image-id",
        Sc = "data-media-id",
        Ec = "data-quick-add-btn",
        Lc = "data-final-sale",
        kc = "data-variant-image-scroll";
    let Ac = class extends HTMLElement {
        connectedCallback() {
            if (this.cartAddEvents(), this.container = this.closest(Ul) || this.closest(Xl), !this.container) return;
            if (this.sectionId = this.container.dataset.sectionId, this.product = this.container.querySelector(bl), this.productForm = this.container.querySelector(fl), this.productNotification = this.container.querySelector(yl), this.productImages = this.container.querySelector(Pl), this.productMediaList = this.container.querySelector(Il), this.installmentForm = this.container.querySelector(nc), this.skuWrapper = this.container.querySelector(zl), this.sellout = null, this.variantImageScroll = "true" === this.container.getAttribute(kc), this.priceOffWrap = this.container.querySelector(Kl), this.priceOffAmount = this.container.querySelector(Gl), this.priceOffType = this.container.querySelector(Yl), this.planDescription = this.container.querySelector(Wl), this.remainingWrapper = this.container.querySelector(ec), this.remainingWrapper) {
                const t = this.container.querySelector(tc);
                t && (this.remainingMaxInt = parseInt(t.getAttribute(vc), 10), this.remainingCount = this.container.querySelector(Zl), this.remainingJSONWrapper = this.container.querySelector(sc), this.remainingJSON = null, this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML) : console.warn("Missing product quantity JSON"))
            }
            this.enableHistoryState = "true" === this.container.getAttribute(gc), this.hasUnitPricing = this.container.querySelector(Bl), this.subSelectors = this.container.querySelector($l), this.subPrices = this.container.querySelector(_l), this.isPreOrder = this.container.querySelector(Fl);
            let t = null;
            const e = this.container.querySelector(Hl);
            e && (t = e.innerHTML), t ? (this.productJSON = JSON.parse(t), this.linkForm(), this.sellout = new class {
                init() {
                    this.update()
                }
                update() {
                    this.getCurrentState(), this.optionElements.forEach((t => {
                        const e = t.closest(`[${cl}]`);
                        if (!e) return;
                        const s = t.value || t.getAttribute(ul),
                            i = e.getAttribute(cl),
                            o = parseInt(i, 10) - 1,
                            n = t.closest(pl);
                        let r = [...this.selections];
                        r[o] = s;
                        const a = this.productJSON.variants.find((t => {
                            let e = !0;
                            for (let s = 0; s < r.length; s++) t.options[s] !== r[s] && (e = !1);
                            return e
                        }));
                        t.classList.remove(ml, vl), t.parentNode.classList.remove(gl), n && n.classList.remove(ml, vl, gl), void 0 === a ? (t.classList.add(vl), n && n.classList.add(vl)) : a && !1 === a.available && (t.classList.add(ml), n && n.classList.add(ml)), a && a.compare_at_price > a.price && theme.settings.variantOnSale && t.parentNode.classList.add(gl)
                    }))
                }
                getCurrentState() {
                    this.selections = [];
                    const t = this.container.querySelectorAll(hl);
                    t.length && t.forEach((t => {
                        const e = t.value;
                        e && "" !== e && this.selections.push(e)
                    }))
                }
                constructor(t, e) {
                    this.container = t, this.productJSON = e, this.optionElements = this.container.querySelectorAll(dl), this.productJSON && this.optionElements.length && this.init()
                }
            }(this.container, this.productJSON)) : console.error("Missing product JSON"), this.variantOptionImages = this.container.querySelectorAll(Jl), this.variantButtons = this.container.querySelectorAll(jl), this.variantOptionImages.length > 1 && this.optionImagesWidth()
        }
        cartAddEvents() {
            this.buttonATC = this.querySelector(El), this.buttonATC.addEventListener("click", (t => {
                t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:add", {
                    detail: {
                        button: this.buttonATC
                    },
                    bubbles: !1
                })), this.closest(Xl) || (window.a11y.lastElement = this.buttonATC)
            }))
        }
        destroy() {
            this.productForm.destroy()
        }
        linkForm() {
            this.productForm = new class {
                destroy() {
                    this._listeners.removeAll()
                }
                options() {
                    return this._serializeInputValues(this.optionInputs, (function(t) {
                        return t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2], t
                    }))
                }
                variant() {
                    const t = this.options();
                    return t.length ? ur(this.product, t) : this.product.variants[0]
                }
                plan(t) {
                    let e = {
                        allocation: null,
                        group: null,
                        detail: null
                    };
                    const s = this.element.querySelector(`${vr}:checked`);
                    if (!s) return null;
                    const i = s.value,
                        o = i && "" !== i ? i : null;
                    return o && t && (e.allocation = t.selling_plan_allocations.find((function(t) {
                        return t.selling_plan_id.toString() === o.toString()
                    }))), e.allocation && (e.group = this.product.selling_plan_groups.find((function(t) {
                        return t.id.toString() === e.allocation.selling_plan_group_id.toString()
                    }))), e.group && (e.detail = e.group.selling_plans.find((function(t) {
                        return t.id.toString() === o.toString()
                    }))), e && e.allocation && e.detail && e.allocation ? e : null
                }
                properties() {
                    return this._serializeInputValues(this.propertyInputs, (function(t) {
                        return t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2], t
                    }))
                }
                quantity() {
                    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
                }
                getFormState() {
                    const t = this.variant();
                    return {
                        options: this.options(),
                        variant: t,
                        properties: this.properties(),
                        quantity: this.quantity(),
                        plan: this.plan(t)
                    }
                }
                _setIdInputValue(t) {
                    t && t.id ? this.variantElement.value = t.id.toString() : this.variantElement.value = "", this.variantElement.dispatchEvent(new Event("change"))
                }
                _onSubmit(t, e) {
                    e.dataset = this.getFormState(), t.onFormSubmit && t.onFormSubmit(e)
                }
                _onOptionChange(t) {
                    this._setIdInputValue(t.dataset.variant)
                }
                _onFormEvent(t) {
                    return void 0 === t ? Function.prototype.bind() : function(e) {
                        e.dataset = this.getFormState(), this._setIdInputValue(e.dataset.variant), t(e)
                    }.bind(this)
                }
                _initInputs(t, e) {
                    return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(function(t) {
                        return this._listeners.add(t, "change", this._onFormEvent(e)), t
                    }.bind(this))
                }
                _serializeInputValues(t, e) {
                    return t.reduce((function(t, s) {
                        return (s.checked || "radio" !== s.type && "checkbox" !== s.type) && t.push(e({
                            name: s.name,
                            value: s.value
                        })), t
                    }), [])
                }
                _validateProductObject(t) {
                    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                    if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                    return t
                }
                constructor(t, e, s) {
                    this.element = t, this.product = this._validateProductObject(e), this.variantElement = this.element.querySelector(mr), s = s || {}, this._listeners = new hr, this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)), this.optionInputs = this._initInputs(gr, s.onOptionChange), this.planInputs = this._initInputs(vr, s.onPlanChange), this.quantityInputs = this._initInputs(br, s.onQuantityChange), this.propertyInputs = this._initInputs(fr, s.onPropertyChange)
                }
            }(this.container, this.productJSON, {
                onOptionChange: this.onOptionChange.bind(this),
                onPlanChange: this.onPlanChange.bind(this)
            }), this.pushState(this.productForm.getFormState(), !0), this.subsToggleListeners()
        }
        onOptionChange(t) {
            this.pushState(t.dataset), this.updateProductImage(t)
        }
        onPlanChange(t) {
            this.subPrices && this.pushState(t.dataset)
        }
        pushState(t, e = !1) {
            var s;
            this.productState = this.setProductState(t), this.updateAddToCartState(t), this.updateNotificationForm(t), this.updateProductPrices(t), this.updateSaleText(t), this.updateSku(t), this.updateSubscriptionText(t), this.updateRemaining(t), this.updateLegend(t), this.fireHookEvent(t), null === (s = this.sellout) || void 0 === s || s.update(t), this.enableHistoryState && !e && this.updateHistoryState(t)
        }
        updateAddToCartState(t) {
            const e = t.variant;
            let s = theme.strings.addToCart;
            const i = this.container.querySelectorAll(xl),
                o = this.container.querySelectorAll(El),
                n = this.container.querySelectorAll(Ll),
                r = this.container.querySelectorAll(ql);
            if (this.installmentForm && e) {
                const t = this.installmentForm.querySelector(rc);
                t.value = e.id, t.dispatchEvent(new Event("change", {
                    bubbles: !0
                }))
            }
            this.isPreOrder && (s = theme.strings.preOrder), i.length && e && i.forEach((t => {
                t.classList.remove(ac)
            })), null == o || o.forEach((t => {
                t.hasAttribute(Ec) || (e && e.available ? t.disabled = !1 : t.disabled = !0)
            })), null == n || n.forEach((t => {
                let i = s;
                e ? e.available || (i = theme.strings.soldOut) : i = theme.strings.unavailable, t.textContent = i
            })), r.length && r.forEach((t => {
                if (e) {
                    e.available ? t.classList.remove(lc, cc) : (t.classList.add(lc), t.classList.remove(cc));
                    const s = t.querySelector(Tl);
                    s && (s.value = e.id);
                    const i = t.querySelector(`${rc}[form]`);
                    i && (i.value = e.id, i.dispatchEvent(new Event("change")))
                } else t.classList.add(cc), t.classList.remove(lc)
            }))
        }
        updateNotificationForm(t) {
            if (!this.productNotification) return;
            const e = this.productNotification.querySelector(wl),
                s = this.productNotification.querySelector(Sl);
            null != e && (e.textContent = t.variant.title, s.value = t.variant.name)
        }
        updateHistoryState(t) {
            const e = t.variant,
                s = t.plan,
                i = window.location.href;
            if (e && i.includes("/product")) {
                const t = new window.URL(i),
                    o = t.searchParams;
                o.set("variant", e.id), s && s.detail && s.detail.id && this.productState.hasPlan ? o.set("selling_plan", s.detail.id) : o.delete("selling_plan"), t.search = o.toString();
                const n = t.toString();
                window.history.replaceState({
                    path: n
                }, "", n)
            }
        }
        updateRemaining(t) {
            var e;
            const s = t.variant;
            if (null === (e = this.remainingWrapper) || void 0 === e || e.classList.remove(uc, pc, mc, hc), s && this.remainingWrapper && this.remainingJSON) {
                const t = this.remainingJSON[s.id];
                ("out" === t || t < 1) && this.remainingWrapper.classList.add(pc), ("in" === t || t >= this.remainingMaxInt) && this.remainingWrapper.classList.add(uc), ("low" === t || t > 0 && t < this.remainingMaxInt) && (this.remainingWrapper.classList.add(hc), this.remainingCount && (this.remainingCount.innerHTML = t))
            } else !s && this.remainingWrapper && this.remainingWrapper.classList.add(mc)
        }
        optionImagesWidth() {
            if (!this.variantButtons) return;
            let t = 0;
            requestAnimationFrame((() => {
                this.variantOptionImages.forEach((e => {
                    const s = e.clientWidth;
                    s > t && (t = s)
                })), this.variantButtons.forEach((e => {
                    var s;
                    null === (s = e.style) || void 0 === s || s.setProperty("--option-image-width", t + "px")
                }))
            }))
        }
        getBaseUnit(t) {
            return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit
        }
        subsToggleListeners() {
            this.container.querySelectorAll(Nl).forEach((t => {
                t.addEventListener("change", function(t) {
                    const e = t.target.value.toString(),
                        s = this.container.querySelector(`[${Rl}="${e}"]`),
                        i = this.container.querySelectorAll(`[${Rl}]`);
                    if (s) {
                        s.classList.remove(ac);
                        const t = s.querySelector('[name="selling_plan"]');
                        t.checked = !0, t.dispatchEvent(new Event("change"))
                    }
                    i.forEach((t => {
                        if (t !== s) {
                            t.classList.add(ac);
                            t.querySelectorAll('[name="selling_plan"]').forEach((t => {
                                t.checked = !1, t.dispatchEvent(new Event("change"))
                            }))
                        }
                    }))
                }.bind(this))
            }))
        }
        updateSaleText(t) {
            this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(ac)
        }
        isVariantFinalSale(t) {
            var e;
            const s = null === (e = document.querySelector(Vl)) || void 0 === e ? void 0 : e.textContent;
            if (!s) return;
            const i = JSON.parse(s);
            let o = !1;
            return i.forEach((e => {
                Number(e.variant_id) === t.id && (o = "true" === e.metafield_value)
            })), o
        }
        updateSaleTextStandard(t) {
            var e, s, i;
            const o = t.variant,
                n = null === (e = this.priceOffWrap) || void 0 === e ? void 0 : e.querySelector(Cl),
                r = null === (s = this.priceOffWrap) || void 0 === s ? void 0 : s.querySelector(Ql),
                a = null == o ? void 0 : o.compare_at_price,
                l = null == o ? void 0 : o.price;
            if (this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"), r && this.priceOffAmount && a && l && !(a <= l)) {
                const t = Math.round((a - l) / a * 100);
                this.priceOffAmount.innerHTML = `${t}%`, r.classList.remove(ac)
            } else null == r || r.classList.add(ac);
            const c = (null === (i = this.priceOffWrap) || void 0 === i ? void 0 : i.hasAttribute(Lc)) || this.isVariantFinalSale(o);
            n && n.classList.toggle(ac, !c), this.priceOffWrap.classList.remove(ac)
        }
        updateSubscriptionText(t) {
            t.plan && this.planDescription ? (this.planDescription.innerHTML = t.plan.detail.description, this.planDescription.classList.remove(ac)) : this.planDescription && this.planDescription.classList.add(ac)
        }
        updateSaleTextSubscription(t) {
            if (this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"), this.priceOffAmount && this.priceOffWrap) {
                const e = t.plan.detail.price_adjustments[0],
                    s = e.value;
                e && "percentage" === e.value_type ? this.priceOffAmount.innerHTML = `${s}%` : this.priceOffAmount.innerHTML = Ye(s, theme.moneyFormat), this.priceOffWrap.classList.remove(ac)
            }
        }
        updateProductPrices(t) {
            const e = t.variant,
                s = t.plan;
            this.container.querySelectorAll(xl).forEach((t => {
                const i = t.querySelector(kl),
                    o = t.querySelector(Ol),
                    n = t.querySelector(Al);
                let r = "",
                    a = "";
                this.productState.available && (r = e.compare_at_price, a = e.price), this.productState.hasPlan && (a = s.allocation.price), this.productState.planSale && (r = s.allocation.compare_at_price, a = s.allocation.price), i && (this.productState.onSale || this.productState.planSale ? (i.classList.remove(ac), n.classList.remove(ac), o.classList.add(dc)) : (i.classList.add(ac), n.classList.add(ac), o.classList.remove(dc)), i.innerHTML = Ye(r, theme.moneyFormat)), o.innerHTML = 0 === a ? window.theme.strings.free : Ye(a, theme.moneyFormat)
            })), this.hasUnitPricing && this.updateProductUnits(t)
        }
        updateProductUnits(t) {
            const e = t.variant,
                s = t.plan;
            let i = null;
            if (e && e.unit_price && (i = e.unit_price), s && s.allocation && s.allocation.unit_price && (i = s.allocation.unit_price), i) {
                const t = this.getBaseUnit(e),
                    s = Ye(i, theme.moneyFormat);
                this.container.querySelector(Ml).innerHTML = s, this.container.querySelector(Dl).innerHTML = t, this.container.querySelector(Bl).classList.remove(ac)
            } else this.container.querySelector(Bl).classList.add(ac)
        }
        updateSku(t) {
            this.skuWrapper && (this.skuWrapper.innerHTML = `${theme.strings.sku}: ${t.variant.sku}`)
        }
        fireHookEvent(t) {
            const e = t.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", {
                detail: {
                    variant: e
                },
                bubbles: !0
            }))
        }
        setProductState(t) {
            const e = t.variant,
                s = t.plan,
                i = {
                    available: !0,
                    soldOut: !1,
                    onSale: !1,
                    showUnitPrice: !1,
                    requiresPlan: !1,
                    hasPlan: !1,
                    planPerDelivery: !1,
                    planSale: !1
                };
            return !e || e.requires_selling_plan && !s ? i.available = !1 : (e.available || (i.soldOut = !0), e.compare_at_price > e.price && (i.onSale = !0), e.unit_price && (i.showUnitPrice = !0), this.product && this.product.requires_selling_plan && (i.requiresPlan = !0), s && this.subPrices && (i.hasPlan = !0, s.allocation.per_delivery_price !== s.allocation.price && (i.planPerDelivery = !0), e.price > s.allocation.price && (i.planSale = !0))), i
        }
        updateProductImage(t) {
            const e = t.dataset.variant;
            if (e && e.featured_media) {
                const t = this.container.querySelector(`[${wc}="${e.featured_media.id}"]`);
                if (t) {
                    const e = t.getAttribute(Sc),
                        s = v();
                    if (t.dispatchEvent(new CustomEvent("theme:media:select", {
                            bubbles: !0,
                            detail: {
                                id: e
                            }
                        })), s && !this.productImages.hasAttribute(bc) && this.variantImageScroll) {
                        const e = t.getBoundingClientRect().top;
                        document.dispatchEvent(new CustomEvent("theme:tooltip:close", {
                            bubbles: !1,
                            detail: {
                                hideTransition: !1
                            }
                        })), Xo(e)
                    }
                    s || this.productImages.hasAttribute(fc) || this.productMediaList.scrollTo({
                        left: t.offsetLeft
                    })
                }
            }
        }
        updateLegend(t) {
            const e = t.variant;
            if (e) {
                const t = this.container.querySelectorAll(ic);
                t.length && t.forEach((t => {
                    const s = t.closest(oc);
                    if (s) {
                        const i = s.getAttribute(yc),
                            o = parseInt(i, 10) - 1,
                            n = e.options[o];
                        t.innerHTML = n
                    }
                }))
            }
        }
        constructor() {
            super()
        }
    };
    const Cc = "[data-popup-open]",
        qc = "[data-popup-close]",
        Tc = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        xc = "closing";
    let Pc = class {
        popupOpen() {
            this.popup && (this.isAnimating = !0, this.showModal && "function" == typeof this.popup.showModal ? this.popup.showModal() : this.showModal || "function" != typeof this.popup.show ? this.popup.setAttribute("open", "") : this.popup.show(), this.popup.removeAttribute("inert"), this.popup.setAttribute("aria-hidden", !1), this.popup.focus(), this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), N(this.popup).then((() => {
                this.isAnimating = !1, this.enableScrollLock && this.a11y.trapFocus(this.popup);
                const t = this.popup.querySelector("[autofocus]") || this.popup.querySelector(Tc);
                null == t || t.focus()
            })))
        }
        popupClose() {
            if (!this.isAnimating && this.popup && !this.popup.hasAttribute("inert")) {
                if (!this.popup.hasAttribute(xc)) return this.popup.setAttribute(xc, ""), this.isAnimating = !0, void N(this.popup).then((() => {
                    this.isAnimating = !1, this.popupClose()
                }));
                "function" == typeof this.popup.close ? this.popup.close() : (this.popup.removeAttribute("open"), this.popup.setAttribute("aria-hidden", !0)), this.popupCloseActions()
            }
        }
        popupCloseActions() {
            this.popup.hasAttribute("inert") || (this.popup.setAttribute("inert", ""), this.popup.setAttribute("aria-hidden", !0), this.popup.removeAttribute(xc), !Ia() && this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            })), this.popup.dispatchEvent(new CustomEvent("theme:popup:onclose", {
                bubbles: !1
            })), this.enableScrollLock && (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()))
        }
        popupEvents() {
            var t;
            if (!this.popup) return;
            null === (t = this.buttonPopupOpen) || void 0 === t || t.addEventListener("click", (t => {
                t.preventDefault(), this.popupOpen(), window.a11y.lastElement = this.buttonPopupOpen
            }));
            const e = this.popup.querySelectorAll(qc);
            e.length && e.forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault(), this.popupClose()
                }))
            })), this.showModal && this.popup.addEventListener("click", (t => {
                "DIALOG" === t.target.nodeName && "click" === t.type && this.popupClose()
            })), this.popup.addEventListener("keydown", (t => {
                "Escape" === t.code && (t.preventDefault(), this.popupClose())
            })), this.popup.addEventListener("close", (() => this.popupCloseActions()))
        }
        constructor(t, e, s = !0, i = !0) {
            var o;
            this.popup = t, this.holder = e, this.a11y = $, this.isAnimating = !1, this.showModal = s, this.enableScrollLock = i, this.buttonPopupOpen = null === (o = this.holder) || void 0 === o ? void 0 : o.querySelector(Cc), this.popupEvents()
        }
    };
    const Ic = "dialog";
    let Hc = class extends HTMLElement {
            connectedCallback() {
                new Pc(this.querySelector(Ic), this, !0, !0)
            }
            constructor() {
                super()
            }
        },
        Oc = class extends se {
            loadContent() {
                super.loadContent(), Shopify.loadFeatures([{
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: this.setupModelViewerUI.bind(this)
                }])
            }
            setupModelViewerUI(t) {
                t || (this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer")))
            }
            constructor() {
                super()
            }
        };
    window.ProductModel = {
        loadShopifyXR() {
            Shopify.loadFeatures([{
                name: "shopify-xr",
                version: "1.0",
                onLoad: this.setupShopifyXR.bind(this)
            }])
        },
        setupShopifyXR(t) {
            t || (window.ShopifyXR ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t => {
                window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove()
            })), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", (() => this.setupShopifyXR())))
        }
    }, window.addEventListener("DOMContentLoaded", (() => {
        window.ProductModel && window.ProductModel.loadShopifyXR()
    }));
    const Mc = "[data-add-to-cart]",
        Dc = "[data-product-json]",
        Bc = "[data-product-form]",
        Fc = "#cart-bar",
        _c = "[data-popup-open]",
        $c = ".product__submit__add",
        Nc = "[data-form-wrapper]",
        Rc = "[data-product-variants]",
        Wc = "[data-slider]",
        Uc = "is-visible",
        zc = "is-loading",
        Vc = "data-cart-bar-enabled",
        jc = "data-add-to-cart-bar",
        Jc = "data-cart-bar-scroll",
        Xc = "data-cart-bar-product-notification",
        Gc = "data-section-id",
        Qc = "data-slider-index",
        Yc = {};
    const Kc = {
        onLoad() {
            Yc[this.id] = new class {
                initCartBar() {
                    this.cartBarBtns = this.cartBar.querySelectorAll($c), this.cartBarBtns.length > 0 && this.cartBarBtns.forEach((t => {
                        t.addEventListener("click", (t => {
                            if (t.preventDefault(), t.currentTarget.hasAttribute(jc)) this.cartBarEnabled && (t.currentTarget.classList.add(zc), t.currentTarget.setAttribute("disabled", "disabled")), this.form.querySelector(Mc).dispatchEvent(new Event("click", {
                                bubbles: !0
                            }));
                            else if (t.currentTarget.hasAttribute(Jc)) this.scrollToTop();
                            else if (t.currentTarget.hasAttribute(Xc)) {
                                var e;
                                null === (e = this.form.querySelector(_c)) || void 0 === e || e.dispatchEvent(new Event("click"))
                            }
                        })), t.hasAttribute(jc) && document.addEventListener("theme:product:add-error", this.scrollToTop)
                    })), this.setCartBarHeight()
                }
                scrollToTop() {
                    const t = this.container.querySelector(Rc),
                        e = (v() ? this.container : t || this.form).getBoundingClientRect().top;
                    Xo(v() ? e : e - 10)
                }
                toggleCartBarOnScroll() {
                    const t = window.scrollY,
                        e = theme.variables.productPageSticky && this.formWrapper ? this.formWrapper : this.form;
                    if (e && this.cartBar) {
                        const s = t > e.offsetTop + e.offsetHeight;
                        this.cartBar.classList.toggle(Uc, s)
                    }
                }
                setCartBarHeight() {
                    const t = this.cartBar.offsetHeight;
                    document.documentElement.style.setProperty("--cart-bar-height", `${t}px`)
                }
                onUnload() {
                    document.removeEventListener("theme:product:add-error", this.scrollToTop), this.cartBarEnabled && (document.removeEventListener("theme:scroll", this.toggleCartBarOnScroll), document.removeEventListener("theme:resize", this.setCartBarHeight))
                }
                onBlockSelect(t) {
                    const e = t.srcElement.closest(Wc);
                    if (e && this.slider.length) {
                        const s = e.hasAttribute(Qc) ? e.getAttribute(Qc) : 0;
                        if (!this.slider[s]) return;
                        this.slider[s].onBlockSelect(t)
                    }
                }
                onBlockDeselect(t) {
                    const e = t.srcElement.closest(Wc);
                    if (e && this.slider.length) {
                        const s = e.hasAttribute(Qc) ? e.getAttribute(Qc) : 0;
                        if (!this.slider[s]) return;
                        this.slider[s].onBlockDeselect(t)
                    }
                }
                constructor(t) {
                    this.section = t, this.container = t.container, this.id = this.container.getAttribute(Gc), this.sliders = this.container.querySelectorAll(Wc), this.slider = [], this.formWrapper = this.container.querySelector(Nc), this.cartBarEnabled = this.container.hasAttribute(Vc), this.cartBar = this.container.querySelector(Fc), this.setCartBarHeight = this.setCartBarHeight.bind(this), this.scrollToTop = this.scrollToTop.bind(this), this.toggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this), this.unlockTimer = 0, this.accessibility = $;
                    const e = this.container.querySelector(Dc);
                    if (e && !e.innerHTML || !e) return;
                    const s = JSON.parse(e.innerHTML).handle;
                    let i = {};
                    s && (i = {
                        handle: s
                    }), Shopify.Products.recordRecentlyViewed(i), this.form = this.container.querySelector(Bc), this.sliders.length && this.sliders.forEach(((t, e) => {
                        t.setAttribute(Qc, e), this.slider.push(new jo(this.container, t))
                    })), this.cartBarEnabled && (this.initCartBar(), this.setCartBarHeight(), document.addEventListener("theme:scroll", this.toggleCartBarOnScroll), document.addEventListener("theme:resize", this.setCartBarHeight))
                }
            }(this)
        },
        onUnload(t) {
            Yc[this.id].onUnload(t)
        },
        onBlockSelect(t) {
            Yc[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            Yc[this.id].onBlockDeselect(t)
        }
    };
    no("product", [Kc, wo, Pa, ll]), customElements.get("product-form") || customElements.define("product-form", Ac), customElements.get("product-modal") || customElements.define("product-modal", Hc), customElements.get("product-model") || customElements.define("product-model", Oc), customElements.get("product-siblings") || customElements.define("product-siblings", na), customElements.get("radio-swatch") || customElements.define("radio-swatch", Vr);
    const Zc = "[data-api-related-template]",
        td = "[data-related-section]",
        ed = "[data-grid-item]",
        sd = "[data-recent-wrapper]",
        id = "[data-recently-viewed-wrapper]",
        od = ".product-item",
        nd = "grid-slider",
        rd = "data-limit",
        ad = "data-minimum",
        ld = "data-product-id",
        cd = "is-hidden",
        dd = "grid--mobile-slider",
        hd = {};
    const ud = {
        onLoad() {
            hd[this.id] = new class {
                init() {
                    this.loadRelatedProducts(), this.loadRecentlyViewedProducts()
                }
                loadRelatedProducts() {
                    const t = this.container.querySelector(td);
                    if (!t) return;
                    const e = t.getAttribute(ld),
                        s = t.getAttribute(rd),
                        i = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${s}&product_id=${e}&intent=related`;
                    fetch(i).then((t => t.text())).then((e => this.handleRelatedProductsResponse(e, t))).catch((() => this.hideSection(t)))
                }
                handleRelatedProductsResponse(t, e) {
                    const s = document.createElement("div");
                    s.innerHTML = (new DOMParser).parseFromString(t, "text/html").querySelector(Zc).innerHTML;
                    const i = s.querySelectorAll(ed).length;
                    i > 0 ? (e.innerHTML = s.innerHTML, this.relatedItems = i, 0 === parseInt(e.style.getPropertyValue("--COLUMNS-MOBILE")) && e.querySelector(ed).parentElement.classList.add(dd)) : this.hideSection(e), this.updateVisibility()
                }
                loadRecentlyViewedProducts() {
                    const t = this.container.querySelector(sd),
                        e = parseInt(t.getAttribute(rd)) || 4,
                        s = parseInt(t.getAttribute(ad)) || 4;
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: e,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        target: "api-product-grid-item",
                        onComplete: (e, i) => this.handleRecentlyViewedResponse(e, i, t, s)
                    })
                }
                handleRecentlyViewedResponse(t, e, s, i) {
                    const o = e.container;
                    if (!o) return;
                    const n = o.querySelector(id),
                        r = t.querySelectorAll(od),
                        a = s.querySelector(nd),
                        l = !n && r.length > 0,
                        c = n && r.length >= i;
                    (l || c) && (c && n.classList.remove(cd), s.classList.remove(cd), s.dispatchEvent(new CustomEvent("theme:tab:check", {
                        bubbles: !0
                    })), a && a.dispatchEvent(new CustomEvent("theme:grid-slider:init", {
                        bubbles: !0
                    }))), this.updateVisibility()
                }
                hideSection(t) {
                    t.dispatchEvent(new CustomEvent("theme:tab:hide", {
                        bubbles: !0
                    }))
                }
                updateVisibility() {
                    const t = Shopify.Products.getConfig().howManyToShow < 1 && this.relatedItems < 1;
                    this.container.classList.toggle(cd, t)
                }
                constructor(t) {
                    this.section = t, this.sectionId = t.id, this.container = t.container, this.relatedItems = 0, this.init()
                }
            }(this)
        }
    };
    no("related", [ud, Pa]), no("reviews", [Jo]);
    const pd = {},
        md = "[data-slider-logos]",
        vd = "[data-slider-text]",
        gd = "[data-slide]",
        bd = "is-selected",
        fd = "is-initialized",
        yd = "flickity-enabled",
        wd = "data-slide",
        Sd = "data-slide-index";
    no("logos", [{
        onLoad() {
            pd[this.id] = new class {
                getSlidesWidth() {
                    return 200 * this.logoSlides.length
                }
                initSlideshowText() {
                    this.slideshowText && (this.flkty = new s(this.slideshowText, {
                        fade: !0,
                        autoPlay: !1,
                        prevNextButtons: !1,
                        cellAlign: "left",
                        contain: !0,
                        pageDots: !1,
                        wrapAround: !1,
                        selectedAttraction: .2,
                        friction: .6,
                        draggable: !1,
                        accessibility: !1,
                        on: {
                            ready: () => this.sliderAccessibility(),
                            change: () => this.sliderAccessibility()
                        }
                    }))
                }
                sliderAccessibility() {
                    const t = this.slideshowText.querySelectorAll(`${gd} a, ${gd} button`);
                    t.length && t.forEach((t => {
                        const e = t.closest(gd);
                        if (e) {
                            const s = e.classList.contains(bd) ? 0 : -1;
                            t.setAttribute("tabindex", s)
                        }
                    }))
                }
                initSlideshowNav() {
                    this.slideshowNav && (this.logoSlides.length && this.logoSlides.forEach((t => {
                        t.addEventListener("click", (() => {
                            const e = parseInt(t.getAttribute(Sd)),
                                s = this.slideshowNav.classList.contains(yd);
                            if (this.flkty && this.flkty.select(e), s) this.flktyNav.select(e), this.slideshowNav.classList.contains(bd) || this.flktyNav.playPlayer();
                            else {
                                const e = this.slideshowNav.querySelector(`.${bd}`);
                                e && e.classList.remove(bd), t.classList.add(bd)
                            }
                        }))
                    })), this.setSlideshowNavState(), document.addEventListener("theme:resize", this.setSlideshowNavStateOnResize))
                }
                setSlideshowNavState() {
                    const t = this.slideshowNav.classList.contains(yd);
                    if (this.logoSlidesWidth > p()) {
                        if (!t) {
                            this.slideshowNav.classList.add(fd);
                            const t = this.slideshowNav.querySelector(`.${bd}`);
                            t && t.classList.remove(bd), this.logoSlides[0].classList.add(bd), this.flktyNav || (this.flktyNav = new e(this.slideshowNav, {
                                autoPlay: 4e3,
                                prevNextButtons: !1,
                                contain: !1,
                                pageDots: !1,
                                wrapAround: !0,
                                watchCSS: !0,
                                selectedAttraction: .05,
                                friction: .8,
                                initialIndex: 0
                            }), this.flktyNav.on("deactivate", (() => {
                                this.slideshowNav.querySelector(gd).classList.add(bd), this.flkty && this.flkty.select(0)
                            })), this.flkty && (this.flkty.select(0), this.flktyNav.on("change", (t => this.flkty.select(t)))))
                        }
                    } else t && this.slideshowNav.classList.remove(fd)
                }
                onBlockSelect(t) {
                    if (!this.slideshowNav) return;
                    const e = this.slideshowNav.querySelector(`[${wd}="${t.detail.blockId}"]`),
                        s = parseInt(e.getAttribute(Sd));
                    this.slideshowNav.classList.contains(yd) ? (this.flktyNav.select(s), this.flktyNav.stopPlayer(), this.slideshowNav.classList.add(bd)) : e.dispatchEvent(new Event("click"))
                }
                onBlockDeselect() {
                    this.slideshowNav && this.slideshowNav.classList.contains(yd) && (this.flktyNav.playPlayer(), this.slideshowNav.classList.remove(bd))
                }
                onUnload() {
                    document.removeEventListener("theme:resize", this.setSlideshowNavStateOnResize)
                }
                constructor(t) {
                    this.container = t.container, this.slideshowNav = this.container.querySelector(md), this.slideshowText = this.container.querySelector(vd), this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState(), this.flkty = null, this.flktyNav = null, this.logoSlides = this.slideshowNav.querySelectorAll(gd), this.logoSlidesWidth = this.getSlidesWidth(), this.initSlideshowText(), this.initSlideshowNav()
                }
            }(this)
        },
        onUnload(t) {
            pd[this.id].onUnload(t)
        },
        onBlockSelect(t) {
            pd[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            pd[this.id].onBlockDeselect(t)
        }
    }]), no("slideshow", [Jo]), no("custom-content", [Jo, nn]);
    const Ed = "[data-large-promo]",
        Ld = "[data-large-promo-inner]",
        kd = "cart-bar",
        Ad = "[data-newsletter]",
        Cd = "[data-newsletter-holder]",
        qd = "[data-newsletter-heading]",
        Td = "[data-newsletter-field]",
        xd = "[data-promo-text]",
        Pd = "[data-newsletter-form]",
        Id = "data-popup-delay",
        Hd = "data-cookie-name",
        Od = "data-target-referrer",
        Md = "hidden",
        Dd = "has-value",
        Bd = "cart-bar-visible",
        Fd = "is-visible",
        _d = "has-success",
        $d = "selected",
        Nd = "has-block-selected",
        Rd = "mobile",
        Wd = "desktop",
        Ud = "bottom";
    let zd = {},
        Vd = class {
            always() {
                this.popupActions.popupOpen()
            }
            delayed(t = 10) {
                setTimeout((() => {
                    this.popupActions.popupOpen()
                }), 1e3 * t)
            }
            idle() {
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    s = ["load", "resize", "scroll"],
                    i = () => {
                        t = setTimeout((() => {
                            t = 0, this.popupActions.popupOpen()
                        }), 6e4), e.forEach((t => {
                            document.addEventListener(t, o)
                        })), s.forEach((t => {
                            window.addEventListener(t, o)
                        }))
                    },
                    o = () => {
                        t && clearTimeout(t), e.forEach((t => {
                            document.removeEventListener(t, o)
                        })), s.forEach((t => {
                            window.removeEventListener(t, o)
                        })), i()
                    };
                i()
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent)
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight && (this.popupActions.popupOpen(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent))
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent)
            }
            constructor(t, e, s) {
                if (this.element = e, this.delay = t.getAttribute(Id), this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true"), this.popupActions = s, this.showPopupOnScrollEvent = () => this.showPopupOnScroll(), ("always" === this.delay || this.isSubmitted) && this.always(), this.delay && this.delay.includes("delayed") && !this.isSubmitted) {
                    const t = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(t)
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle()
            }
        },
        jd = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(Od)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el)
            }
            constructor(t) {
                if (this.el = t, this.locationPath = location.href, !this.el.hasAttribute(Od)) return !1;
                this.init()
            }
        };
    const Jd = {
        onLoad() {
            zd[this.id] = [];
            this.container.querySelectorAll(Ed).forEach((t => {
                zd[this.id].push(new class {
                    init() {
                        const t = !1 !== this.cookie.read(),
                            e = this.popup.classList.contains(Rd),
                            s = this.popup.classList.contains(Wd),
                            i = !v();
                        let o = !0;
                        if ((e && !i || s && i) && (o = !1), !o) return this.a11y.removeTrapFocus(), void document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        }));
                        t && !window.Shopify.designMode || (window.Shopify.designMode || window.location.pathname.endsWith("/challenge") || new Vd(this.popup, this.modal, this.popupActions), this.form && this.form.classList.contains(_d) && this.checkForSuccess(), this.modal.addEventListener("theme:popup:onclose", (() => this.cookie.write())))
                    }
                    checkForSuccess() {
                        this.popupActions.popupOpen(), this.cookie.write()
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupOpen(), this.popup.classList.add($d), this.popup.parentNode.classList.add(Nd))
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupClose(), this.popup.classList.remove($d), this.popup.parentNode.classList.remove(Nd))
                    }
                    constructor(t) {
                        this.popup = t, this.modal = this.popup.querySelector(Ld), this.form = this.popup.querySelector(Pd), this.cookie = new Go(this.popup.getAttribute(Hd), "user_has_closed"), this.isTargeted = new jd(this.popup), this.popupActions = new Pc(this.modal, this.modal, !0, !0), this.a11y = $, this.init()
                    }
                }(t))
            }));
            this.container.querySelectorAll(Ad).forEach((t => {
                zd[this.id].push(new class {
                    init() {
                        const t = !1 !== this.cookie.read(),
                            e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                            s = [...this.holder.classList].toString().includes(Ud);
                        e && (this.delay = 0), t && !window.Shopify.designMode || (this.show(), this.form.classList.contains(_d) && this.checkForSuccess()), s && this.observeCartBar()
                    }
                    show() {
                        window.location.pathname.endsWith("/challenge") || (window.Shopify.designMode ? this.popupActions.popupOpen() : new Vd(this.popup, this.holder, this.popupActions)), this.showForm(), this.inputField(), this.holder.addEventListener("theme:popup:onclose", (() => this.cookie.write()))
                    }
                    checkForSuccess() {
                        this.popupActions.popupOpen(), this.cookie.write()
                    }
                    observeCartBar() {
                        if (this.cartBar = document.getElementById(kd), !this.cartBar) return;
                        let t = this.cartBar.classList.contains(Fd);
                        document.body.classList.toggle(Bd, t), this.observer = new MutationObserver((e => {
                            for (const s of e) "attributes" === s.type && (t = s.target.classList.contains(Fd), document.body.classList.toggle(Bd, t))
                        })), this.observer.observe(this.cartBar, {
                            attributes: !0,
                            childList: !1,
                            subtree: !1
                        })
                    }
                    showForm() {
                        this.heading.addEventListener("click", (t => {
                            t.preventDefault(), this.heading.classList.add(Md), this.form.classList.remove(Md), this.newsletterField.focus()
                        })), this.heading.addEventListener("keyup", (t => {
                            "Enter" === t.code && this.heading.dispatchEvent(new Event("click"))
                        }))
                    }
                    inputField() {
                        const t = () => {
                            this.resetClassTimer && clearTimeout(this.resetClassTimer), "" !== this.newsletterField.value && this.holder.classList.add(Dd)
                        };
                        this.newsletterField.addEventListener("input", t), this.newsletterField.addEventListener("focus", t), this.newsletterField.addEventListener("focusout", (() => {
                            this.resetClassTimer && clearTimeout(this.resetClassTimer), this.resetClassTimer = setTimeout((() => {
                                this.holder.classList.remove(Dd)
                            }), 2e3)
                        }))
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupOpen(), this.popup.classList.add($d), this.popup.parentNode.classList.add(Nd))
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupClose(), this.popup.classList.remove($d), this.popup.parentNode.classList.remove(Nd))
                    }
                    onUnload() {
                        this.observer && this.observer.disconnect()
                    }
                    constructor(t) {
                        this.popup = t, this.holder = this.popup.querySelector(Cd), this.heading = this.popup.querySelector(qd), this.newsletterField = this.popup.querySelector(Td), this.cookie = new Go(this.popup.getAttribute(Hd), "newsletter_is_closed"), this.form = this.popup.querySelector(Pd), this.isTargeted = new jd(this.popup), this.popupActions = new Pc(this.holder, this.holder, !1, !1), this.resetClassTimer = 0, this.init()
                    }
                }(t))
            }));
            this.container.querySelectorAll(xd).forEach((t => {
                zd[this.id].push(new class {
                    init() {
                        !1 !== this.cookie.read() && !window.Shopify.designMode || (window.Shopify.designMode ? this.popupActions.popupOpen() : new Vd(this.popup, this.popup, this.popupActions), this.popup.addEventListener("theme:popup:onclose", (() => this.cookie.write())))
                    }
                    onSelect() {
                        this.popupActions.popupOpen(), this.popup.classList.add($d), this.popup.parentNode.classList.add(Nd)
                    }
                    onDeselect() {
                        this.popupActions.popupClose(), this.popup.classList.remove($d), this.popup.parentNode.classList.remove(Nd)
                    }
                    constructor(t) {
                        this.popup = t, this.cookie = new Go(this.popup.getAttribute(Hd), "user_has_closed"), this.isTargeted = new jd(this.popup), this.popupActions = new Pc(this.popup, this.popup, !1, !1), this.init()
                    }
                }(t))
            }))
        },
        onBlockSelect(t) {
            zd[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            zd[this.id].forEach((e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            }))
        },
        onSelect() {
            zd[this.id].forEach((t => {
                "function" == typeof t.onSelect && t.onSelect()
            }))
        },
        onDeselect() {
            zd[this.id].forEach((t => {
                "function" == typeof t.onDeselect && t.onDeselect()
            }))
        },
        onUnload() {
            zd[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        }
    };
    no("popups", [Jd, nn]);
    const Xd = "[data-password-modal]",
        Gd = "#login_form .errors";
    no("password-template", {
        onLoad() {
            new class {
                constructor(t) {
                    this.container = t.container, this.popupActions = new Pc(this.container.querySelector(Xd), this.container, !0, !0), this.container.querySelector(Gd) && this.popupActions.popupOpen()
                }
            }(this)
        }
    }), no("list-collections", [Jo]), no("columns", [Jo]), no("newsletter", nn);
    const Qd = "[data-scroll-to]",
        Yd = "[data-tooltip]",
        Kd = "[data-collapsible-trigger]",
        Zd = "open",
        th = "data-scroll-to",
        eh = "data-tooltip-stop-mouseenter",
        sh = {};
    const ih = {
            onLoad() {
                sh[this.id] = new class {
                    init() {
                        this.scrollToButtons.forEach((t => {
                            t.addEventListener("click", (() => {
                                const e = this.container.querySelector(t.getAttribute(th));
                                e && "A" !== t.tagName && this.scrollToElement(e)
                            }))
                        }))
                    }
                    scrollToElement(t) {
                        Xo(t.getBoundingClientRect().top + 1);
                        const e = t.nextElementSibling.matches("details") ? t.nextElementSibling : null;
                        if (e) {
                            const t = null == e ? void 0 : e.querySelector(Kd);
                            e.hasAttribute(Zd) || null == t || t.dispatchEvent(new Event("click"))
                        }
                        const s = document.querySelectorAll(`${Yd}:not([${eh}])`);
                        s.length && s.forEach((t => {
                            t.setAttribute(eh, ""), setTimeout((() => {
                                t.removeAttribute(eh)
                            }), 1e3)
                        }))
                    }
                    constructor(t) {
                        this.section = t, this.container = t.container, this.scrollToButtons = this.container.querySelectorAll(Qd), this.scrollToButtons.length && this.init()
                    }
                }(this)
            }
        },
        oh = "[data-scroll-spy]",
        nh = "is-selected",
        rh = "data-scroll-spy",
        ah = "data-scroll-spy-mobile",
        lh = "data-scroll-spy-desktop",
        ch = "data-scroll-trigger-point",
        dh = {};
    const hh = {
        onLoad() {
            var t;
            dh[this.id] = [], null === (t = this.container.querySelectorAll(oh)) || void 0 === t || t.forEach((t => {
                const e = this.container.querySelector(t.getAttribute(rh));
                dh[this.id].push(new class {
                    init() {
                        this.toggleScrollObserver(), document.addEventListener("theme:resize:width", this.toggleScrollObserver)
                    }
                    toggleScrollObserver() {
                        this.isEligible() ? this.initialized || (document.addEventListener("theme:scroll", this.scrollCallback), this.initialized = !0) : (document.removeEventListener("theme:scroll", this.scrollCallback), this.initialized = !1)
                    }
                    isEligible() {
                        const t = v();
                        return !t && this.anchor.hasAttribute(ah) || t && this.anchor.hasAttribute(lh) || !this.anchor.hasAttribute(lh) && !this.anchor.hasAttribute(ah)
                    }
                    onScroll() {
                        this.top = this.elementToSpy.getBoundingClientRect().top;
                        const t = Math.round(window.innerHeight),
                            e = Math.round(window.scrollY),
                            s = e + t,
                            i = Math.round(this.top + e),
                            o = this.elementToSpy.offsetHeight;
                        i < s && !(i + o < e) && this.triggerPointReached() && (this.anchorSiblings.forEach((t => {
                            t.matches(this.anchorSelector) || t.classList.remove(nh)
                        })), this.anchor.classList.add(nh))
                    }
                    triggerPointReached() {
                        let t = !1;
                        switch (this.triggerPoint) {
                            case "top":
                            default:
                                t = this.top <= 0;
                                break;
                            case "middle":
                                t = this.top <= window.innerHeight / 2;
                                break;
                            case "bottom":
                                t = this.top <= window.innerHeight
                        }
                        return t
                    }
                    onUnload() {
                        document.removeEventListener("theme:resize:width", this.toggleScrollObserver), document.removeEventListener("theme:scroll", this.scrollCallback)
                    }
                    constructor(t, e) {
                        this.container = t, this.elementToSpy = e, this.anchorSelector = `[${rh}="#${this.elementToSpy.id}"]`, this.anchor = this.container.querySelector(this.anchorSelector), this.anchorSiblings = this.container.querySelectorAll(`[${rh}]`), this.initialized = !1, this.anchor && (this.triggerPoint = this.anchor.getAttribute(ch), this.scrollCallback = () => this.onScroll(), this.toggleScrollObserver = this.toggleScrollObserver.bind(this), this.init())
                    }
                }(this.container, e))
            }))
        },
        onUnload() {
            dh[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        }
    };
    no("sidebar", [ih, hh]);
    const uh = "[data-hover-target]",
        ph = "[data-collection-image]",
        mh = "data-hover-target",
        vh = "is-visible",
        gh = "is-selected";
    let bh = {};
    no("collections-hover", [{
        onLoad() {
            bh[this.id] = new class {
                init() {
                    this.buttons.length && this.buttons.forEach((t => {
                        t.addEventListener("mouseenter", (t => {
                            const e = t.currentTarget.getAttribute(mh);
                            this.updateState(e)
                        }))
                    }))
                }
                updateState(t) {
                    const e = this.container.querySelector(`[${mh}="${t}"]`),
                        s = this.container.querySelector(`#${t}:not(.${vh})`),
                        i = this.container.querySelector(`${uh}.${gh}`),
                        o = this.container.querySelector(`${ph}.${vh}`);
                    s && v() && (null == o || o.classList.remove(vh), null == i || i.classList.remove(gh), s.classList.add(vh), e.classList.add(gh))
                }
                onBlockSelect(t) {
                    this.updateState(t.target.id)
                }
                constructor(t) {
                    this.container = t.container, this.buttons = this.container.querySelectorAll(uh), this.init()
                }
            }(this)
        },
        onBlockSelect(t) {
            bh[this.id].onBlockSelect(t)
        }
    }, hh]);
    const fh = "[data-featured-image]",
        yh = "[data-featured-aside]",
        wh = "[data-featured-content]",
        Sh = "[data-featured-wrapper]",
        Eh = "data-horizontal-scroll",
        Lh = "data-horizontal-scroll-reversed",
        kh = {};
    no("featured-product", [{
        onLoad() {
            kh[this.id] = new class {
                init() {
                    this.horizontalScroll && this.imagesHolder && (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent), document.addEventListener("theme:scroll", this.scrollEvent)), this.wrapper && this.contentHolder && this.images.length && (this.calculateHeight(), document.addEventListener("theme:resize:width", this.calculateHeightEvent))
                }
                scrollEvents() {
                    this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent))
                }
                removeAnimationFrame() {
                    this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), this.requestAnimationSticky = null)
                }
                calculateHorizontalPosition() {
                    let t = window.scrollY + this.headerHeight;
                    const e = t + window.innerHeight,
                        s = this.imagesHolder.offsetTop,
                        i = this.imagesHolder.offsetHeight,
                        o = s + i + this.headerHeight,
                        n = i - (window.innerHeight - this.headerHeight),
                        r = this.horizontalScrollReversed ? 1 : -1;
                    let a = 0;
                    a = t >= s && e <= o ? (t - s) / n * 100 : t < s ? 0 : 100, a *= this.images.length - 1, this.container.style.setProperty("--translateX", a * r + "%"), this.lastPercent !== a ? this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent) : this.requestAnimationSticky && this.removeAnimationFrame(), this.lastPercent = a
                }
                calculateHeight() {
                    let {
                        stickyHeaderHeight: t
                    } = r();
                    this.container.style.removeProperty("--min-height"), this.container.style.setProperty("--min-height", `${this.wrapper.offsetHeight+this.contentHolder.offsetHeight}px`), this.headerHeight = t
                }
                onUnload() {
                    this.horizontalScroll && this.imagesHolder && document.removeEventListener("theme:scroll", this.calculateHorizontalPositionEvent), this.wrapper && this.contentHolder && this.images.length && document.removeEventListener("theme:resize:width", this.calculateHeightEvent)
                }
                constructor(t) {
                    this.container = t.container, this.horizontalScroll = this.container.hasAttribute(Eh), this.horizontalScrollReversed = this.container.hasAttribute(Lh), this.images = this.container.querySelectorAll(fh), this.imagesHolder = this.container.querySelector(yh), this.contentHolder = this.container.querySelector(wh), this.wrapper = this.container.querySelector(Sh), this.requestAnimationSticky = null, this.lastPercent = 0, this.scrollEvent = () => this.scrollEvents(), this.calculateHorizontalPositionEvent = () => this.calculateHorizontalPosition(), this.calculateHeightEvent = () => this.calculateHeight(), this.init()
                }
            }(this)
        },
        onUnload(t) {
            kh[this.id].onUnload(t)
        }
    }]);
    const Ah = {};

    function Ch(t = {}) {
        if (t.type || (t.type = "json"), t.url) return Ah[t.url] ? Ah[t.url] : function(t, e) {
            const s = new Promise(((s, i) => {
                "text" === e ? fetch(t).then((t => t.text())).then((t => {
                    s(t)
                })).catch((t => {
                    i(t)
                })) : function(t, e, s) {
                    let i = document.getElementsByTagName("head")[0],
                        o = !1,
                        n = document.createElement("script");
                    n.src = t, n.onload = n.onreadystatechange = function() {
                        o || this.readyState && "loaded" != this.readyState && "complete" != this.readyState ? s() : (o = !0, e())
                    }, i.appendChild(n)
                }(t, (function() {
                    s()
                }), (function() {
                    i()
                }))
            }));
            return Ah[t] = s, s
        }(t.url, t.type);
        if (t.json) return Ah[t.json] ? Promise.resolve(Ah[t.json]) : window.fetch(t.json).then((t => t.json())).then((e => (Ah[t.json] = e, e)));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return Ah[e] ? Ah[e] : function(t) {
                const e = "".concat(t.name, t.version),
                    s = new Promise(((e, s) => {
                        try {
                            window.Shopify.loadFeatures([{
                                name: t.name,
                                version: t.version,
                                onLoad: t => {
                                    ! function(t, e, s) {
                                        s ? e(s) : t()
                                    }(e, s, t)
                                }
                            }])
                        } catch (t) {
                            s(t)
                        }
                    }));
                return Ah[e] = s, s
            }(t)
        }
        return Promise.reject()
    }
    document.addEventListener("DOMContentLoaded", (function() {
        ro("*");
        const t = document.querySelector("[data-scroll-top-button]");
        t && (t.addEventListener("click", (() => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            })
        })), document.addEventListener("theme:scroll", (() => {
            t.classList.toggle("is-visible", window.scrollY > window.innerHeight)
        }))), window.self !== window.top && document.querySelector("html").classList.add("iframe"), "scrollBehavior" in document.documentElement.style || Ch({
            url: window.theme.assets.smoothscroll
        })
    })), window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies"))
}(themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.FlickityFade);